import React, { useState, useEffect, useContext, useMemo } from 'react';
import { AuthContext } from '../../../contexts/AuthContext';
import Header from '../../../layout/Header/Header';
import {
  Button,
  Row,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Spinner,
  Input,
  Label,
  ButtonGroup,
  Col,
  Badge
} from 'reactstrap';
import SweetAlert from 'sweetalert2-react';
import Swal from 'sweetalert2';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import autoTable from 'jspdf-autotable';
import ExportJsonExcel from 'js-export-excel';
import { encode } from 'base64-arraybuffer';
import axios from 'axios';
import { TableHeader, Pagination, Search } from '../../../DataTable';
import useFullPageLoader from '../../../hooks/useFullPageLoader';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import i18next from 'i18next';
import { v4 as uuidv4 } from 'uuid';
import EtaUpdate from '../../EtaUpdate';
import Baja from '../../Baja';
import * as XLSX from "xlsx";
// import { MapContainer, TileLayer, Marker, Polyline } from 'react-leaflet';
// import L from 'leaflet';

// delete L.Icon.Default.prototype._getIconUrl;
// L.Icon.Default.mergeOptions({
//   iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
//   iconUrl: require('leaflet/dist/images/marker-icon.png'),
//   shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
// });

function ListadoContenedores() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_ARTICULOS = process.env.REACT_APP_URL_ARTICULOS;
  const URL_CONTENEDORES = process.env.REACT_APP_URL_CONTENEDORES;
  const URL_ARTICULOS_CONTENEDOR = process.env.REACT_APP_URL_ARTICULOS_CONTENEDOR;
  const URL_CLIENTES = process.env.REACT_APP_URL_CLIENTES;
  const URL_PROVEEDORES = process.env.REACT_APP_URL_PROVEEDORES;
  const URL_SEND_MAIL_ATT = process.env.REACT_APP_URL_SEND_MAIL_ATT;
  const URL_GASTOS_CONTENEDOR = process.env.REACT_APP_URL_GASTOS_CONTENEDOR;
  const URL_CARGOS_CONTENEDOR = process.env.REACT_APP_URL_CARGOS_CONTENEDOR;
  const URL_CONCEPTOS_GASTOS = process.env.REACT_APP_URL_CONCEPTOS_GASTOS;
  const URL_TERMINALES = process.env.REACT_APP_URL_TERMINALES;
  const URL_PROGRAMAS = process.env.REACT_APP_URL_PROGRAMAS;
  const URL_PATENTES = process.env.REACT_APP_URL_PATENTES;
  const URL_UPMEDIA_PACKING = process.env.REACT_APP_URL_UPMEDIA_PACKING;
  const URL_UPMEDIA_BL = process.env.REACT_APP_URL_UPMEDIA_BL;
  const URL_UPMEDIA_INVOICE = process.env.REACT_APP_URL_UPMEDIA_INVOICE;
  const URL_UPMEDIA_FICHA_TECNICA = process.env.REACT_APP_URL_UPMEDIA_FICHA_TECNICA;
  const URL_UPMEDIA_CARGOS_LOCALES = process.env.REACT_APP_URL_UPMEDIA_CARGOS_LOCALES;
  const URL_UPMEDIA_DODA = process.env.REACT_APP_URL_UPMEDIA_DODA;
  const URL_UPMEDIA_BOLETA = process.env.REACT_APP_URL_UPMEDIA_BOLETA;
  const URL_UPMEDIA_PREALTA = process.env.REACT_APP_URL_UPMEDIA_PREALTA;
  const URL_UPMEDIA_EIR = process.env.REACT_APP_URL_UPMEDIA_EIR;
  const URL_UPMEDIA_VALIDACION = process.env.REACT_APP_URL_UPMEDIA_VALIDACION;
  const URL_UPMEDIA_GARANTIA = process.env.REACT_APP_URL_UPMEDIA_GARANTIA;
  const URL_UPMEDIA_TRANSPORTE = process.env.REACT_APP_URL_UPMEDIA_TRANSPORTE;
  const URL_DELMEDIA = process.env.REACT_APP_URL_DELMEDIA;

  const [t, i18n] = useTranslation('global');
  let hoy = new Date();
  let inicio = new Date();
  inicio.setDate(inicio.getDate() - 365);

  let comp30 = new Date();
  comp30.setDate(comp30.getDate() - 30);

  let endDate = moment(hoy).format('YYYY-MM-DD');
  let startDate = moment(inicio).format('YYYY-MM-DD');

  const [articulos, setArticulos] = useState([]);

  const [programas, setProgramas] = useState([]);
  const [patentes, setPatentes] = useState([]);
  const [proveedores, setProveedores] = useState([]);
  const [terminales, setTerminales] = useState([]);
  const [selectedNaviera, setSelectedNaviera] = useState('');
  const [selectedTerminal, setSelectedTerminal] = useState('');
  const [selectedPrograma, setSelectedPrograma] = useState('');
  const [selectedPatente, setSelectedPatente] = useState('');
  const [clientes, setClientes] = useState([]);
  const [selectedCliente, setSelectedCliente] = useState('');
  const [selectedAgente, setSelectedAgente] = useState('');
  const [selectedAgencia, setSelectedAgencia] = useState('');
  const [selectedComisionista, setSelectedComisionista] = useState('');
  const [selectedTransportista, setSelectedTransportista] = useState('');
  const [selectedForwarder, setSelectedForwarder] = useState('');
  const [selectedStatus, setSelectedStatus] = useState('');
  const [selectedPuerto, setSelectedPuerto] = useState('');
  const [selectedModalidad, setSelectedModalidad] = useState('');
  const [selectedAsegurado, setSelectedAsegurado] = useState('');
  const [selectedFechaInicio, setSelectedFechaInicio] = useState(startDate);
  const [selectedFechaFin, setSelectedFechaFin] = useState(endDate);

  const [selectedFechaCitaInicio, setSelectedFechaCitaInicio] = useState("");
  const [selectedFechaCitaFin, setSelectedFechaCitaFin] = useState("");

  const [selectedPendiente, setSelectedPendiente] = useState('No');
  const [selectedActivo, setSelectedActivo] = useState('Si');

  const [fecha, setFecha] = useState('');
  const [fechaCita, setFechaCita] = useState('');
  const [diasLibresDemoras, setDiasLibresDemoras] = useState('');
  const [custodia, setCustodia] = useState('');
  const [numeroBl, setNumeroBl] = useState('');
  const [puerto, setPuerto] = useState('');
  const [puertoOrigen, setPuertoOrigen] = useState('');
  const [direccionEntrega, setDireccionEntrega] = useState('');
  const [observaciones, setObservaciones] = useState('NA');
  const [observacionesInternas, setObservacionesInternas] = useState('NA');
  const [totalGeneral, setTotalGeneral] = useState('');
  const [totalCantidad, setTotalCantidad] = useState('');
  const [numeroContenedor, setNumeroContenedor] = useState('');
  const [rastreo, setRastreo] = useState('No');
  const [pesoTotal, setPesoTotal] = useState(0);
  const [totalGastos, setTotalGastos] = useState(0);
  const [totalCargos, setTotalCargos] = useState(0);

  const [idEdit, setIdEdit] = useState('');
  const [selectedNavieraEdit, setSelectedNavieraEdit] = useState('');
  const [selectedClienteEdit, setSelectedClienteEdit] = useState('');
  const [selectedAgenteEdit, setSelectedAgenteEdit] = useState('');
  const [selectedAgenciaEdit, setSelectedAgenciaEdit] = useState('');
  const [selectedComisionistaEdit, setSelectedComisionistaEdit] = useState('');
  const [selectedTransportistaEdit, setSelectedTransportistaEdit] = useState('');
  const [selectedForwarderEdit, setSelectedForwarderEdit] = useState('');

  const [coordenadasMapa, setCoordenadasMapa] = useState([]);
  const [originCoords, setOriginCoords] = useState([]);
  const [destinationCoords, setDestinationCoords] = useState([]);
  const [vesselCoords, setVesselCoords] = useState([]);
  const [diasLlegada, setDiasLlegada] = useState(0);

  const [modalMapa, setModalMapa] = useState(false);
  const toggleMapa = () => setModalMapa(!modalMapa);

  const [numeroInterno, setnumeroInterno] = useState('');
  const [contenedor, setContenedor] = useState('');
  // const [fechaETAEstimada, setFechaETAEstimada] = useState("");
  const [fechaETAReal, setFechaETAReal] = useState('');

  const [articulosContenedor, setArticulosContenedor] = useState([]);
  const [modalEditArticulos, setModalEditArticulos] = useState(false);
  const toggleEditArticulos = () => setModalEditArticulos(!modalEditArticulos);
  const [totalGeneral_edit, setTotalGeneralEdit] = useState(0);
  const [totalCantidad_edit, setTotalCantidadEdit] = useState(0);


  const [modalSubirFotoPacking, setModalSubirFotoPacking] = useState(false);
  const toggleSubirFotoPacking = () => setModalSubirFotoPacking(!modalSubirFotoPacking);
  const [modalFotoPacking, setModalFotoPacking] = useState(false);
  const toggleFotoPacking = () => setModalFotoPacking(!modalFotoPacking);

  const [modalSubirFotoBL, setModalSubirFotoBL] = useState(false);
  const toggleSubirFotoBL = () => setModalSubirFotoBL(!modalSubirFotoBL);
  const [modalFotoBL, setModalFotoBL] = useState(false);
  const toggleFotoBL = () => setModalFotoBL(!modalFotoBL);

  const [modalSubirFotoValidacion, setModalSubirFotoValidacion] = useState(false);
  const toggleSubirFotoValidacion = () => setModalSubirFotoValidacion(!modalSubirFotoValidacion);
  const [modalFotoValidacion, setModalFotoValidacion] = useState(false);
  const toggleFotoValidacion = () => setModalFotoValidacion(!modalFotoValidacion);

  const [modalSubirFotoInvoice, setModalSubirFotoInvoice] = useState(false);
  const toggleSubirFotoInvoice = () => setModalSubirFotoInvoice(!modalSubirFotoInvoice);
  const [modalFotoInvoice, setModalFotoInvoice] = useState(false);
  const toggleFotoInvoice = () => setModalFotoInvoice(!modalFotoInvoice);

  const [modalSubirFotoFichaTecnica, setModalSubirFotoFichaTecnica] = useState(false);
  const toggleSubirFotoFichaTecnica = () => setModalSubirFotoFichaTecnica(!modalSubirFotoFichaTecnica);
  const [modalFotoFichaTecnica, setModalFotoFichaTecnica] = useState(false);
  const toggleFotoFichaTecnica = () => setModalFotoFichaTecnica(!modalFotoFichaTecnica);

  const [modalSubirFotoCargosLocales, setModalSubirFotoCargosLocales] = useState(false);
  const toggleSubirFotoCargosLocales = () => setModalSubirFotoCargosLocales(!modalSubirFotoCargosLocales);
  const [modalFotoCargosLocales, setModalFotoCargosLocales] = useState(false);
  const toggleFotoCargosLocales = () => setModalFotoCargosLocales(!modalFotoCargosLocales);

  const [modalSubirFotoDODA, setModalSubirFotoDODA] = useState(false);
  const toggleSubirFotoDODA = () => setModalSubirFotoDODA(!modalSubirFotoDODA);
  const [modalFotoDODA, setModalFotoDODA] = useState(false);
  const toggleFotoDODA = () => setModalFotoDODA(!modalFotoDODA);

  const [modalSubirFotoBoleta, setModalSubirFotoBoleta] = useState(false);
  const toggleSubirFotoBoleta = () => setModalSubirFotoBoleta(!modalSubirFotoBoleta);
  const [modalFotoBoleta, setModalFotoBoleta] = useState(false);
  const toggleFotoBoleta = () => setModalFotoBoleta(!modalFotoBoleta);

  const [modalSubirFotoPrealta, setModalSubirFotoPrealta] = useState(false);
  const toggleSubirFotoPrealta = () => setModalSubirFotoPrealta(!modalSubirFotoPrealta);
  const [modalFotoPrealta, setModalFotoPrealta] = useState(false);
  const toggleFotoPrealta = () => setModalFotoPrealta(!modalFotoPrealta);

  const [modalSubirFotoEIR, setModalSubirFotoEIR] = useState(false);
  const toggleSubirFotoEIR = () => setModalSubirFotoEIR(!modalSubirFotoEIR);
  const [modalFotoEIR, setModalFotoEIR] = useState(false);
  const toggleFotoEIR = () => setModalFotoEIR(!modalFotoEIR);

  const [modalSubirFotoGarantia, setModalSubirFotoGarantia] = useState(false);
  const toggleSubirFotoGarantia = () => setModalSubirFotoGarantia(!modalSubirFotoGarantia);
  const [modalFotoGarantia, setModalFotoGarantia] = useState(false);
  const toggleFotoGarantia = () => setModalFotoGarantia(!modalFotoGarantia);

  const [modalSubirFotoTransporte, setModalSubirFotoTransporte] = useState(false);
  const toggleSubirFotoTransporte = () => setModalSubirFotoTransporte(!modalSubirFotoTransporte);
  const [modalFotoTransporte, setModalFotoTransporte] = useState(false);
  const toggleFotoTransporte = () => setModalFotoTransporte(!modalFotoTransporte);

  const [packing, setPacking] = useState('');
  const [blArchivo, setBlArchivo] = useState('');
  const [validacion, setValidacion] = useState('');
  const [invoice, setInvoice] = useState('');
  const [fichaTecnicaArchivo, setFichaTecnicaArchivo] = useState('');
  const [cargosLocales, setCargosLocales] = useState('');
  const [DODA, setDODA] = useState('');
  const [boleta, setBoleta] = useState('');
  const [prealta, setPrealta] = useState('');
  const [EIR, setEIR] = useState('');
  const [garantia, setGarantia] = useState('');
  const [transporte, setTransporte] = useState('');


  const [modalFotos, setModalFotos] = useState(false);
  const toggleFotos = () => setModalFotos(!modalFotos);


  const [photo, setPhoto] = useState([]);
  const [idContenedor, setIdContenedor] = useState();
  const [file, setFile] = useState([]);

   const [modalArchivo, setModalArchivo] = useState(false);
    const toggleArchivo = () => setModalArchivo(!modalArchivo);
      const [inputFieldsContenedores, setInputFieldsContenedores] = useState([
        {
          id: uuidv4(),
          cliente: "",
          idCliente: "",
          referencia: "",
          referenciaCliente: "",
          contenedor: "",
          eta: "",
          articulo: "",
          valorFactura: 0,
          pedimento: "",
          modalidad: "",
          puerto: "",
          direccionEntrega: "",
        },
      ]);
  const [totalContenedores, setTotalContenedores] = useState(0);

  const [validaBoton, setValidaBoton] = useState(true);
  const [inputFields, setInputFields] = useState([
    {
      id: uuidv4(),
      articulos: '',
      cantidad: 0,
      precio: 0,
      total: 0,
    },
  ]);

  const [modalMail, setModalMail] = useState(false);
  const toggleMail = () => setModalMail(!modalMail);
  const [mailTo, setMailTo] = useState('');

  const [modalEdit, setModalEdit] = useState(false);
  const toggleEdit = () => setModalEdit(!modalEdit);

  const [modalETA, setModalETA] = useState(false);
  const toggleETA = () => setModalETA(!modalETA);

  const [modalProgreso, setModalProgreso] = useState(false);
  const toggleProgreso = () => setModalProgreso(!modalProgreso);

  const [modalStatus, setModalStatus] = useState(false);
  const toggleStatus = () => setModalStatus(!modalStatus);
  const [id, setid] = useState('');
  const [bl, setbl] = useState('');
  const [pl, setpl] = useState('');
  const [pedimento, setPedimento] = useState('');
  const [factura, setfactura] = useState('');
  const [modalidad, setModalidad] = useState('');
  const [asegurado, setAsegurado] = useState('');
  const [documentos, setdocumentos] = useState('');
  const [telex, settelex] = useState('');
  const [toquePiso, settoquePiso] = useState('');
  const [revalidacion, setrevalidacion] = useState('');
  const [fichaTecnica, setfichaTecnica] = useState('');
  const [pagoPedimento, setpagoPedimento] = useState('');
  const [modulacion, setmodulacion] = useState('');
  const [retornoVacio, setretornoVacio] = useState('');
  const [salidaPuerto, setsalidaPuerto] = useState('');
  const [salidaRuta, setsalidaRuta] = useState('');
  const [entregaCliente, setentregaCliente] = useState('');
  const [maniobras, setmaniobras] = useState('');
  const [status, setstatus] = useState('');
  const [fechaEntradaPuerto, setfechaEntradaPuerto] = useState('');
  const [fechaDocumentos, setfechaDocumentos] = useState('');
  const [fechaTelex, setfechaTelex] = useState('');
  const [fechaToquePiso, setfechaToquePiso] = useState('');
  const [fechaRevalidacion, setfechaRevalidacion] = useState('');
  const [fechaFichaTecnica, setfechaFichaTecnica] = useState('');
  const [fechaPagoPedimento, setfechaPagoPedimento] = useState('');
  const [fechaModulacion, setfechaModulacion] = useState('');
  const [fechaRetornoVacio, setfechaRetornoVacio] = useState('');
  const [fechaSalidaPuerto, setfechaSalidaPuerto] = useState('');
  const [fechaSalidaRuta, setfechaSalidaRuta] = useState('');
  const [fechaEntregaCliente, setfechaEntregaCliente] = useState('');
  const [fechaManiobras, setfechaManiobras] = useState('');
  const [fechaFactura, setfechaFactura] = useState('');
  const [fechaBl, setfechaBl] = useState('');
  const [fechaPl, setfechaPl] = useState('');

  const [modalGastos, setModalGastos] = useState(false);
  const toggleGastos = () => setModalGastos(!modalGastos);
  const [fechaGasto, setFechaGasto] = useState(endDate);
  const [totalUSD, setTotalUSD] = useState(0);
  const [tipoCambio, setTipoCambio] = useState(1);
  const [total, setTotal] = useState(0);
  const [descripcion, setDescripcion] = useState('NA');
  const [conceptosGastos, setConceptosGastos] = useState([]);
  const [selectedConcepto, setSelectedConcepto] = useState('');
  const [selectedProveedor, setSelectedProveedor] = useState('');
  const [selectedContenedor, setSelectedContenedor] = useState('');
  const [selectedClienteGasto, setSelectedClienteGasto] = useState('');
  const [moneda, setMoneda] = useState('MXN');

  const [modalCargos, setModalCargos] = useState(false);
  const toggleCargos = () => setModalCargos(!modalCargos);

  //--- Pagination
  const [comments, setComments] = useState([]);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState('');
  const [sorting, setSorting] = useState({ field: '', order: '' });

  const ITEMS_PER_PAGE = 50;

  useMemo(() => {
    // Helpers (ponlos arriba, fuera del .then)
const MS_PER_DAY = 24 * 60 * 60 * 1000;
const parseYMD = (s) => {
  if (!s) return null;
  const [y, m, d] = s.split("-").map(Number);
  return new Date(y, (m || 1) - 1, d || 1); // fecha local 00:00
};
const startOfToday = () => {
  const t = new Date();
  t.setHours(0,0,0,0);
  return t;
};
const diffDays = (start, end) => {
  if (!start || !end) return 0;
  const ms = end - start;
  return Math.max(0, Math.floor(ms / MS_PER_DAY));
};
    axios
      .get(
        `${URL_CONTENEDORES}Fechas/${selectedFechaInicio}/${selectedFechaFin}`,
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem('app_token')}`,
          },
        }
      )
      .then((response) => {
        let allContenedores = response.data;
        // Array para pagination
        let arrayTabla = allContenedores
          .sort((a, b) => (a.etaReal > b.etaReal ? 1 : -1))
          .map((a) => {
            // Fechas base
  const eta = parseYMD(a.etaReal);                 // inicio
  const hoy = startOfToday();

  // --- 1) Demoras cobrables ---
  // del etaReal a fechaModulacion (o hoy si no hay modulacion),
  // solo si ya pasó etaReal; restando diasLibresDemoras.
  const finDemoras = parseYMD(a.fechaModulacion) || hoy;
  const diasLibres = Number(a.diasLibresDemoras) || 0;
  const brutosDemoras = eta && hoy >= eta ? diffDays(eta, finDemoras) : 0;
  const diasDemorasCobrables = Math.max(0, brutosDemoras - diasLibres);

  // --- 2) Almacenajes cobrables ---
  // del etaReal a fechaRetornoVacio (o hoy si no hay),
  // mismos criterios que arriba pero SIN restar diasLibresDemoras.
  const finAlmacen = parseYMD(a.fechaRetornoVacio) || hoy;
  const diasAlmacenajesCobrables = eta && hoy >= eta ? diffDays(eta, finAlmacen) : 0;
            return {
              _id: a._id,
              numero: a.idContenedor,
              activo: a.is_active,
              fecha: a.fecha,
              fechaCita: a.fechaCita,
              diasLibresDemoras: a.diasLibresDemoras,
              custodia: a.custodia,
              observaciones: a.observaciones,
              observacionesInternas: a.observacionesInternas,
              totalGeneral: a.totalGeneral,
              navieras: a.navieras[0].name,
              idNavieras: a.navieras[0]._id,
              clientes: a.clientes[0].nombre_comercial,
              idClientes: a.clientes[0]._id,
              agentes: a.agentes[0].name,
              idAgentes: a.agentes[0]._id,
              agencias: a.agencias[0].name,
              idAgencias: a.agencias[0]._id,
              comisionistas: a.comisionistas[0].name,
              idComisionistas: a.comisionistas[0]._id,
              transportistas: a.transportistas[0].name,
              idTransportistas: a.transportistas[0]._id,
              terminales: a.terminales[0].name,
              idTerminales: a.terminales[0]._id,
              programas: a.programas[0].name,
              idProgramas: a.programas[0]._id,
              patentes: a.patentes[0].name,
              idPatentes: a.patentes[0]._id,
              forwarders: a.forwarders[0].name,
              idForwarders: a.forwarders[0]._id,
              totalCantidad: a.totalCantidad,
              numeroInterno:
                a.clientes[0].nombre_comercial + '-' + a.idContenedor,
              contenedor: a.contenedor,
              // etaEstimada: a.etaEstimada,
              etaReal: a.etaReal,
              bl: a.bl,
              pl: a.pl,
              invoice: a.invoice,
              fichaTecnicaArchivo: a.fichaTecnicaArchivo,
              cargosLocales: a.cargosLocales,
              DODA: a.DODA,
              boleta: a.boleta,
              prealta: a.prealta,
              EIR: a.EIR,
              validacion: a.validacion,
              garantia: a.garantia,
              packing: a.packing,
              transporte: a.transporte,
              totalGastos: a.totalGastos,
              puerto: a.puerto,
              puertoOrigen: a.puertoOrigen,
              numeroBl: a.numeroBl,
              direccionEntrega: a.direccionEntrega,
              totalCargos: a.totalCargos,

              pedimento: a.pedimento,
              modalidad: a.modalidad,

              asegurado: a.asegurado,

              factura: a.factura,
              documentos: a.documentos,
              telex: a.telex,
              toquePiso: a.toquePiso,
              revalidacion: a.revalidacion,
              fichaTecnica: a.fichaTecnica,
              pagoPedimento: a.pagoPedimento,
              modulacion: a.modulacion,
              retornoVacio: a.retornoVacio,
              salidaPuerto: a.salidaPuerto,
              salidaRuta: a.salidaRuta,
              entregaCliente: a.entregaCliente,
              maniobras: a.maniobras,
              status: a.status,
              fechaEntradaPuerto: a.fechaEntradaPuerto,
              fechaDocumentos: a.fechaDocumentos,
              fechaTelex: a.fechaTelex,
              fechaToquePiso: a.fechaToquePiso,
              fechaRevalidacion: a.fechaRevalidacion,
              fechaFichaTecnica: a.fechaFichaTecnica,
              fechaPagoPedimento: a.fechaPagoPedimento,
              fechaModulacion: a.fechaModulacion,
              fechaRetornoVacio: a.fechaRetornoVacio,
              fechaSalidaPuerto: a.fechaSalidaPuerto,
              fechaSalidaRuta: a.fechaSalidaRuta,
              fechaEntregaCliente: a.fechaEntregaCliente,
              fechaManiobras: a.fechaManiobras,
              fechaFactura: a.fechaFactura,
              fechaBl: a.fechaBl,
              fechaPl: a.fechaPl,

              rastreo:a.rastreo,
              mapa:a.mapa,
              fromCountry: a.fromCountry,
              polOrigen: a.polOrigen,
              loadingDate: a.loadingDate,
              departureDate: a.departureDate,
              toCountry: a.toCountry,
              podDestino: a.podDestino,
              arrivalDate: a.arrivalDate,
              dischargeDate: a.dischargeDate,
              vessel: a.vessel,
              vesselIMO: a.vesselIMO,
              vesselLatitude: a.vesselLatitude,
              vesselLongitude: a.vesselLongitude,
              vesselVoyage: a.vesselVoyage,
              polLatitude: a.polLatitude,
              polLongitude: a.polLongitude,
              podLatitude: a.podLatitude,
              podLongitude: a.podLongitude,
              vesselLatitude: a.vesselLatitude,
              vesselLongitude: a.vesselLongitude,
              pesoTotal: a.pesoTotal,


    // 👇 NUEVOS CAMPOS
    diasDemorasCobrables,
    diasAlmacenajesCobrables,
            };
          })
          .filter(function (el) {
            return el != null;
          });

        let dataFinal = Object.values(arrayTabla);

        setComments(dataFinal);
        //
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(`${URL_CLIENTES}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem('app_token')}`,
        },
      })
      .then((response) => {
        let allClientes = response.data;
        setClientes(allClientes);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(`${URL_TERMINALES}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem('app_token')}`,
        },
      })
      .then((response) => {
        let allTerminales = response.data;
        setTerminales(allTerminales);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(`${URL_PROVEEDORES}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem('app_token')}`,
        },
      })
      .then((res) => {
        const allProveedores = res.data;
        setProveedores(allProveedores);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(`${URL_PROGRAMAS}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem('app_token')}`,
        },
      })
      .then((res) => {
        const allProgramas = res.data;
        setProgramas(allProgramas);
      })
      .catch((err) => {
        console.log(err);
      });

      axios
      .get(`${URL_PATENTES}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem('app_token')}`,
        },
      })
      .then((res) => {
        const allPatentes = res.data;
        setPatentes(allPatentes);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(URL_ARTICULOS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem('app_token')}`,
        },
      })
      .then((response) => {
        let allArticulos = response.data;
        setArticulos(allArticulos);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(URL_CONCEPTOS_GASTOS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem('app_token')}`,
        },
      })
      .then((res) => {
        const allConceptosGastos = res.data;
        setConceptosGastos(allConceptosGastos);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [selectedFechaInicio, selectedFechaFin]);

  function PDFTabla() {
    const data = comments.map((a) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
        (selectedNaviera == 0 || selectedNaviera == a.idNavieras) &&
        (selectedCliente == 0 || selectedCliente == a.idClientes) &&
        (selectedForwarder == 0 || selectedForwarder == a.idForwarders) &&
        (selectedStatus == 0 || selectedStatus == a.status) &&
        (selectedPuerto == 0 || selectedPuerto == a.puerto) &&
        (selectedModalidad == 0 || selectedModalidad == a.selectedModalidad) &&
        (selectedAsegurado == 0 || selectedAsegurado == a.selectedAsegurado) &&
        (selectedAgente == 0 || selectedAgente == a.idAgentes) &&
        (selectedTransportista == 0 || selectedTransportista == a.idTransportistas) &&
        (selectedAgencia == 0 || selectedAgencia == a.idAgencias) &&
        (selectedComisionista == 0 || selectedComisionista == a.idComisionistas) &&
        (selectedPendiente == 0 || selectedPendiente == a.entregaCliente) &&
        (selectedActivo == 0 || selectedActivo == a.activo)
      ) {
        return [
          a.etaReal,
          a.numeroInterno,
          a.contenedor,
          a.navieras,
          a.clientes,
          a.forwarders,
          a.puerto,
          a.modalidad,
          a.fechaModulacion,
          a.fechaEntregaCliente,
          a.status,
          a.observaciones,
        ];
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF('landscape');
    var img = new Image();
    img.src = process.env.PUBLIC_URL + 'Logo-Lynqro-PDF.png';
    doc.addImage(img, 'png', 230, 30, 45, 15);
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + 'logoInstitucion.png';
    doc.addImage(img2, 'png', 120, 15, 65, 28);
    doc.text(`Listado Contenedores`, 20, 30);
    doc.text(`${selectedFechaInicio} - ${selectedFechaFin}`, 20, 40);
    doc.autoTable({
      head: [
        [
          'ETA',
          'No. Interno',
          'Contenedor',
          'Naviera',
          'Cliente',
          'Forwarder',
          'Puerto',
          'Modalidad',
          'Modulacion',
          'Entrega Cliente',
          'Status',
          'Observaciones',
        ],
      ],
      body: dataPDFLimpia,
      startY: 45,
    });
    doc.save(`Contenedores.pdf`);
  }

  function excel() {
    const dataExcel = comments.map((a) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
        (selectedNaviera == 0 || selectedNaviera == a.idNavieras) &&
        (selectedCliente == 0 || selectedCliente == a.idClientes) &&
        (selectedForwarder == 0 || selectedForwarder == a.idForwarders) &&
        (selectedStatus == 0 || selectedStatus == a.status) &&
        (selectedPuerto == 0 || selectedPuerto == a.puerto) &&
        (selectedModalidad == 0 || selectedModalidad == a.selectedModalidad) &&
        (selectedAsegurado == 0 || selectedAsegurado == a.selectedAsegurado) &&
        (selectedAgente == 0 || selectedAgente == a.idAgentes) &&
        (selectedTransportista == 0 || selectedTransportista == a.idTransportistas) &&
        (selectedAgencia == 0 || selectedAgencia == a.idAgencias) &&
        (selectedComisionista == 0 || selectedComisionista == a.idComisionistas) &&
        (selectedPendiente == 0 || selectedPendiente == a.entregaCliente) &&
        (selectedActivo == 0 || selectedActivo == a.activo)
      ) {
        return {
          ID: a._id,
          Numero: a.numero,
          ETA: a.etaReal,
          NumeroInterno: a.numeroInterno,
          Contenedor: a.contenedor,
          FechaCita: a.fechaCita,
          BL: a.numeroBl,
          Naviera: a.navieras,
          Cliente: a.clientes,
          AgenteAduanal: a.agentes,
          Forwarder: a.forwarders,
          Puerto: a.puerto,
          Modalidad: a.modalidad,
          Asegurado: a.asegurado,
          Modulacion: a.fechaModulacion,
          Status: a.status,
          // Maniobras: a.fechaManiobras,
          Patente: a.patente,
          EntregaCliente: a.fechaEntregaCliente,
          Observaciones: a.observaciones,
          ObservacionesInternas: a.observacionesInternas,
        };
      }
    });
    const dataExportExcel = Object.values(dataExcel);
    const dataExcelLimpia = dataExportExcel.filter(function (el) {
      return el != null;
    });

    var option = {};

    option.fileName = 'ListadoContenedores';

    option.datas = [
      {
        sheetData: dataExcelLimpia,
        sheetName: 'ListadoContenedores',
        sheetFilter: [
          'ID',
          'Numero',
          'ETA',
          'NumeroInterno',
          'Contenedor',
          'FechaCita',
          'BL',
          'Naviera',
          'Cliente',
          'AgenteAduanal',
          'Forwarder',
          'Puerto',
          'Modalidad',
          'Asegurado',
          'Modulacion',
          'Status',
          // 'Maniobras',
          'Patente',
          'EntregaCliente',
          'Observaciones',
          'ObservacionesInternas',
        ],
        sheetHeader: [
          'ID',
          'Numero',
          'ETA',
          'NumeroInterno',
          'Contenedor',
          'FechaCita',
          'BL',
          'Naviera',
          'Cliente',
          'AgenteAduanal',
          'Forwarder',
          'Puerto',
          'Modalidad',
          'Asegurado',
          'Modulacion',
          'Status',
          // 'Maniobras',
          'Patente',
          'EntregaCliente',
          'Observaciones',
          'ObservacionesInternas',
        ],
      },
    ];

    var toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel();
  }

  function enviaMail() {
    const data = comments.map((a) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
        (selectedNaviera == 0 || selectedNaviera == a.idNavieras) &&
        (selectedCliente == 0 || selectedCliente == a.idClientes) &&
        (selectedForwarder == 0 || selectedForwarder == a.idForwarders) &&
        (selectedStatus == 0 || selectedStatus == a.status) &&
        (selectedPuerto == 0 || selectedPuerto == a.puerto) &&
        (selectedModalidad == 0 || selectedModalidad == a.selectedModalidad) &&
        (selectedAsegurado == 0 || selectedAsegurado == a.selectedAsegurado) &&
        (selectedAgente == 0 || selectedAgente == a.idAgentes) &&
        (selectedTransportista == 0 || selectedTransportista == a.idTransportistas) &&
        (selectedAgencia == 0 || selectedAgencia == a.idAgencias) &&
        (selectedComisionista == 0 || selectedComisionista == a.idComisionistas) &&
        (selectedPendiente == 0 || selectedPendiente == a.entregaCliente) &&
        (selectedActivo == 0 || selectedActivo == a.activo)
      ) {
        return [
          a.numero,
          a.fecha,
          a.etaReal,
          a.numeroInterno,
          a.contenedor,
          a.navieras,
          a.clientes,
          a.agentes,
          a.forwarders,
          a.puerto,
          a.terminal,
          a.modalidad,
          a.fechaSalidaPuerto,
          a.fechaSalidaRuta,
          a.status,
          a.observaciones,
          a.programa,
          a.totalCantidad,
          new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            maximumFractionDigits: 2,
          }).format(a.totalGeneral),
          a.direccionEntrega,
        ];
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF('landscape');
    var img = new Image();
    img.src = process.env.PUBLIC_URL + 'Logo-Lynqro-PDF.png';
    doc.addImage(img, 'png', 230, 30, 45, 15);
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + 'logoInstitucion.png';
    doc.addImage(img2, 'png', 120, 15, 65, 28);
    doc.text(`Listado Contenedores`, 20, 30);
    doc.text(`${selectedFechaInicio} - ${selectedFechaFin}`, 20, 40);
    doc.autoTable({
      head: [
        [
          'Numero',
          'Fecha',
          'ETA',
          'No. Interno',
          'Contenedor',
          'Naviera',
          'Cliente',
          'Agente Aduanal',
          'Forwarder',
          'Puerto',
          'Terminal',
          'Modalidad',
          'Salida Puerto',
          'Salida Ruta',
          'Status',
          'Observaciones',
          'Programa',
          'Cantidad',
          'Total',
          'Direccion Entrega',
        ],
      ],
      body: dataPDFLimpia,
      startY: 45,
    });
    var att = doc.output('arraybuffer');
    var base64File = encode(att);

    // Envia el Mail
    axios
      .post(
        URL_SEND_MAIL_ATT,
        {
          subject: 'Listado Contenedores',
          email: mailTo,
          fileName: 'ListadoContenedores.pdf',
          att: base64File,
          text: `<table border="0" cellpadding="0" cellspacing="0" width="100%">
         <th><img width="${process.env.REACT_APP_TAMANO_LOGO_MAIL}" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}logoInstitucion.png" /></th>
         <tr align="center" style="font-size:30px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>${process.env.REACT_APP_NOMBRE_INSTITUCION}</tr>
         <tbody>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Hola,</tr>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Adjunto encontraras el listado de Contenedores.</tr>
         </tbody>
         <tr style="font-size:16px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px"><br>Favor de no responder este correo, para cualquier duda favor de comunicarse al ${process.env.REACT_APP_TELEFONO_INSTITUCION}</tr>
         <tr align="right"><br>Powered by <a href="https://lynqro.com"> <img width="20%" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}Logo-Lynqro-PDF.png" /> </a> </tr>
         </table>`,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem('app_token')}`,
          },
        }
      )
      .then(() => {
        toggleMail();
        Swal.fire('Good job!', 'Enviado con exito', 'success');
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Something went wrong!',
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  }

  function jalaInfo(
    fecha,
    idNavieras,
    idClientes,
    idAgentes,
    idAgencias,
    idComisionistas,
    idTransportistas,
    idForwarders,
    totalCantidad,
    totalGeneral,
    observaciones,
    observacionesInternas,
    numeroContenedor,
    numeroInterno,
    contenedor,
    // etaEstimada,
    etaReal,
    puerto,
    puertoOrigen,
    numeroBl,
    fechaCita,
    diasLibresDemoras,
    custodia,
    idTerminales,
    pedimento,
    modalidad,
    asegurado,
    direccionEntrega,
    idProgramas,
    idPatentes,
    rastreo,
    pesoTotal,
    totalCargos,
    totalGastos,
    idEdit
  ) {
    setFecha(fecha);
    setSelectedNavieraEdit(idNavieras);
    setSelectedClienteEdit(idClientes);
    setSelectedAgenteEdit(idAgentes);
    setSelectedAgenciaEdit(idAgencias);
    setSelectedComisionistaEdit(idComisionistas);
    setSelectedTransportistaEdit(idTransportistas);
    setSelectedForwarderEdit(idForwarders);
    setTotalCantidad(totalCantidad);
    setTotalGeneral(totalGeneral);
    setObservaciones(observaciones);
    setObservacionesInternas(observacionesInternas);
    setNumeroContenedor(numeroContenedor);
    setnumeroInterno(numeroInterno);
    setContenedor(contenedor);
    // setFechaETAEstimada(etaEstimada);
    setFechaETAReal(etaReal);
    setPuerto(puerto);
    setPuertoOrigen(puertoOrigen);
    setNumeroBl(numeroBl);
    setFechaCita(fechaCita);
    setDiasLibresDemoras(diasLibresDemoras);
    setCustodia(custodia);
    setSelectedTerminal(idTerminales);
    setPedimento(pedimento);
    setModalidad(modalidad);
    setAsegurado(asegurado);
    setDireccionEntrega(direccionEntrega);
    setSelectedPrograma(idProgramas);
    setSelectedPatente(idPatentes);
    setRastreo(rastreo);
    setPesoTotal(pesoTotal);
    setTotalCargos(totalCargos);
    setTotalGastos(totalGastos);
    setIdEdit(idEdit);
    toggleEdit();
  }

  async function PDFOC(
    fecha,
    idNavieras,
    navieras,
    clientes,
    agentes,
    totalCantidad,
    totalGeneral,
    observaciones,
    numero,
    idPDFOC
  ) {
    await axios
      .get(`${URL_ARTICULOS_CONTENEDOR}/contenedor/${idPDFOC}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem('app_token')}`,
        },
      })
      .then((response) => {
        let allArticulosContenedor = response.data;
        let arrayTabla = allArticulosContenedor
          .map((a) => {
            return {
              id: a._id,
              articulos: a.articulos[0].name,
              descripcion: a.descripcion,
              cantidad: a.cantidad,
              precio: a.precio,
              total: a.total,
            };
          })
          .filter(function (el) {
            return el != null;
          });

        let dataFinal = Object.values(arrayTabla);

        let cant = inputFields.map((c) => parseFloat(c.cantidad));
        let TC = cant.reduce((t, total, index) => t + total, 0);
        setTotalCantidad(TC);
        let importes = dataFinal.map((c) => parseFloat(c.total));
        let TG = importes.reduce((t, total, index) => t + total, 0);
        setTotalGeneralEdit(TG);

        const data = dataFinal.map((a) => {
          return [
            a.articulos,
            a.descripcion,
            new Intl.NumberFormat('en-US').format(a.cantidad),
            new Intl.NumberFormat('en-US', {
              style: 'currency',
              currency: 'USD',
              maximumFractionDigits: 2,
            }).format(a.precio),
            new Intl.NumberFormat('en-US', {
              style: 'currency',
              currency: 'USD',
              maximumFractionDigits: 2,
            }).format(a.total),
          ];
        });
        const dataPDF = Object.values(data);
        const dataPDFLimpia = dataPDF.filter(function (el) {
          return el != null;
        });
        const doc = new jsPDF('landscape');
        var img = new Image();
        img.src = process.env.PUBLIC_URL + 'Logo-Lynqro-PDF.png';
        doc.addImage(img, 'png', 230, 30, 45, 15);
        var img2 = new Image();
        img2.src = process.env.PUBLIC_URL + 'logoInstitucion.png';
        doc.addImage(img2, 'png', 120, 15, 45, 15);
        doc.text(`Contenedor # ${numero}`, 20, 20);
        doc.setFontSize(12);
        doc.text(`Fecha ${fecha}`, 20, 25);
        doc.text(`Naviera ${navieras}`, 20, 30);
        doc.text(
          `Piezas ${new Intl.NumberFormat('en-US').format(totalCantidad)}`,
          20,
          40
        );
        doc.autoTable({
          head: [['Articulo', 'Descripcion', 'Cantidad', 'Precio', 'Total']],
          body: dataPDFLimpia,
          startY: 45,
          foot: [
            [
              '',
              '',
              '',
              'Total',
              new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: 'USD',
                maximumFractionDigits: 2,
              }).format(totalGeneral),
            ],
          ],
          showFoot: 'lastPage',
        });
        doc.save(`Contenedor-${numero}.pdf`);
      })
      .catch((err) => {
        console.log(err);
      });
  }

// ===============================
// HELPERS PROVEEDORES (OPCIÓN B)
// ===============================
const norm = (s) => (s || "").toString().trim().toUpperCase();

const getNombreProveedor = (p) =>
  (p?.nombre_comercial ||
    p?.nombre ||
    p?.razon_social ||
    p?.descripcion ||
    "").toString().trim();

// 🔴 AJUSTA SOLO ESTE CAMPO si en tu schema se llama diferente:
const getTipoProveedor = (p) => norm(p?.tipoProveedor); // <-- cambia si aplica

const findProveedorByTipoYNombre = (tipo, nombre, proveedores) => {
  const n = norm(nombre);
  if (!n) return null;

  return (
    (proveedores || []).find((p) => {
      return (
        getTipoProveedor(p) === norm(tipo) &&
        norm(getNombreProveedor(p)) === n
      );
    }) || null
  );
};

function formatearETA(valor) {
  if (valor === null || valor === undefined || valor === "") return "";

  // 1️⃣ Si Excel lo mandó como Date
  if (valor instanceof Date && !isNaN(valor.getTime())) {
    return valor.toISOString().split("T")[0];
  }

  // 2️⃣ Si viene como número (serial Excel)
  if (typeof valor === "number") {
    const fecha = new Date(Math.round((valor - 25569) * 86400 * 1000));
    return fecha.toISOString().split("T")[0];
  }

  // 3️⃣ Si viene como string
  if (typeof valor === "string") {
    const v = valor.trim();

    // dd/mm/yyyy  ← TU CASO
    if (/^\d{2}\/\d{2}\/\d{4}$/.test(v)) {
      const [d, m, a] = v.split("/");
      return `${a}-${m.padStart(2, "0")}-${d.padStart(2, "0")}`;
    }

    // yyyy-mm-dd
    if (/^\d{4}-\d{2}-\d{2}$/.test(v)) {
      return v;
    }

    // dd-mm-yyyy
    if (/^\d{2}-\d{2}-\d{4}$/.test(v)) {
      const [d, m, a] = v.split("-");
      return `${a}-${m}-${d}`;
    }
  }

  return "";
}


function importarArchivo(event) {
  const inputEl = event.target; // ✅ referencia real del input
  if (!inputEl || inputEl.name !== "file") return;

  const file = inputEl.files?.[0];
  if (!file) return;

  const normalizeText = (s) =>
    (s || "")
      .toString()
      .replace(/\u00A0/g, " ")
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/\s+/g, " ")
      .trim()
      .toUpperCase();

  const safeStr = (v) => (v === null || v === undefined ? "" : String(v)).trim();

  const findCliente = (nombreExcel) => {
    const key = normalizeText(nombreExcel);
    return (
      (clientes || []).find((c) => normalizeText(c?.nombre_comercial) === key) ||
      null
    );
  };

  const findProveedor = (tipoBuscado, nombreExcel) => {
    const nombreKey = normalizeText(nombreExcel);
    if (!nombreKey) return null;

    const tipoKey = normalizeText(tipoBuscado);

    return (
      (proveedores || []).find((p) => {
        const pTipo = normalizeText(p?.tipo);
        const pName = normalizeText(p?.name);
        return pTipo === tipoKey && pName === nombreKey;
      }) || null
    );
  };

  const updateSwalProgress = (info = {}) => {
    const {
      filasProcesadas = 0,
      totalFilas = 0,
      importadas = 0,
      omitidas = 0,
      ultimosErrores = [],
      titulo = "Procesando archivo...",
      icon = undefined,
      loading = true,
      footer = "",
      autoCloseMs = 0,
    } = info;

    const bloqueErrores = ultimosErrores?.length
      ? `
        <div style="text-align:left;max-height:260px;overflow:auto;margin-top:10px;padding:10px;border:1px solid #eee;border-radius:10px;">
          <b>Errores/Advertencias:</b><br>
          ${ultimosErrores.join("<br>")}
        </div>
      `
      : `<div style="margin-top:10px;">Sin errores hasta ahora ✅</div>`;

    Swal.update({
      title: titulo,
      icon,
      html: `
        <div style="text-align:left">
          <div><b>Filas:</b> ${filasProcesadas}${totalFilas ? ` / ${totalFilas}` : ""}</div>
          <div><b>Importadas:</b> ${importadas}</div>
          <div><b>Omitidas:</b> ${omitidas}</div>
          ${bloqueErrores}
          ${footer ? `<div style="margin-top:10px;opacity:.85">${footer}</div>` : ""}
        </div>
      `,
      allowOutsideClick: !loading,
      backdrop: true,
      showConfirmButton: !loading && autoCloseMs === 0,
      confirmButtonText: !loading ? "Entendido" : undefined,
    });

    if (loading) Swal.showLoading();
    else Swal.hideLoading();

    if (!loading && autoCloseMs > 0) setTimeout(() => Swal.close(), autoCloseMs);
  };

  Swal.fire({
    title: "Procesando archivo...",
    html: "Leyendo Excel...",
    allowOutsideClick: false,
    backdrop: true,
    didOpen: () => Swal.showLoading(),
  });

  const reader = new FileReader();

  reader.onload = async (e) => {
    try {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: "array" });
      const sheet = workbook.Sheets[workbook.SheetNames[0]];

      const raw = XLSX.utils.sheet_to_json(sheet, { defval: "" });

      const A1 = raw
        .map((row) => {
          const out = {};
          Object.entries(row).forEach(([k, v]) => {
            const key = (k || "")
              .toString()
              .toUpperCase()
              .replace(/\*/g, "")
              .replace(/\s+/g, "");
            out[key] = v;
          });
          return out;
        })
        .filter((row) =>
          Object.values(row).some(
            (v) => v !== null && v !== undefined && String(v).trim() !== ""
          )
        );

      if (!A1.length) {
        updateSwalProgress({
          titulo: "No se encontró información",
          icon: "warning",
          loading: false,
          ultimosErrores: ["El archivo se leyó, pero no hay filas con datos."],
        });
        if (inputEl) inputEl.value = ""; // ✅
        return;
      }

      const totalFilas = A1.length;
      const nuevosCampos = [];
      const erroresImportacion = [];
      let omitidas = 0;

      updateSwalProgress({
        filasProcesadas: 0,
        totalFilas,
        importadas: 0,
        omitidas: 0,
        ultimosErrores: [],
        titulo: "Procesando archivo...",
        loading: true,
      });

      let filaExcel = 1;
      for (const a of A1) {
        const referencia = safeStr(a.REFERENCIA);

        const clienteExcel = safeStr(a.CLIENTE);
        const clienteObj = findCliente(clienteExcel);

        if (!clienteObj) {
          omitidas++;
          erroresImportacion.push(
            `Fila ${filaExcel}: Cliente NO encontrado → "${clienteExcel}"`
          );

          updateSwalProgress({
            filasProcesadas: filaExcel,
            totalFilas,
            importadas: nuevosCampos.length,
            omitidas,
            ultimosErrores: erroresImportacion.slice(-6),
            titulo: "Procesando archivo...",
            loading: true,
          });

          filaExcel++;
          continue;
        }

        const navieraObj = findProveedor("Naviera", a.NAVIERA);
        const agenciaObj = findProveedor("Agencia", a.AGENCIA);
        const agenteObj = findProveedor("Agente", a.AGENTE);
        const comisionistaObj = findProveedor("Comisionista", a.COMISIONISTA);
        const transportistaObj = findProveedor("Transportista", a.TRANSPORTISTA);
        const forwarderObj = findProveedor("Forwarder", a.FORWARDER);

        nuevosCampos.push({
          id: uuidv4(),
          cliente: clienteObj.nombre_comercial,
          idCliente: clienteObj._id,
          referencia: "NA",
          referenciaCliente: "NA",
          // referenciaCliente: safeStr(a.REFERENCIACLIENTE),

          idNaviera: navieraObj?._id || null,
          idAgencia: agenciaObj?._id || null,
          idAgente: agenteObj?._id || null,
          idComisionista: comisionistaObj?._id || null,
          idTransportista: transportistaObj?._id || null,
          idForwarder: forwarderObj?._id || null,

          // numeroInterno: safeStr(a.NUMEROINTERNO),
          numeroInterno: "NA",
          contenedor: safeStr(a.CONTENEDOR),
          fechaETA: formatearETA(a.ETA),
          fecha: formatearETA(a.FECHA),
          fechaCita: formatearETA(a.FECHACITA),
          puerto: safeStr(a.PUERTO),
          puertoOrigen: safeStr(a.PUERTOORIGEN),
          modalidad: safeStr(a.MODALIDAD),
          numeroBl: safeStr(a.NUMEROBL),
          direccionEntrega: "NA",

          articulo: safeStr(a.ARTICULO),
          valorFactura: Number(a.VALORFACTURA || 0),
          pedimento: safeStr(a.PEDIMENTO),

          custodia: safeStr(a.CUSTODIA),
          diasLibresDemoras:
            safeStr(a.DIASLIBRESDEMORAS) === "" ? null : Number(a.DIASLIBRESDEMORAS),
          asegurado: safeStr(a.ASEGURADO),
          observaciones: safeStr(a.OBSERVACIONES),
        });

        if (filaExcel % 10 === 0 || filaExcel === totalFilas) {
          updateSwalProgress({
            filasProcesadas: filaExcel,
            totalFilas,
            importadas: nuevosCampos.length,
            omitidas,
            ultimosErrores: erroresImportacion.slice(-6),
            titulo: "Procesando archivo...",
            loading: true,
          });
        }

        filaExcel++;
      }

      setInputFieldsContenedores(nuevosCampos);
      setTotalContenedores(nuevosCampos.length);
      if (typeof setValidaBoton === "function") setValidaBoton(nuevosCampos.length > 0);

      if (!erroresImportacion.length && omitidas === 0) {
        updateSwalProgress({
          titulo: "Importación exitosa",
          icon: "success",
          loading: false,
          filasProcesadas: totalFilas,
          totalFilas,
          importadas: nuevosCampos.length,
          omitidas,
          ultimosErrores: [],
          footer: "Todo salió bien ✅",
          autoCloseMs: 900,
        });
      } else {
        updateSwalProgress({
          titulo: "Importación terminada (con advertencias)",
          icon: "warning",
          loading: false,
          filasProcesadas: totalFilas,
          totalFilas,
          importadas: nuevosCampos.length,
          omitidas,
          ultimosErrores: erroresImportacion,
          footer:
            "Las filas con cliente no encontrado fueron omitidas. Proveedores no encontrados se dejaron en null.",
          autoCloseMs: 0,
        });
      }

      // ✅ LIMPIA INPUT SIEMPRE al final
      if (inputEl) inputEl.value = "";
    } catch (err) {
      updateSwalProgress({
        titulo: "Error al procesar el archivo",
        icon: "error",
        loading: false,
        ultimosErrores: [
          "Hubo un error al leer/procesar el Excel.",
          err?.message ? `Detalle: ${err.message}` : "Sin detalle del error.",
        ],
      });
      console.error(err);
      if (inputEl) inputEl.value = "";
    }
  };

  reader.onerror = (err) => {
    updateSwalProgress({
      titulo: "Error al leer el archivo",
      icon: "error",
      loading: false,
      ultimosErrores: [
        "FileReader no pudo leer el archivo.",
        err?.message ? `Detalle: ${err.message}` : "Sin detalle del error.",
      ],
    });
    console.error(err);
    if (inputEl) inputEl.value = "";
  };

  reader.readAsArrayBuffer(file);
}


const authHeaders = () => ({
  headers: { Authorization: `Bearer ${localStorage.getItem("app_token")}` },
});
console.log("hola", inputFieldsContenedores)
const saveContenedoresArchivo = async () => {
  setValidaBoton(false);
  toggleProgreso();

  try {
    const rows = (inputFieldsContenedores || []).filter(
      (r) => r.referencia && r.referencia.toString().trim() !== ""
    );

    await Promise.all(
      rows.map((r) =>
        axios.post(
          URL_CONTENEDORES,
          {
           fecha: r.fecha || fecha,
fechaCita: r.fechaCita || fechaCita,

            diasLibresDemoras: r.diasLibresDemoras ?? diasLibresDemoras,
            custodia: r.custodia || custodia,

            // ✅ IDs por fila (fallback si no viene en Excel)
            navieras: r.idNaviera ?? selectedNaviera,
clientes: r.idCliente ?? selectedCliente,
agencias: r.idAgencia ?? selectedAgencia,
agentes: r.idAgente ?? selectedAgente,
comisionistas: r.idComisionista ?? selectedComisionista,
transportistas: r.idTransportista ?? selectedTransportista,
forwarders: r.idForwarder ?? selectedForwarder,
            numeroInterno: "NA",
            contenedor: r.contenedor || "",

etaEstimada: r.fechaETA,
etaReal: r.fechaETA,

            totalGastos: 0,
            totalGeneral: 0,
            totalCantidad: 0,
            totalCargos: 0,

            observaciones: r.observaciones || observaciones,

            puerto: r.puerto || puerto,
            puertoOrigen: r.puertoOrigen || puertoOrigen,
            numeroBl: r.numeroBl || numeroBl,
            modalidad: r.modalidad || modalidad,
            direccionEntrega: r.direccionEntrega || "NA",

            // si estos siguen fijos, déjalos hardcode como ya los tienes:
            terminales: "659751b809da69446cc05f3d",
            programas: "65984b7d111f341061f6c353",
            patentes: "66db35dea6b7de33346cd392",

            asegurado: "No",
            // asegurado: r.asegurado || asegurado,
            rastreo: "No",
            pesoTotal: 0,

            // si usas referencia en el backend, asegúrate de mandarla:
          },
          authHeaders()
        )
      )
    );

    await axios.post(
      URL_LOGS,
      { tipo: "Subir Contenedores", detalle: "Varios", user: user.id },
      authHeaders()
    );

    Swal.fire("Good job!", "Creado con éxito", "success");
    setTimeout(() => window.location.reload(), 1000);
  } catch (error) {
    Swal.fire({ icon: "error", title: "Oops...", text: "Something went wrong!" });
    console.log(error);
    setValidaBoton(true);
  }
};
  function editContenedores(event) {
    event.preventDefault();
    const URL_CONTENEDORES_EDIT = `${process.env.REACT_APP_URL_CONTENEDORES}/${idEdit}`;

    axios
      .patch(
        URL_CONTENEDORES_EDIT,
        {
          fecha,
          fechaCita,
          diasLibresDemoras,
          custodia,
          navieras: selectedNavieraEdit,
          clientes: selectedClienteEdit,
          agentes: selectedAgenteEdit,
          agencias: selectedAgenciaEdit,
          comisionistas: selectedComisionistaEdit,
          transportistas: selectedTransportistaEdit,
          forwarders: selectedForwarderEdit,
          observaciones,
          observacionesInternas,
          numeroInterno,
          contenedor,
          // etaEstimada: fechaETAEstimada,
          etaReal: fechaETAReal,
          puerto,
          terminales: selectedTerminal,
          pedimento,
          modalidad,
          asegurado,
          direccionEntrega,
          programas: selectedPrograma,
          patentes: selectedPatente,
          numeroBl,
          puertoOrigen,
          pesoTotal
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem('app_token')}`,
          },
        }
      )
      .then(() => {
        axios.post(
          URL_LOGS,
          {
            tipo: 'Editar Contenedor',
            detalle: `${numeroContenedor} ${fecha}`,
            user: user.id,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem('app_token')}`,
            },
          }
        ).then(() => {
          toggleEdit();
          Swal.fire('Good job!', 'Actualizado con exito', 'success');
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        })
        .catch((error) => {
          console.log(error);
        });


      })
      .catch((error) => {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Something went wrong!',
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  }

  const headers = [
    { name: `${t('No. Interno')}`, field: 'numeroInterno', sortable: true },
    { name: `${t('ETA')}`, field: 'etaReal', sortable: true },
    { name: `${t('Contenedor')}`, field: 'contenedor', sortable: true },
    { name: `${t('Numero BL')}`, field: 'numeroBl', sortable: true },
    { name: `${t('Dias Libres')}`, field: 'diasLibresDemoras', sortable: true },
    { name: `${t('Demoras Cobrables')}`, field: 'diasDemorasCobrables', sortable: true },
    { name: `${t('Almacenajes Cobrables')}`, field: 'diasAlmacenajesCobrables', sortable: true },
    { name: `${t('Naviera')}`, field: 'navieras', sortable: true },
    { name: `${t('Forwarder')}`, field: 'forwarders', sortable: true },
    { name: `${t('Agencia')}`, field: 'agencias', sortable: true },
    { name: `${t('Comisionista')}`, field: 'comisionistas', sortable: true },
    { name: `${t('Agente Aduanal')}`, field: 'agentes', sortable: true },
    { name: `${t('Modalidad')}`, field: 'modalidad', sortable: true },
    { name: `${t('Custodia')}`, field: 'custodia', sortable: true },
    { name: `${t('Fecha Cita')}`,
      field: 'fechaCita',
      sortable: true,
      sortFunction: (rowA, rowB) => {
        const fechaA = rowA.fechaCita;
        const fechaB = rowB.fechaCita;
    
        // Si ambos están vacíos, se consideran iguales
        if (!fechaA && !fechaB) return 0;
        // Si uno está vacío, lo ubicamos al final (o al inicio, según lo que necesites)
        if (!fechaA) return 1;
        if (!fechaB) return -1;
    
        // Si ambos tienen valor, convertimos a fecha y comparamos
        return new Date(fechaA) - new Date(fechaB);
      }
    },
    { name: `${t('Status')}`, field: 'status', sortable: false },
    { name: `${t('Transportista')}`, field: 'transportistas', sortable: false },
    {
      name: `${t('Entrega Cliente')}`,
      field: 'entregaCliente',
      sortable: true,
    },
    { name: `${t('Retorno')}`, field: 'retornoVacio', sortable: true },
    // { name: `${t('Cliente')}`, field: 'clientes', sortable: true },
    { name: `${t('Archivos')}`, field: 'archivos', sortable: false },
    { name: `${t('Acciones')}`, field: 'acciones', sortable: false },
  ];

  const commentsData = useMemo(() => {
    let computedComments = comments;

    if (search) {
      computedComments = computedComments.filter(
        (comment) =>
          comment.numeroInterno.toLowerCase().includes(search.toLowerCase()) ||
          comment.contenedor.toLowerCase().includes(search.toLowerCase()) ||
          comment.numeroBl.toLowerCase().includes(search.toLowerCase()) ||
          comment.navieras.toLowerCase().includes(search.toLowerCase()) ||
          comment.clientes.toLowerCase().includes(search.toLowerCase()) ||
          comment.agentes.toLowerCase().includes(search.toLowerCase()) ||
          comment.agencias.toLowerCase().includes(search.toLowerCase()) ||
          comment.comisionistas.toLowerCase().includes(search.toLowerCase()) ||
          comment.transportistas.toLowerCase().includes(search.toLowerCase()) ||
          comment.status.toLowerCase().includes(search.toLowerCase()) ||
          comment.forwarders.toLowerCase().includes(search.toLowerCase()) ||
          comment.modalidad.toLowerCase().includes(search.toLowerCase()) ||
          comment.custodia.toLowerCase().includes(search.toLowerCase()) ||
          comment.totalCantidad.toString().includes(search) ||
          comment.totalGeneral.toString().includes(search) ||
          comment.diasLibresDemoras.toString().includes(search) ||
          comment.diasDemorasCobrables.toString().includes(search) ||
          comment.diasAlmacenajesCobrables.toString().includes(search) ||
          comment.numero.toString().includes(search)
      );
    }
    if (selectedNaviera) {
      computedComments = computedComments.filter((e) =>
        e.idNavieras.includes(selectedNaviera)
      );
    }

    if (selectedCliente) {
      computedComments = computedComments.filter((e) =>
        e.idClientes.includes(selectedCliente)
      );
    }

    if (selectedAgente) {
      computedComments = computedComments.filter((e) =>
        e.idAgentes.includes(selectedAgente)
      );
    }

    if (selectedAgencia) {
      computedComments = computedComments.filter((e) =>
        e.idAgencias.includes(selectedAgencia)
      );
    }

    if (selectedComisionista) {
      computedComments = computedComments.filter((e) =>
        e.idComisionistas.includes(selectedComisionista)
      );
    }

    if (selectedTransportista) {
      computedComments = computedComments.filter((e) =>
        e.idTransportistas.includes(selectedTransportista)
      );
    }

    if (selectedForwarder) {
      computedComments = computedComments.filter((e) =>
        e.idForwarders.includes(selectedForwarder)
      );
    }

    if (selectedPuerto) {
      computedComments = computedComments.filter((e) =>
        e.puerto.includes(selectedPuerto)
      );
    }

    if (selectedModalidad) {
      computedComments = computedComments.filter((e) =>
        e.modalidad.includes(selectedModalidad)
      );
    }
    if (selectedAsegurado) {
      computedComments = computedComments.filter((e) =>
        e.asegurado.includes(selectedAsegurado)
      );
    }

    if (selectedStatus) {
      computedComments = computedComments.filter((e) =>
        e.status.includes(selectedStatus)
      );
    }

    if (selectedFechaInicio) {
      computedComments = computedComments.filter(
        (e) => e.fecha >= selectedFechaInicio
      );
    }

    if (selectedFechaFin) {
      computedComments = computedComments.filter(
        (e) => e.fecha <= selectedFechaFin
      );
    }
    if (selectedFechaCitaInicio) {
      computedComments = computedComments.filter(
        (e) => e.fechaCita >= selectedFechaCitaInicio
      );
    }

    if (selectedFechaCitaFin) {
      computedComments = computedComments.filter(
        (e) => e.fechaCita <= selectedFechaCitaFin
      );
    }
    if (selectedPendiente) {
      computedComments = computedComments.filter((e) =>
        e.entregaCliente.includes(selectedPendiente)
      );
    }

    if (selectedActivo) {
      computedComments = computedComments.filter((e) =>
        e.activo.includes(selectedActivo)
      );
    }


    setTotalItems(computedComments.length);

    //Sorting comments
    if (
      sorting.field &&
      sorting.field != 'totalCantidad' &&
      sorting.field != 'totalGeneral' &&
      sorting.field != 'diasLibresDemoras' &&
      sorting.field != 'diasDemorasCobrables' &&
      sorting.field != 'diasAlmacenajesCobrables' &&
      sorting.field != 'numero'
    ) {
      const reversed = sorting.order === 'asc' ? 1 : -1;
      computedComments = computedComments.sort(
        (a, b) => reversed * a[sorting.field].localeCompare(b[sorting.field])
      );
    }

    if (
      sorting.field &&
      sorting.order === 'asc' &&
      (sorting.field == 'totalCantidad' ||
        sorting.field == 'totalGeneral' ||
        sorting.field == 'diasLibresDemoras' ||
        sorting.field == 'diasDemorasCobrables' ||
        sorting.field == 'diasAlmacenajesCobrables' ||
        sorting.field == 'numero')
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) > parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    if (
      sorting.field &&
      sorting.order === 'desc' &&
      (sorting.field == 'totalCantidad' ||
        sorting.field == 'totalGeneral' ||
        sorting.field == 'diasLibresDemoras' ||
        sorting.field == 'diasDemorasCobrables' ||        
        sorting.field == 'diasAlmacenajesCobrables' ||
        sorting.field == 'numero')
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) < parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    //Current Page slice
    return computedComments.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
  }, [
    comments,
    currentPage,
    search,
    sorting,
    selectedFechaInicio,
    selectedFechaFin,
    selectedFechaCitaInicio,
    selectedFechaCitaFin,
    selectedNaviera,
    selectedCliente,
    selectedAgente,
    selectedAgencia,
    selectedComisionista,
    selectedTransportista,
    selectedForwarder,
    selectedPuerto,
    selectedModalidad,
    selectedAsegurado,
    selectedStatus,
    selectedPendiente,
    selectedActivo
  ]);

  async function EditArticulos(idOC, numeroContenedor) {
    setInputFields([
      {
        id: uuidv4(),
        articulos: '',
        descripcion: '',
        cantidad: 0,
        precio: 0,
        total: 0,
      },
    ]);
    setIdEdit(idOC);
    setNumeroContenedor(numeroContenedor);
    await axios
      .get(`${URL_ARTICULOS_CONTENEDOR}/contenedor/${idOC}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem('app_token')}`,
        },
      })
      .then((response) => {
        let allArticulosContenedor = response.data;
        let arrayTabla = allArticulosContenedor
          .map((a) => {
            return {
              id: a._id,
              articulos: a.articulos[0]._id,
              cantidad: a.cantidad,
              descripcion: a.descripcion,
              precio: a.precio,
              total: a.total,
            };
          })
          .filter(function (el) {
            return el != null;
          });
        let dataFinal = Object.values(arrayTabla);
        setArticulosContenedor(dataFinal);

        let cant = dataFinal.map((c) => parseFloat(c.cantidad));
        let TC = cant.reduce((t, total, index) => t + total, 0);
        setTotalCantidadEdit(TC);
        let importes = dataFinal.map((c) => parseFloat(c.total));
        let TG = importes.reduce((t, total, index) => t + total, 0);
        setTotalGeneralEdit(TG);
      })
      .catch((err) => {
        console.log(err);
      });
    toggleEditArticulos();
  }

  const handleChangeInputExistentes = (id, event) => {
    const newArticulosContenedor = articulosContenedor.map((i) => {
      if (id === i.id) {
        i[event.target.name] = event.target.value;
        let totalParcial = i.cantidad * i.precio;
        i.total = totalParcial;
      }
      return i;
    });
    setArticulosContenedor(newArticulosContenedor);
    ActualizaTotales();
  };

  const handleChangeInputExistentesCantidad = (id, event) => {
    const newArticulosContenedor = articulosContenedor.map((i) => {
      if (id === i.id) {
        i[event.target.name] = event.target.value;
        let totalParcial = i.cantidad * i.precio;
        i.total = totalParcial;
      }
      return i;
    });
    setArticulosContenedor(newArticulosContenedor);
    ActualizaTotales();
  };

  function BuscaArticuloExistentes(id, event) {
    articulos.map((a) => {
      if (a._id == event.target.value) {
        let idArticulo = a._id;
        handleChangeInputExistentesArticulo(id, idArticulo);
      }
    });
  }

  const handleChangeInputExistentesArticulo = (id, idArticulo) => {
    const newArticulosContenedor = articulosContenedor.map((i) => {
      if (id === i.id) {
        i.articulos = idArticulo;
        let totalParcial = i.cantidad * i.precio;
        i.total = totalParcial;
      }
      return i;
    });
    setArticulosContenedor(newArticulosContenedor);
    ActualizaTotales();
  };

  const handleAddFields = () => {
    const ultimo = inputFields[inputFields.length - 1];
    setInputFields([
      ...inputFields,
      {
        id: uuidv4(),
        articulos: ultimo.articulos,
        cantidad: 0,
        precio: ultimo.precio,
        total: 0,
      },
    ]);
  };

  const handleRemoveFields = (id) => {
    const values = [...inputFields];
    values.splice(
      values.findIndex((value) => value.id === id),
      1
    );
    setInputFields(values);
    let cantidadExistentes = articulosContenedor.map((c) =>
      parseFloat(c.cantidad)
    );
    let cantidadNuevos = values.map((c) => parseFloat(c.cantidad));
    let cantidad = cantidadExistentes.concat(cantidadNuevos);
    let TC = cantidad.reduce((t, total, index) => t + total, 0);
    setTotalCantidadEdit(TC);

    let importesExistentes = articulosContenedor.map((c) =>
      parseFloat(c.total)
    );
    let importesNuevos = values.map((c) => parseFloat(c.total));
    let importes = importesExistentes.concat(importesNuevos);
    let TG = importes.reduce((t, total, index) => t + total, 0);
    setTotalGeneralEdit(TG);
  };

  const handleChangeInput = (id, event) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i[event.target.name] = event.target.value;
        let totalParcial = i.cantidad * i.precio;
        i.total = totalParcial;
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales();
  };

  function BuscaArticulo(id, event) {
    articulos.map((a) => {
      if (a._id == event.target.value) {
        let idArticulo = a._id;
        handleChangeInputArticulo(id, idArticulo);
      }
    });
  }

  const handleChangeInputArticulo = (id, idArticulo) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i.articulos = idArticulo;
        let totalParcial = i.cantidad * i.precio;
        i.total = totalParcial;
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales();
  };

  function ActualizaTotales() {
    let cantidadExistentes = articulosContenedor.map((c) =>
      parseFloat(c.cantidad)
    );
    let cantidadNuevos = inputFields.map((c) => parseFloat(c.cantidad));
    let cantidad = cantidadExistentes.concat(cantidadNuevos);
    let TC = cantidad.reduce((t, total, index) => t + total, 0);
    setTotalCantidadEdit(TC);

    let importesExistentes = articulosContenedor.map((c) =>
      parseFloat(c.total)
    );
    let importesNuevos = inputFields.map((c) => parseFloat(c.total));
    let importes = importesExistentes.concat(importesNuevos);
    let TG = importes.reduce((t, total, index) => t + total, 0);
    setTotalGeneralEdit(TG);
  }

  const saveContenedor = async (event) => {
    event.preventDefault();
    toggleProgreso();

    let totalArticulos = inputFields.length + articulosContenedor.length;

    const URL_CONTENEDORES_EDIT = `${process.env.REACT_APP_URL_CONTENEDORES}/${idEdit}`;
    try {
      await axios
        .patch(
          URL_CONTENEDORES_EDIT,
          {
            totalGeneral: totalGeneral_edit,
            totalCantidad: totalCantidad_edit,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem('app_token')}`,
            },
          }
        )
        .then(() => {
          inputFields.map((a) => {
            if (a.articulos != '' && a.cantidad > 0) {
              axios
                .post(
                  URL_ARTICULOS_CONTENEDOR,
                  {
                    contenedores: idEdit,
                    articulos: a.articulos,
                    descripcion: a.descripcion,
                    cantidad: parseFloat(a.cantidad),
                    precio: parseFloat(a.precio),
                    total: parseFloat(a.total),
                  },
                  {
                    headers: {
                      Authorization: `Bearer: ${localStorage.getItem(
                        'app_token'
                      )}`,
                    },
                  }
                )
                .then(() => {
                  totalArticulos = totalArticulos - 1;
                  if (totalArticulos == 0) {
                    axios
                      .post(
                        URL_LOGS,
                        {
                          tipo: 'Editar Contenedor',
                          detalle: `${numeroContenedor}`,
                          user: user.id,
                        },
                        {
                          headers: {
                            Authorization: `Bearer: ${localStorage.getItem(
                              'app_token'
                            )}`,
                          },
                        }
                      )
                      .then(() => {
                        Swal.fire('Good job!', 'Creado con exito', 'success');
                        setTimeout(() => {
                          window.location.reload();
                        }, 1000);
                      })
                      .catch((error) => {
                        Swal.fire({
                          icon: 'error',
                          title: 'Oops...',
                          text: 'Something went wrong!',
                          footer: `${error.response.data}`,
                        });
                        console.log(error);
                      });
                  }
                })
                .catch((error) => {
                  Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: 'Something went wrong!',
                    footer: `${error.response.data}`,
                  });
                  console.log(error);
                });
              // cerrar if
            } else {
              totalArticulos = totalArticulos - 1;
              if (totalArticulos == 0) {
                axios
                  .post(
                    URL_LOGS,
                    {
                      tipo: 'Editar Contenedor',
                      detalle: `${numeroContenedor}`,
                      user: user.id,
                    },
                    {
                      headers: {
                        Authorization: `Bearer: ${localStorage.getItem(
                          'app_token'
                        )}`,
                      },
                    }
                  )
                  .then(() => {
                    Swal.fire('Good job!', 'Creado con exito', 'success');
                    setTimeout(() => {
                      window.location.reload();
                    }, 1000);
                  })
                  .catch((error) => {
                    Swal.fire({
                      icon: 'error',
                      title: 'Oops...',
                      text: 'Something went wrong!',
                      footer: `${error.response.data}`,
                    });
                    console.log(error);
                  });
              }
            }
          });

          articulosContenedor.map((a) => {
            axios
              .patch(
                `${URL_ARTICULOS_CONTENEDOR}/${a.id}`,
                {
                  articulos: a.articulos,
                  cantidad: parseFloat(a.cantidad),
                  precio: parseFloat(a.precio),
                  total: parseFloat(a.total),
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem(
                      'app_token'
                    )}`,
                  },
                }
              )
              .then(() => {
                totalArticulos = totalArticulos - 1;
                if (totalArticulos == 0) {
                  axios
                    .post(
                      URL_LOGS,
                      {
                        tipo: 'Editar Contenedor',
                        detalle: `${numeroContenedor}`,
                        user: user.id,
                      },
                      {
                        headers: {
                          Authorization: `Bearer: ${localStorage.getItem(
                            'app_token'
                          )}`,
                        },
                      }
                    )
                    .then(() => {
                      Swal.fire('Good job!', 'Creado con exito', 'success');
                      setTimeout(() => {
                        window.location.reload();
                      }, 1000);
                    })
                    .catch((error) => {
                      Swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: 'Something went wrong!',
                        footer: `${error.response.data}`,
                      });
                      console.log(error);
                    });
                }
              })
              .catch((error) => {
                Swal.fire({
                  icon: 'error',
                  title: 'Oops...',
                  text: 'Something went wrong!',
                  footer: `${error.response.data}`,
                });
                console.log(error);
              });
          });
        })
        .catch((error) => {
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'Something went wrong!',
            footer: `${error.response.data}`,
          });
          console.log(error);
        });
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'Something went wrong!',
        footer: `${error.response.data}`,
      });
      console.log(error);
    }
  };

  function EditStatus(
    id,
    bl,
    pl,
    factura,
    numeroInterno,
    documentos,
    telex,
    toquePiso,
    revalidacion,
    fichaTecnica,
    pagoPedimento,
    modulacion,
    retornoVacio,
    salidaPuerto,
    salidaRuta,
    // maniobras,
    entregaCliente,
    status,
    fechaEntradaPuerto,
    fechaDocumentos,
    fechaTelex,
    fechaToquePiso,
    fechaRevalidacion,
    fechaFichaTecnica,
    fechaPagoPedimento,
    fechaModulacion,
    fechaRetornoVacio,
    fechaSalidaPuerto,
    fechaSalidaRuta,
    // fechaManiobras,
    fechaEntregaCliente,
    fechaFactura,
    fechaBl,
    fechaPl
  ) {
    setid(id);
    setbl(bl);
    setpl(pl);
    setfactura(factura);
    setnumeroInterno(numeroInterno);
    setdocumentos(documentos);
    settelex(telex);
    settoquePiso(toquePiso);
    setrevalidacion(revalidacion);
    setfichaTecnica(fichaTecnica);
    setpagoPedimento(pagoPedimento);
    setmodulacion(modulacion);
    setretornoVacio(retornoVacio);
    setsalidaPuerto(salidaPuerto);
    setsalidaRuta(salidaRuta);
    // setmaniobras(maniobras)
    setentregaCliente(entregaCliente);
    setstatus(status);
    setfechaEntradaPuerto(fechaEntradaPuerto);
    setfechaDocumentos(fechaDocumentos);
    setfechaTelex(fechaTelex);
    setfechaToquePiso(fechaToquePiso);
    setfechaRevalidacion(fechaRevalidacion);
    setfechaFichaTecnica(fechaFichaTecnica);
    setfechaPagoPedimento(fechaPagoPedimento);
    setfechaModulacion(fechaModulacion);
    setfechaRetornoVacio(fechaRetornoVacio);
    setfechaSalidaPuerto(fechaSalidaPuerto);
    setfechaSalidaRuta(fechaSalidaRuta);
    // setfechaManiobras(fechaManiobras)
    setfechaEntregaCliente(fechaEntregaCliente);
    setfechaFactura(fechaFactura);
    setfechaBl(fechaBl);
    setfechaPl(fechaPl);
    toggleStatus();
  }

  function updateStatus(property, value, nombreFecha, fechaS) {
    if (fechaS == '' || fechaS == undefined) {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'La fecha no puede estar vacia',
      });
    } else {
      const data = {
        [property]: value,
        [nombreFecha]: fechaS,
        status,
      };

      axios
        .patch(`${URL_CONTENEDORES}/${id}`, data, {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem('app_token')}`,
          },
        })
        .then(() => {
          Swal.fire({
            position: 'center',
            icon: 'success',
            title: 'Actualizado con Exito',
            showConfirmButton: false,
            timer: 2000,
          });

          let temp = comments.map((a) => {
            if (a._id === id) {
              a[nombreFecha] = fechaS;
              a[property] = value;
              a.status = status;
            }
            return a;
          });
          setComments(temp);
        //     setTimeout(() => {
        //   window.location.reload();
        // }, 1000);
        })
        .catch((error) => {
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'Something went wrong!',
            footer: `${error.response.data}`,
          });
          console.log(error);
        });
    }
  }

  function updateOnlyStatus() {
    axios
      .patch(
        `${URL_CONTENEDORES}/${id}`,
        {
          status,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem('app_token')}`,
          },
        }
      )
      .then(() => {
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: 'Actualizado con Exito',
          showConfirmButton: false,
          timer: 2000,
        });

        let temp = comments.map((a) => {
          if (a._id === id) {
            a.status = status;
          }
          return a;
        });
        setComments(temp);

        setTimeout(() => {
          setModalStatus(false);
        }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Something went wrong!',
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  }

  const calcula = (e) => {
    setTotalUSD(e);
    setTotal(parseFloat(e) * parseFloat(tipoCambio));
  };

  const calculaTipoCambio = (e) => {
    setTipoCambio(e);
    setTotal(parseFloat(totalUSD) * parseFloat(e));
  };

  function saveGasto() {
    setValidaBoton(false);
    axios
      .post(
        URL_GASTOS_CONTENEDOR,
        {
          fecha: fechaGasto,
          totalUSD,
          tipoCambio,
          total,
          abonos: 0,
          saldo: total,
          descripcion,
          conceptosGastos: selectedConcepto,
          contenedores: selectedContenedor,
          proveedores: selectedProveedor,
          clientes: selectedClienteGasto,
          moneda,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem('app_token')}`,
          },
        }
      )
      .then(() => {
        axios.post(
          URL_LOGS,
          {
            tipo: 'Crear Gasto',
            detalle: `Fecha: ${fecha} / Concepto: ${selectedConcepto} / Total: ${total} `,
            user: user.id,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem('app_token')}`,
            },
          }
        );
        Swal.fire('Good job!', 'Creado con exito', 'success');
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Something went wrong!',
        });
        console.log(error);
        setValidaBoton(true);
      });
  }

  function saveCargo() {
    setValidaBoton(false);
    axios
      .post(
        URL_CARGOS_CONTENEDOR,
        {
          fecha: fechaGasto,
          totalUSD,
          tipoCambio,
          total,
          abonos: 0,
          saldo: total,
          descripcion,
          conceptosGastos: selectedConcepto,
          contenedores: selectedContenedor,
          clientes: selectedClienteGasto,
          moneda,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem('app_token')}`,
          },
        }
      )
      .then(() => {
        axios.post(
          URL_LOGS,
          {
            tipo: 'Crear Cargo',
            detalle: `Fecha: ${fecha} / Concepto: ${selectedConcepto} / Total: ${total} `,
            user: user.id,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem('app_token')}`,
            },
          }
        );
        Swal.fire('Good job!', 'Creado con exito', 'success');
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Something went wrong!',
        });
        console.log(error);
        setValidaBoton(true);
      });
  }

  function excelOC() {
    var option = {};

    option.fileName = numeroInterno;

    option.datas = [
      {
        sheetData: [
          {
            BL: fechaBl,
            PL: fechaPl,
            Factura: fechaFactura,
            FichaTecnica: fechaFichaTecnica,
            Telex: fechaTelex,
            ToquePiso: fechaToquePiso,
            Revalidacion: fechaRevalidacion,
            PagoPedimento: fechaPagoPedimento,
            Documentos: fechaDocumentos,
            Modulacion: fechaModulacion,
            SalidaPuerto: fechaSalidaPuerto,
            SalidaRuta: fechaSalidaRuta,
            // Maniobras: fechaManiobras,
            EntregaCliente: fechaEntregaCliente,
            RetornoVacio: fechaRetornoVacio,
          },
        ],
        sheetName: numeroInterno,
        sheetFilter: [
          'BL',
          'PL',
          'Factura',
          'FichaTecnica',
          'Telex',
          'ToquePiso',
          'Revalidacion',
          'PagoPedimento',
          'Documentos',
          'Modulacion',
          'SalidaPuerto',
          'SalidaRuta',
          // 'Maniobras',
          'EntregaCliente',
          'RetornoVacio',
        ],
        sheetHeader: [
          'BL',
          'PL',
          'Factura',
          'FichaTecnica',
          'Telex',
          'ToquePiso',
          'Revalidacion',
          'PagoPedimento',
          'Documentos',
          'Modulacion',
          'SalidaPuerto',
          'SalidaRuta',
          // 'Maniobras',
          'EntregaCliente',
          'RetornoVacio',
        ],
      },
    ];

    var toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel();
  }

//   async function registrarSG(id, naviera, contenedor) {

//     axios
//     .patch(
//       `${URL_CONTENEDORES}AltaRastreo/${id}`,
//       {
//         navieras: naviera,
//         contenedor: contenedor
//       },
//       {
//         headers: {
//           Authorization: `Bearer: ${localStorage.getItem(
//             'app_token'
//           )}`,
//         },
//       }
//     )
//     .then(() => {
//       Swal.fire('Good job!', 'Creado con exito', 'success');
//       setTimeout(() => {
//         window.location.reload();
//       }, 1000);
//     })
//     .catch((error) => {
//       Swal.fire({
//         icon: 'error',
//         title: 'Oops...',
//         text: 'Something went wrong!',
//         footer: `${error.response.data}`,
//       });
//       console.log(error);
//     });
    
//   }

//   function crearMapa(polLatitude,
//     polLongitude,
//     podLatitude,
//     podLongitude,
//     vesselLatitude,
//     vesselLongitude,
//     etaReal
//   ){

// const etaRealDate = new Date(etaReal)
// etaRealDate.setHours(0, 0, 0, 0);
// hoy.setHours(0, 0, 0, 0);
//   const diasDiferencia = Math.floor((Date.UTC(etaRealDate.getFullYear(), etaRealDate.getMonth(), etaRealDate.getDate()) - 
//                                    Date.UTC(hoy.getFullYear(), hoy.getMonth(), hoy.getDate())) / (1000 * 60 * 60 * 24));

//     setDiasLlegada(diasDiferencia)

//     setOriginCoords([polLatitude, polLongitude]);  // Ningbo, China (puerto de origen)
//     setVesselCoords([vesselLatitude, vesselLongitude]);  // Posición actual del barco
//     setDestinationCoords([podLatitude, podLongitude]);  // Lázaro Cárdenas, México (puerto de destino)
  
//     // Ruta con puntos intermedios
//     setCoordenadasMapa([
//       // [polLatitude, polLongitude], 
//       [vesselLatitude, vesselLongitude], 
//       [podLatitude, podLongitude],
//       // [30, 140],  // Punto intermedio 1 en el océano
//       // [40, -160],
//       // [20, -130],  // Punto intermedio 2 en el océano
//     ]);

//     toggleMapa()
//   }

  // Foto Packing
  function guardaFotosPacking() {
    file.map((a)=>{
    const formData = new FormData();
    formData.append("file", a); // El archivo puede ser imagen, PDF, o Excel
    formData.append("contenedor", idContenedor);
  
    axios
      .post(URL_UPMEDIA_PACKING, formData, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          "Content-Type": "multipart/form-data", // Asegura que el tipo de contenido sea correcto
        },
        params: {
          resource_type: "raw", // Para Cloudinary, permite la subida de archivos que no son imágenes
        },
      })
      .then((response) => {
        axios
          .patch(
            `${URL_CONTENEDORES}/${idContenedor}`,
            {
              packing: "Si",
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .then((response) => {
            axios
              .post(
                URL_LOGS,
                {
                  tipo: "Contenedor",
                  detalle: `Subir Foto`,
                  user: user.id,
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                  },
                }
              )
              .then((response) => {
                Swal.fire("Good job!", "Actualizado con éxito", "success");

                setPacking("Si");
                // setTimeout(() => {
                //   window.location.reload();
                // }, 1000);
              })
              .catch((error) => {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Something went wrong!",
                  footer: `${error.response.data}`,
                });
                console.log(error);
              });
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response.data}`,
            });
            console.log(error);
          });
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
    })
    setFile();
    setPhoto([]);
  }

  function jalaFotoPacking(idCont) {
    setPhoto([])
    const URL_GET_MEDIA = `${process.env.REACT_APP_URL_FINDMEDIABYTAG_PACKING}/${idCont}`;
    axios
      .get(URL_GET_MEDIA, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((data) => {
        setPhoto(data.data.resources);
      })
      .catch((err) => console.log(err));
    setIdContenedor(idCont);


    toggleFotoPacking();
  }

    // Foto BL
    function guardaFotosBL() {
      file.map((a)=>{
      const formData = new FormData();
      formData.append("file", a); // El archivo puede ser imagen, PDF, o Excel
      formData.append("contenedor", idContenedor);
    
      axios
        .post(URL_UPMEDIA_BL, formData, {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            "Content-Type": "multipart/form-data", // Asegura que el tipo de contenido sea correcto
          },
          params: {
            resource_type: "raw", // Para Cloudinary, permite la subida de archivos que no son imágenes
          },
        })
        .then((response) => {
          axios
            .patch(
              `${URL_CONTENEDORES}/${idContenedor}`,
              {
                bl: "Si",
              },
              {
                headers: {
                  Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                },
              }
            )
            .then((response) => {
              axios
                .post(
                  URL_LOGS,
                  {
                    tipo: "Contenedor",
                    detalle: `Subir Foto`,
                    user: user.id,
                  },
                  {
                    headers: {
                      Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                    },
                  }
                )
                .then((response) => {
                  Swal.fire("Good job!", "Actualizado con éxito", "success");
                  setBlArchivo("Si");
                  // setTimeout(() => {
                  //   window.location.reload();
                  // }, 1000);
                })
                .catch((error) => {
                  Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: "Something went wrong!",
                    footer: `${error.response.data}`,
                  });
                  console.log(error);
                });
            })
            .catch((error) => {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Something went wrong!",
                footer: `${error.response.data}`,
              });
              console.log(error);
            });
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
            footer: `${error.response.data}`,
          });
          console.log(error);
        });
      })
      setFile();
      setPhoto([]);
    }
  
    function jalaFotoBL(idCont) {
      setPhoto([])
      const URL_GET_MEDIA = `${process.env.REACT_APP_URL_FINDMEDIABYTAG_BL}/${idCont}`;
      axios
        .get(URL_GET_MEDIA, {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        })
        .then((data) => {
          setPhoto(data.data.resources);
        })
        .catch((err) => console.log(err));
      setIdContenedor(idCont);
  
  
      toggleFotoBL();
    }

      // Foto Invoice
  function guardaFotosInvoice() {
    file.map((a)=>{
    const formData = new FormData();
    formData.append("file", a); // El archivo puede ser imagen, PDF, o Excel
    formData.append("contenedor", idContenedor);
  
    axios
      .post(URL_UPMEDIA_INVOICE, formData, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          "Content-Type": "multipart/form-data", // Asegura que el tipo de contenido sea correcto
        },
        params: {
          resource_type: "raw", // Para Cloudinary, permite la subida de archivos que no son imágenes
        },
      })
      .then((response) => {
        axios
          .patch(
            `${URL_CONTENEDORES}/${idContenedor}`,
            {
              invoice: "Si",
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .then((response) => {
            axios
              .post(
                URL_LOGS,
                {
                  tipo: "Contenedor",
                  detalle: `Subir Foto`,
                  user: user.id,
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                  },
                }
              )
              .then((response) => {
                Swal.fire("Good job!", "Actualizado con éxito", "success");
                setInvoice("Si");
                // setTimeout(() => {
                //   window.location.reload();
                // }, 1000);
              })
              .catch((error) => {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Something went wrong!",
                  footer: `${error.response.data}`,
                });
                console.log(error);
              });
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response.data}`,
            });
            console.log(error);
          });
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
    })
    setFile();
    setPhoto([]);
  }

  function jalaFotoInvoice(idCont) {
    setPhoto([])
    const URL_GET_MEDIA = `${process.env.REACT_APP_URL_FINDMEDIABYTAG_INVOICE}/${idCont}`;
    axios
      .get(URL_GET_MEDIA, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((data) => {
        setPhoto(data.data.resources);
      })
      .catch((err) => console.log(err));
    setIdContenedor(idCont);


    toggleFotoInvoice();
  }

        // Foto FichaTecnica
        function guardaFotosFichaTecnica() {
          file.map((a)=>{
          const formData = new FormData();
          formData.append("file", a); // El archivo puede ser imagen, PDF, o Excel
          formData.append("contenedor", idContenedor);
        
          axios
            .post(URL_UPMEDIA_FICHA_TECNICA, formData, {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                "Content-Type": "multipart/form-data", // Asegura que el tipo de contenido sea correcto
              },
              params: {
                resource_type: "raw", // Para Cloudinary, permite la subida de archivos que no son imágenes
              },
            })
            .then((response) => {
              axios
                .patch(
                  `${URL_CONTENEDORES}/${idContenedor}`,
                  {
                    fichaTecnicaArchivo: "Si",
                  },
                  {
                    headers: {
                      Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                    },
                  }
                )
                .then((response) => {
                  axios
                    .post(
                      URL_LOGS,
                      {
                        tipo: "Contenedor",
                        detalle: `Subir Foto`,
                        user: user.id,
                      },
                      {
                        headers: {
                          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                        },
                      }
                    )
                    .then((response) => {
                      Swal.fire("Good job!", "Actualizado con éxito", "success");
                      setFichaTecnicaArchivo("Si");
                      // setTimeout(() => {
                      //   window.location.reload();
                      // }, 1000);
                    })
                    .catch((error) => {
                      Swal.fire({
                        icon: "error",
                        title: "Oops...",
                        text: "Something went wrong!",
                        footer: `${error.response.data}`,
                      });
                      console.log(error);
                    });
                })
                .catch((error) => {
                  Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: "Something went wrong!",
                    footer: `${error.response.data}`,
                  });
                  console.log(error);
                });
            })
            .catch((error) => {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Something went wrong!",
                footer: `${error.response.data}`,
              });
              console.log(error);
            });
          })
          setFile();
          setPhoto([]);
        }
      
        function jalaFotoFichaTecnica(idCont) {
          setPhoto([])
          const URL_GET_MEDIA = `${process.env.REACT_APP_URL_FINDMEDIABYTAG_FICHA_TECNICA}/${idCont}`;
          axios
            .get(URL_GET_MEDIA, {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            })
            .then((data) => {
              setPhoto(data.data.resources);
            })
            .catch((err) => console.log(err));
          setIdContenedor(idCont);
      
      
          toggleFotoFichaTecnica();
        }


              // Foto Cargos Locales
  function guardaFotosCargosLocales() {
    file.map((a)=>{
    const formData = new FormData();
    formData.append("file", a); // El archivo puede ser imagen, PDF, o Excel
    formData.append("contenedor", idContenedor);
  
    axios
      .post(URL_UPMEDIA_CARGOS_LOCALES, formData, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          "Content-Type": "multipart/form-data", // Asegura que el tipo de contenido sea correcto
        },
        params: {
          resource_type: "raw", // Para Cloudinary, permite la subida de archivos que no son imágenes
        },
      })
      .then((response) => {
        axios
          .patch(
            `${URL_CONTENEDORES}/${idContenedor}`,
            {
              cargosLocales: "Si",
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .then((response) => {
            axios
              .post(
                URL_LOGS,
                {
                  tipo: "Contenedor",
                  detalle: `Subir Foto`,
                  user: user.id,
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                  },
                }
              )
              .then((response) => {
                Swal.fire("Good job!", "Actualizado con éxito", "success");
                setCargosLocales("Si");
                // setTimeout(() => {
                //   window.location.reload();
                // }, 1000);
              })
              .catch((error) => {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Something went wrong!",
                  footer: `${error.response.data}`,
                });
                console.log(error);
              });
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response.data}`,
            });
            console.log(error);
          });
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
    })
    setFile();
    setPhoto([]);
  }

  function jalaFotoCargosLocales(idCont) {
    setPhoto([])
    const URL_GET_MEDIA = `${process.env.REACT_APP_URL_FINDMEDIABYTAG_CARGOS_LOCALES}/${idCont}`;
    axios
      .get(URL_GET_MEDIA, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((data) => {
        setPhoto(data.data.resources);
      })
      .catch((err) => console.log(err));
    setIdContenedor(idCont);


    toggleFotoCargosLocales();
  }

        // Foto DODA
        function guardaFotosDODA() {
          file.map((a)=>{
          const formData = new FormData();
          formData.append("file", a); // El archivo puede ser imagen, PDF, o Excel
          formData.append("contenedor", idContenedor);
        
          axios
            .post(URL_UPMEDIA_DODA, formData, {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                "Content-Type": "multipart/form-data", // Asegura que el tipo de contenido sea correcto
              },
              params: {
                resource_type: "raw", // Para Cloudinary, permite la subida de archivos que no son imágenes
              },
            })
            .then((response) => {
              axios
                .patch(
                  `${URL_CONTENEDORES}/${idContenedor}`,
                  {
                    DODA: "Si",
                  },
                  {
                    headers: {
                      Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                    },
                  }
                )
                .then((response) => {
                  axios
                    .post(
                      URL_LOGS,
                      {
                        tipo: "Contenedor",
                        detalle: `Subir Foto`,
                        user: user.id,
                      },
                      {
                        headers: {
                          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                        },
                      }
                    )
                    .then((response) => {
                      Swal.fire("Good job!", "Actualizado con éxito", "success");
                      setDODA("Si");
                      // PackingsetTimeout(() => {
                      //   window.location.reload();
                      // }, 1000);
                    })
                    .catch((error) => {
                      Swal.fire({
                        icon: "error",
                        title: "Oops...",
                        text: "Something went wrong!",
                        footer: `${error.response.data}`,
                      });
                      console.log(error);
                    });
                })
                .catch((error) => {
                  Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: "Something went wrong!",
                    footer: `${error.response.data}`,
                  });
                  console.log(error);
                });
            })
            .catch((error) => {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Something went wrong!",
                footer: `${error.response.data}`,
              });
              console.log(error);
            });
          })
          setFile();
          setPhoto([]);
        }
      
        function jalaFotoDODA(idCont) {
          setPhoto([])
          const URL_GET_MEDIA = `${process.env.REACT_APP_URL_FINDMEDIABYTAG_DODA}/${idCont}`;
          axios
            .get(URL_GET_MEDIA, {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            })
            .then((data) => {
              setPhoto(data.data.resources);
            })
            .catch((err) => console.log(err));
          setIdContenedor(idCont);
      
      
          toggleFotoDODA();
        }

              // Foto Boleta
  function guardaFotosBoleta() {
    file.map((a)=>{
    const formData = new FormData();
    formData.append("file", a); // El archivo puede ser imagen, PDF, o Excel
    formData.append("contenedor", idContenedor);
  
    axios
      .post(URL_UPMEDIA_BOLETA, formData, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          "Content-Type": "multipart/form-data", // Asegura que el tipo de contenido sea correcto
        },
        params: {
          resource_type: "raw", // Para Cloudinary, permite la subida de archivos que no son imágenes
        },
      })
      .then((response) => {
        axios
          .patch(
            `${URL_CONTENEDORES}/${idContenedor}`,
            {
              boleta: "Si",
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .then((response) => {
            axios
              .post(
                URL_LOGS,
                {
                  tipo: "Contenedor",
                  detalle: `Subir Foto`,
                  user: user.id,
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                  },
                }
              )
              .then((response) => {
                Swal.fire("Good job!", "Actualizado con éxito", "success");
                setBoleta("Si");
                // setTimeout(() => {
                //   window.location.reload();
                // }, 1000);
              })
              .catch((error) => {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Something went wrong!",
                  footer: `${error.response.data}`,
                });
                console.log(error);
              });
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response.data}`,
            });
            console.log(error);
          });
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
    })
    setFile();
    setPhoto([]);
  }

  function jalaFotoBoleta(idCont) {
    setPhoto([])
    const URL_GET_MEDIA = `${process.env.REACT_APP_URL_FINDMEDIABYTAG_BOLETA}/${idCont}`;
    axios
      .get(URL_GET_MEDIA, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((data) => {
        setPhoto(data.data.resources);
      })
      .catch((err) => console.log(err));
    setIdContenedor(idCont);


    toggleFotoBoleta();
  }

        // Foto Prealta
        function guardaFotosPrealta() {
          file.map((a)=>{
          const formData = new FormData();
          formData.append("file", a); // El archivo puede ser imagen, PDF, o Excel
          formData.append("contenedor", idContenedor);
        
          axios
            .post(URL_UPMEDIA_PREALTA, formData, {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                "Content-Type": "multipart/form-data", // Asegura que el tipo de contenido sea correcto
              },
              params: {
                resource_type: "raw", // Para Cloudinary, permite la subida de archivos que no son imágenes
              },
            })
            .then((response) => {
              axios
                .patch(
                  `${URL_CONTENEDORES}/${idContenedor}`,
                  {
                    prealta: "Si",
                  },
                  {
                    headers: {
                      Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                    },
                  }
                )
                .then((response) => {
                  axios
                    .post(
                      URL_LOGS,
                      {
                        tipo: "Contenedor",
                        detalle: `Subir Foto`,
                        user: user.id,
                      },
                      {
                        headers: {
                          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                        },
                      }
                    )
                    .then((response) => {
                      Swal.fire("Good job!", "Actualizado con éxito", "success");
                      setPrealta("Si");
                      // setTimeout(() => {
                      //   window.location.reload();
                      // }, 1000);
                    })
                    .catch((error) => {
                      Swal.fire({
                        icon: "error",
                        title: "Oops...",
                        text: "Something went wrong!",
                        footer: `${error.response.data}`,
                      });
                      console.log(error);
                    });
                })
                .catch((error) => {
                  Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: "Something went wrong!",
                    footer: `${error.response.data}`,
                  });
                  console.log(error);
                });
            })
            .catch((error) => {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Something went wrong!",
                footer: `${error.response.data}`,
              });
              console.log(error);
            });
          })
          setFile();
          setPhoto([]);
        }
      
        function jalaFotoPrealta(idCont) {
          setPhoto([])
          const URL_GET_MEDIA = `${process.env.REACT_APP_URL_FINDMEDIABYTAG_PREALTA}/${idCont}`;
          axios
            .get(URL_GET_MEDIA, {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            })
            .then((data) => {
              setPhoto(data.data.resources);
            })
            .catch((err) => console.log(err));
          setIdContenedor(idCont);
      
      
          toggleFotoPrealta();
        }

              // Foto EIR
  function guardaFotosEIR() {
    file.map((a)=>{
    const formData = new FormData();
    formData.append("file", a); // El archivo puede ser imagen, PDF, o Excel
    formData.append("contenedor", idContenedor);
  
    axios
      .post(URL_UPMEDIA_EIR, formData, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          "Content-Type": "multipart/form-data", // Asegura que el tipo de contenido sea correcto
        },
        params: {
          resource_type: "raw", // Para Cloudinary, permite la subida de archivos que no son imágenes
        },
      })
      .then((response) => {
        axios
          .patch(
            `${URL_CONTENEDORES}/${idContenedor}`,
            {
              EIR: "Si",
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .then((response) => {
            axios
              .post(
                URL_LOGS,
                {
                  tipo: "Contenedor",
                  detalle: `Subir Foto`,
                  user: user.id,
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                  },
                }
              )
              .then((response) => {
                Swal.fire("Good job!", "Actualizado con éxito", "success");
                setEIR("Si");
                // setTimeout(() => {
                //   window.location.reload();
                // }, 1000);
              })
              .catch((error) => {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Something went wrong!",
                  footer: `${error.response.data}`,
                });
                console.log(error);
              });
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response.data}`,
            });
            console.log(error);
          });
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
    })
    setFile();
    setPhoto([]);
  }

  function jalaFotoEIR(idCont) {
    setPhoto([])
    const URL_GET_MEDIA = `${process.env.REACT_APP_URL_FINDMEDIABYTAG_EIR}/${idCont}`;
    axios
      .get(URL_GET_MEDIA, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((data) => {
        setPhoto(data.data.resources);
      })
      .catch((err) => console.log(err));
    setIdContenedor(idCont);


    toggleFotoEIR();
  }
    // Foto Validacion
    function guardaFotosValidacion() {
      file.map((a)=>{
      const formData = new FormData();
      formData.append("file", a); // El archivo puede ser imagen, PDF, o Excel
      formData.append("contenedor", idContenedor);
    
      axios
        .post(URL_UPMEDIA_VALIDACION, formData, {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            "Content-Type": "multipart/form-data", // Asegura que el tipo de contenido sea correcto
          },
          params: {
            resource_type: "raw", // Para Cloudinary, permite la subida de archivos que no son imágenes
          },
        })
        .then((response) => {
          axios
            .patch(
              `${URL_CONTENEDORES}/${idContenedor}`,
              {
                validacion: "Si",
              },
              {
                headers: {
                  Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                },
              }
            )
            .then((response) => {
              axios
                .post(
                  URL_LOGS,
                  {
                    tipo: "Contenedor",
                    detalle: `Subir Foto`,
                    user: user.id,
                  },
                  {
                    headers: {
                      Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                    },
                  }
                )
                .then((response) => {
                  Swal.fire("Good job!", "Actualizado con éxito", "success");
                  setValidacion("Si");
                  // setTimeout(() => {
                  //   window.location.reload();
                  // }, 1000);
                })
                .catch((error) => {
                  Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: "Something went wrong!",
                    footer: `${error.response.data}`,
                  });
                  console.log(error);
                });
            })
            .catch((error) => {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Something went wrong!",
                footer: `${error.response.data}`,
              });
              console.log(error);
            });
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
            footer: `${error.response.data}`,
          });
          console.log(error);
        });
      })
      setFile();
      setPhoto([]);
    }
  
    function jalaFotoValidacion(idCont) {
      setPhoto([])
      const URL_GET_MEDIA = `${process.env.REACT_APP_URL_FINDMEDIABYTAG_VALIDACION}/${idCont}`;
      axios
        .get(URL_GET_MEDIA, {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        })
        .then((data) => {
          setPhoto(data.data.resources);
        })
        .catch((err) => console.log(err));
      setIdContenedor(idCont);
  
  
      toggleFotoValidacion();
    }

      // Foto Garantia
  function guardaFotosGarantia() {
    file.map((a)=>{
    const formData = new FormData();
    formData.append("file", a); // El archivo puede ser imagen, PDF, o Excel
    formData.append("contenedor", idContenedor);
  
    axios
      .post(URL_UPMEDIA_GARANTIA, formData, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          "Content-Type": "multipart/form-data", // Asegura que el tipo de contenido sea correcto
        },
        params: {
          resource_type: "raw", // Para Cloudinary, permite la subida de archivos que no son imágenes
        },
      })
      .then((response) => {
        axios
          .patch(
            `${URL_CONTENEDORES}/${idContenedor}`,
            {
              garantia: "Si",
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .then((response) => {
            axios
              .post(
                URL_LOGS,
                {
                  tipo: "Contenedor",
                  detalle: `Subir Foto`,
                  user: user.id,
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                  },
                }
              )
              .then((response) => {
                Swal.fire("Good job!", "Actualizado con éxito", "success");
                setGarantia("Si");
                // setTimeout(() => {
                //   window.location.reload();
                // }, 1000);
              })
              .catch((error) => {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Something went wrong!",
                  footer: `${error.response.data}`,
                });
                console.log(error);
              });
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response.data}`,
            });
            console.log(error);
          });
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
    })
    setFile();
    setPhoto([]);
  }

  function jalaFotoGarantia(idCont) {
    setPhoto([])
    const URL_GET_MEDIA = `${process.env.REACT_APP_URL_FINDMEDIABYTAG_GARANTIA}/${idCont}`;
    axios
      .get(URL_GET_MEDIA, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((data) => {
        setPhoto(data.data.resources);
      })
      .catch((err) => console.log(err));
    setIdContenedor(idCont);


    toggleFotoGarantia();
  }

    // Foto Transporte
    function guardaFotosTransporte() {
      file.map((a)=>{
      const formData = new FormData();
      formData.append("file", a); // El archivo puede ser imagen, PDF, o Excel
      formData.append("contenedor", idContenedor);
    
      axios
        .post(URL_UPMEDIA_TRANSPORTE, formData, {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            "Content-Type": "multipart/form-data", // Asegura que el tipo de contenido sea correcto
          },
          params: {
            resource_type: "raw", // Para Cloudinary, permite la subida de archivos que no son imágenes
          },
        })
        .then((response) => {
          axios
            .patch(
              `${URL_CONTENEDORES}/${idContenedor}`,
              {
                transporte: "Si",
              },
              {
                headers: {
                  Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                },
              }
            )
            .then((response) => {
              axios
                .post(
                  URL_LOGS,
                  {
                    tipo: "Contenedor",
                    detalle: `Subir Foto`,
                    user: user.id,
                  },
                  {
                    headers: {
                      Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                    },
                  }
                )
                .then((response) => {
                  Swal.fire("Good job!", "Actualizado con éxito", "success");
                  setTransporte("Si");
                  setTimeout(() => {
                    window.location.reload();
                  }, 1000);
                })
                .catch((error) => {
                  Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: "Something went wrong!",
                    footer: `${error.response.data}`,
                  });
                  console.log(error);
                });
            })
            .catch((error) => {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Something went wrong!",
                footer: `${error.response.data}`,
              });
              console.log(error);
            });
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
            footer: `${error.response.data}`,
          });
          console.log(error);
        });
      })
      setFile();
      setPhoto([]);
    }
  
    function jalaFotoTransporte(idCont) {
      setPhoto([])
      const URL_GET_MEDIA = `${process.env.REACT_APP_URL_FINDMEDIABYTAG_TRANSPORTE}/${idCont}`;
      axios
        .get(URL_GET_MEDIA, {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        })
        .then((data) => {
          setPhoto(data.data.resources);
        })
        .catch((err) => console.log(err));
      setIdContenedor(idCont);
  
  
      toggleFotoTransporte();
    }
    function borrarFoto(id) {

      axios.post(`${URL_DELMEDIA}/${id}`, {}, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
  
      .then(() => {
  
        Swal.fire("Good job!", "Actualizado con exito", "success");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
  
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
      
  
      // setFile();
      // setPhoto([]);
    }

    function jalaArchivos(id, packing, bl, invoice, fichaTecnicaArchivo, cargosLocales, DODA, boleta, prealta, EIR, validacion, garantia, transporte) {
      setIdContenedor(id);
      setPacking(packing);
      setBlArchivo(bl);
      setInvoice(invoice);
      setFichaTecnicaArchivo(fichaTecnicaArchivo);
      setCargosLocales(cargosLocales);
      setDODA(DODA);
      setBoleta(boleta);
      setPrealta(prealta);
      setEIR(EIR);
      setValidacion(validacion);
      setGarantia(garantia);
      setTransporte(transporte);
      toggleFotos();
    }

  return (
    <>
      <Header />
      <br />
      <br />
      {user.menuContenedores ? (
        <div className='card col-12'>
          <Row>
            <Col md={8}>
              {user.contenedoresCreate ? (
                <Button
                  size='sm'
                  type='submit'
                  className='btn btn-success'
                  href='/ContenedoresCreate'
                >
                  {t('Nuevo')}
                </Button>
              ) : (
                <Button
                  size='sm'
                  type='submit'
                  className='btn btn-success'
                  disabled
                >
                  {t('Nuevo')}
                </Button>
              )}
              <Button
                size='sm'
                href='/MenuContenedores'
                className='btn btn-danger'
                id='botonListado'
              >
                {t('Regresar')}
              </Button>
            </Col>
            <Col sm={4}>
              <ButtonGroup id='logoutBoton'>
                {/* <Button
                  size='sm'
                  className='btn'
                  color='success'
                  onClick={toggleETA}
                >
                  ETAs
                </Button> */}
                 <Button
                  size="sm"
                  className="btn"
                  color="danger"
                  onClick={toggleArchivo}
                >
                  Archivo <i class="fas fa-upload"></i>
                </Button>
                <Button
                  size='sm'
                  className='btn'
                  color='danger'
                  onClick={PDFTabla}
                >
                  PDF <i class='far fa-file-pdf'></i>
                </Button>
                <Button
                  size='sm'
                  className='btn'
                  onClick={toggleMail}
                  color='info'
                >
                  eMail <i class='fas fa-at'></i>
                </Button>
                <Button
                  size='sm'
                  className='btn'
                  color='primary'
                  onClick={excel}
                >
                  Excel <i class='far fa-file-excel'></i>
                </Button>
              </ButtonGroup>
            </Col>
          </Row>
          <Modal size='sm' isOpen={modalMail} toggle={toggleMail}>
            <ModalHeader toggle={toggleMail}>
              <h4>{t('Enviar Listado Contenedores')}</h4>
            </ModalHeader>
            <ModalBody>
              <Label className='mr-sm-2'>Email</Label>
              <Input
                className='col-sm-12'
                type='text'
                value={mailTo}
                required
                onChange={(e) => {
                  setMailTo(e.target.value);
                }}
              />
            </ModalBody>
            <ModalFooter>
              <Button size='sm' color='success' onClick={enviaMail}>
                {t('Enviar')}
              </Button>
            </ModalFooter>
          </Modal>
          <h3 align='center'>{t('Contenedores')}</h3>
          <div className='row'>
            <div className='col-md-8'>
              <Pagination
                total={totalItems}
                itemsPerPage={ITEMS_PER_PAGE}
                currentPage={currentPage}
                onPageChange={(page) => setCurrentPage(page)}
              />
            </div>
            <div className='col-md-4 d-flex flex-row-reverse'>
              <Search
                onSearch={(value) => {
                  setSearch(value);
                  setCurrentPage(1);
                }}
              />
            </div>
          </div>
          <Row>
            <Col md={2}>
              <Label className='mr-sm-2'>{t('Fecha Inicio')}</Label>
              <Input
                bsSize='sm'
                type='date'
                value={selectedFechaInicio}
                required
                onChange={(e) => {
                  setSelectedFechaInicio(e.target.value);
                }}
              />
            </Col>
            <Col md={2}>
              <Label className='mr-sm-2'>{t('Fecha Fin')}</Label>
              <Input
                bsSize='sm'
                type='date'
                value={selectedFechaFin}
                required
                onChange={(e) => {
                  setSelectedFechaFin(e.target.value);
                }}
              />
            </Col>

            <Col md={2}>
              <Label className='mr-sm-2'>{t('Pendientes')}</Label>
              <Input
                bsSize='sm'
                type='select'
                value={selectedPendiente}
                required
                onChange={(e) => {
                  setSelectedPendiente(e.target.value);
                }}
              >
                <option value=''>{t('Selecciona')}</option>
                <option value='No'>{t('Pendiente')}</option>
                <option value='Si'>{t('Entregado')}</option>
              </Input>
            </Col>

            <Col md={2}>
              <Label className='mr-sm-2'>{t('Activo')}</Label>
              <Input
                bsSize='sm'
                type='select'
                value={selectedActivo}
                required
                onChange={(e) => {
                  setSelectedActivo(e.target.value);
                }}
              >
                <option value=''>{t('Selecciona')}</option>
                <option value='Si'>{t('Activo')}</option>
                <option value='No'>{t('Cancelado')}</option>
              </Input>
            </Col>
            <Col md={2}>
              <Label className='mr-sm-2'>{t('Fecha Cita Inicio')}</Label>
              <Input
                bsSize='sm'
                type='date'
                value={selectedFechaCitaInicio}
                required
                onChange={(e) => {
                  setSelectedFechaCitaInicio(e.target.value);
                }}
              />
            </Col>
            <Col md={2}>
              <Label className='mr-sm-2'>{t('Fecha Cita Fin')}</Label>
              <Input
                bsSize='sm'
                type='date'
                value={selectedFechaCitaFin}
                required
                onChange={(e) => {
                  setSelectedFechaCitaFin(e.target.value);
                }}
              />
            </Col>

          </Row>
          <br />
          <Table size='sm' striped borderless className='table-responsive-xl'>
            <TableHeader
              headers={headers}
              onSorting={(field, order) => setSorting({ field, order })}
            />
            <tr>
              <td style={{ paddingTop: '0px' }}>
                <Input
                  bsSize='sm'
                  type='select'
                  value={selectedCliente}
                  onChange={(e) => {
                    setSelectedCliente(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value=''>{t('Selecciona')}</option>
                  {clientes
                    .sort((a, b) =>
                      a.nombre_comercial > b.nombre_comercial ? 1 : -1
                    )
                    .map((a) => {
                      return (
                        <option value={a._id}>{a.nombre_comercial}</option>
                      );
                    })}
                </Input>
              </td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td> 
              <td style={{ paddingTop: '0px' }}>
                <Input
                  bsSize='sm'
                  type='select'
                  value={selectedNaviera}
                  onChange={(e) => {
                    setSelectedNaviera(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value=''>{t('Selecciona')}</option>
                  {proveedores
                    .sort((a, b) => (a.name > b.name ? 1 : -1))
                    .map((a) => {
                      if (a.tipo === 'Naviera') {
                        return <option value={a._id}>{a.name}</option>;
                      }
                    })}
                </Input>
              </td>
              <td style={{ paddingTop: '0px' }}>
                <Input
                  bsSize='sm'
                  type='select'
                  value={selectedForwarder}
                  onChange={(e) => {
                    setSelectedForwarder(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value=''>{t('Selecciona')}</option>
                  {proveedores
                    .sort((a, b) => (a.name > b.name ? 1 : -1))
                    .map((a) => {
                      if (a.tipo === 'Forwarder') {
                        return <option value={a._id}>{a.name}</option>;
                      }
                    })}
                </Input>
              </td>
              <td style={{ paddingTop: '0px' }}>
                <Input
                  bsSize='sm'
                  type='select'
                  value={selectedAgencia}
                  onChange={(e) => {
                    setSelectedAgencia(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value=''>{t('Selecciona')}</option>
                  {proveedores
                    .sort((a, b) => (a.name > b.name ? 1 : -1))
                    .map((a) => {
                      if (a.tipo === 'Agencia') {
                        return <option value={a._id}>{a.name}</option>;
                      }
                    })}
                </Input>
              </td>
              <td style={{ paddingTop: '0px' }}>
                <Input
                  bsSize='sm'
                  type='select'
                  value={selectedComisionista}
                  onChange={(e) => {
                    setSelectedComisionista(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value=''>{t('Selecciona')}</option>
                  {proveedores
                    .sort((a, b) => (a.name > b.name ? 1 : -1))
                    .map((a) => {
                      if (a.tipo === 'Comisionista') {
                        return <option value={a._id}>{a.name}</option>;
                      }
                    })}
                </Input>
              </td>
              <td style={{ paddingTop: '0px' }}>
                <Input
                  bsSize='sm'
                  type='select'
                  value={selectedAgente}
                  onChange={(e) => {
                    setSelectedAgente(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value=''>{t('Selecciona')}</option>
                  {proveedores
                    .sort((a, b) => (a.name > b.name ? 1 : -1))
                    .map((a) => {
                      if (a.tipo === 'Agente') {
                        return <option value={a._id}>{a.name}</option>;
                      }
                    })}
                </Input>
              </td>
              <td style={{ paddingTop: '0px' }}>
                <Input
                  bsSize='sm'
                  type='select'
                  placeholder='Modalidad'
                  value={selectedModalidad}
                  required
                  onChange={(e) => {
                    setSelectedModalidad(e.target.value);
                  }}
                >
                  <option value=''>Selecciona</option>
                  <option value='Tren'>Tren</option>
                  <option value='Camion'>Camion</option>
                </Input>
              </td>
             
              <td></td>
              <td></td>
              {/* <td style={{ paddingTop: '0px' }}>
                <Input
                  bsSize='sm'
                  type='select'
                  placeholder='Asegurado'
                  value={selectedAsegurado}
                  required
                  onChange={(e) => {
                    setSelectedAsegurado(e.target.value);
                  }}
                >
                  <option value=''>Selecciona</option>
                  <option value='No'>No</option>
                  <option value='Si'>Si</option>
                  <option value='No Aplica'>No Aplica</option>
                </Input>
              </td> */}
              <td style={{ paddingTop: '0px' }}>
                <Input
                  type='select'
                  bsSize='sm'
                  value={selectedStatus}
                  onChange={(e) => {
                    setSelectedStatus(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value=''>Selecciona</option>
                  <option value='Pendiente'>Pendiente</option>
                  <option value='Ficha Tecnica'>Ficha Tecnica</option>
                  <option value='En Agua'>En Agua</option>
                  <option value='Toque Piso'>Toque Piso</option>
                  <option value='Telex'> Telex</option>
                  <option value='Naviera Freno Demoras'>Naviera Freno Demoras</option>
                  <option value="Bloqueado">Bloqueado</option>
                  <option value='Cambio Patente'>Cambio Patente</option>
                  <option value='Proceso Pago MBL'>Proceso Pago MBL</option>
                  <option value='Proceso Revalidacion'>Proceso Revalidacion</option>
                  <option value='Revalidacion'>Revalidacion</option>
                  <option value='Pedimento Pagado'>Pedimento Pagado</option>
                  <option value='Bloqueado SEMAR'>Bloqueado SEMAR</option>
                  <option value='Cita'>Cita</option>
                  <option value='Por Modular'>Por Modular</option>
                  <option value='Modulado'>Modulado</option>
                  <option value='Por Documentar Tren'>Por Documentar Tren</option>
                  <option value='Por subir Tren'>Por subir Tren</option>
                  <option value='Maniobra Transportista'>Maniobra Transportista</option>
                  <option value='Patio Transportista'>Patio Transportista</option>
                  <option value='A1'>A1</option>
                  <option value='PAMA'>PAMA</option>
                  <option value='ROJO'>ROJO</option>
                  <option value='OVT'>OVT</option>
                  <option value='Abandono'>Abandono</option>
                  <option value='RETENIDO DESDE LLEGADA'>RETENIDO DESDE LLEGADA</option>
                  <option value='Bodega Tortons'>Bodega Tortons</option>
                  <option value='En Tren'>En Tren</option>
                  <option value='En Ruta'>En Ruta</option>
                  <option value='Entregado'>Entregado</option>
                  <option value='Retorno Vacio'>Retorno Vacio</option>
                  <option value='Cancelado'>Cancelado</option>
                </Input>
              </td>
              <td style={{ paddingTop: '0px' }}>
                <Input
                  bsSize='sm'
                  type='select'
                  value={selectedTransportista}
                  onChange={(e) => {
                    setSelectedTransportista(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value=''>{t('Selecciona')}</option>
                  {proveedores
                    .sort((a, b) => (a.name > b.name ? 1 : -1))
                    .map((a) => {
                      if (a.tipo === 'Transportista') {
                        return <option value={a._id}>{a.name}</option>;
                      }
                    })}
                </Input>
              </td>
              <td style={{ paddingTop: '0px' }}></td>
            </tr>
            <tbody>
              {commentsData.map((a) => {
                // const getRowStyle = (status) => {
                //   switch (status) {
                //     case "Toque Piso":
                //       return { backgroundColor: "#FFB6C1" }; // Rojo (mismo color de Revalidado)
                //     case "Telex":
                //       return { backgroundColor: "#FFFFE0" }; // Amarillo claro
                //     case "Revalidacion":
                //       return { backgroundColor: "#D8BFD8" }; // Lila
                //     case "Pedimento Pagado":
                //       return { backgroundColor: "#ADD8E6" }; // Azul claro
                //     case "Cita":
                //       return { backgroundColor: "#FFDAB9" }; // Naranja claro
                //     case "Modulado":
                //       return { backgroundColor: "#98FB98" }; // Verde menta
                //     case "Retorno Vacio":
                //       return { backgroundColor: "#bf692c" }; // Café
                //     case "Entregado":
                //       return { backgroundColor: "#32CD32" }; // Verde (se queda igual)
                //     default:
                //       return { backgroundColor: "transparent" }; // Sin color por defecto
                //   }
                // };
                const getRowStyle = (a) => {
                  // Si está entregado o en retorno vacío, prioridad
                  if (a.status === "Entregado") {
                    return { backgroundColor: "#32CD32" }; // Verde
                  }
                  if (a.status === "Retorno Vacio") {
                    return { backgroundColor: "#bf692c" }; // Café
                  }
                
                  // Evaluar diferencia de días con etaReal si existe
                  if (a.etaReal) {
                    const etaDate = new Date(a.etaReal);
                    const now = new Date();
                    const diffTime = now - etaDate;
                    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
                
                    if (diffDays >= 0 && diffDays <= 5) {
                      return { backgroundColor: "#90ee90" }; // Verde claro
                    } else if (diffDays > 5 && diffDays <= 10) {
                      return { backgroundColor: "#FFFF99" }; // Amarillo
                    } else if (diffDays > 10 && diffDays <= 15) {
                      return { backgroundColor: "#FFA500" }; // Naranja
                    } else if (diffDays > 15) {
                      return { backgroundColor: "#ed8c8c" }; // Rojo
                    }
                  }
                };
                
                return (
                  <tr key={a._id} style={getRowStyle(a)}>
                    {/* <td>{a.numero}</td>
                    <td>{a.fecha}</td> */}
                    <td style={{ paddingTop: '0px' }}>{a.numeroInterno}</td>
                    <td style={{ paddingTop: '0px' }}>{a.etaReal}</td>
                    <td style={{ paddingTop: '0px' }}>{a.contenedor}</td>
                    <td style={{ paddingTop: '0px' }}>{a.numeroBl}</td>
                    <td style={{ paddingTop: '0px' }}>{a.diasLibresDemoras}</td>
                    <td style={{ paddingTop: '0px' }}>{a.diasDemorasCobrables}</td>
                    <td style={{ paddingTop: '0px' }}>{a.diasAlmacenajesCobrables}</td>
                    <td style={{ paddingTop: '0px' }}>{a.navieras}</td>
                    <td style={{ paddingTop: '0px' }}>{a.forwarders}</td>
                    <td style={{ paddingTop: '0px' }}>{a.agencias}</td>
                    <td style={{ paddingTop: '0px' }}>{a.comisionistas}</td>
                    <td style={{ paddingTop: '0px' }}>{a.agentes}</td>
                    <td style={{ paddingTop: '0px' }}>{a.modalidad}</td>
                    <td style={{ paddingTop: '0px' }}>{a.custodia}</td>
                    <td style={{ paddingTop: '0px' }}>{a.fechaCita}</td>
                    <td style={{ paddingTop: '0px' }}>{a.status}</td>
                    <td style={{ paddingTop: '0px' }}>{a.transportistas}</td>
                    <td style={{ paddingTop: '0px' }}>
                      {a.fechaEntregaCliente}
                    </td>
                    <td style={{ paddingTop: '0px' }}>{a.retornoVacio}</td>
                    {/* <td style={{ paddingTop: '0px' }}>{a.clientes}</td> */}
                    {/* Fotos */}
                      <td>
                      <Button
                        size='sm'
                        style={{ color: "yellow" }}
                        onClick={(e) =>
                          jalaArchivos(
                            a._id,
                            a.packing,
                            a.bl,
                            a.invoice,
                            a.fichaTecnicaArchivo,
                            a.cargosLocales,
                            a.DODA,
                            a.boleta,
                            a.prealta,
                            a.EIR,
                            a.validacion,
                            a.garantia,
                            a.transporte
                          )
                        }
                      >
                        <i class='far fa-folder'></i>
                        </Button>
                      </td>

                    <td style={{ paddingTop: '0px' }}>
                      <Button
                        size='sm'
                        className='btn'
                        color='danger'
                        onClick={(e) =>
                          PDFOC(
                            a.fecha,
                            a.idNavieras,
                            a.navieras,
                            a.clientes,
                            a.agentes,
                            a.totalCantidad,
                            a.totalGeneral,
                            a.observaciones,
                            a.numero,
                            a._id
                          )
                        }
                      >
                        <i class='far fa-file-pdf'></i>
                        </Button>
                      {/* {a.rastreo == 'No' && a.idNavieras != "65a093c4b196000019bbeca4" ? (
                      <Button
                      size='sm'
                        color='success'
                        onClick={(e) =>{
                          registrarSG(a._id, a.navieras, a.contenedor)
                        }
                        }
                      >
                        SG
                      </Button>
                      ):(
                        <Button
                          size='sm'
                        color='success'
                          disabled
                          >
                            SG
                          </Button>)}
                      {a.mapa !== 'No' ? (
                      <Button
                      size='sm'
                        onClick={(e) =>{
                          crearMapa(a.polLatitude,
                            a.polLongitude,
                            a.podLatitude,
                            a.podLongitude,
                            a.vesselLatitude,
                            a.vesselLongitude,
                            a.etaReal
                          )
                        }
                        }
                      >
                        <i class='fas fa-map'></i>
                      </Button>
                      ):(
                        <Button
                          size='sm'
                          disabled
                          >
                            <i class='fas fa-map'></i>
                          </Button>)} */}
                      <Button
                        color='info'
                        id='Editar'
                        size='sm'
                        onClick={(e) =>
                          jalaInfo(
                            a.fecha,
                            a.idNavieras,
                            a.idClientes,
                            a.idAgentes,
                            a.idAgencias,
                            a.idComisionistas,
                            a.idTransportistas,
                            a.idForwarders,
                            a.totalCantidad,
                            a.totalGeneral,
                            a.observaciones,
                            a.observacionesInternas,
                            a.numero,
                            a.numeroInterno,
                            a.contenedor,
                            // a.etaEstimada,
                            a.etaReal,
                            a.puerto,
                            a.puertoOrigen,
                            a.numeroBl,
                            a.fechaCita,
                            a.diasLibresDemoras,
                            a.custodia,
                            a.idTerminales,
                            a.pedimento,
                            a.modalidad,
                            a.asegurado,
                            a.direccionEntrega,
                            a.idProgramas,
                            a.idPatentes,
                            a.rastreo,
                            a.pesoTotal,
                            a.totalCargos,
                            a.totalGastos,
                            a._id
                          )
                        }
                      >
                        <i class='far fa-edit'></i>
                      </Button>
                      <Button
                        color='info'
                        id='Editar'
                        size='sm'
                        onClick={(e) => EditArticulos(a._id, a.numero)}
                      >
                        <i class='fas fa-cart-plus'></i>
                      </Button>

                      <Button
                        color='success'
                        id='Editar'
                        size='sm'
                        onClick={(e) =>
                          EditStatus(
                            a._id,
                            a.bl,
                            a.pl,
                            a.factura,
                            a.numeroInterno,
                            a.documentos,
                            a.telex,
                            a.toquePiso,
                            a.revalidacion,
                            a.fichaTecnica,
                            a.pagoPedimento,
                            a.modulacion,
                            a.retornoVacio,
                            a.salidaPuerto,
                            a.salidaRuta,
                            // a.maniobras,
                            a.entregaCliente,
                            a.status,
                            a.fechaEntradaPuerto,
                            a.fechaDocumentos,
                            a.fechaTelex,
                            a.fechaToquePiso,
                            a.fechaRevalidacion,
                            a.fechaFichaTecnica,
                            a.fechaPagoPedimento,
                            a.fechaModulacion,
                            a.fechaRetornoVacio,
                            a.fechaSalidaPuerto,
                            a.fechaSalidaRuta,
                            // a.fechaManiobras,
                            a.fechaEntregaCliente,
                            a.fechaFactura,
                            a.fechaBl,
                            a.fechaPl
                          )
                        }
                      >
                        <i class='fas fa-calendar-check'></i>
                      </Button>
                      {user.contenedoresEntrega?(
                      <Baja
                        idStatus={a._id}
                        is_active={a.activo}
                        URL_BAJA={process.env.REACT_APP_URL_CONTENEDORES}
                      />
                    ):undefined}
                      {/* <Button
                        color="primary"
                        id="Editar"
                        size="sm"
                        onClick={(e) => {
                          setSelectedContenedor(a._id);
                          setSelectedClienteGasto(a.idClientes);
                          setnumeroInterno(a.numeroInterno);
                          toggleGastos();
                        }}
                      >
                        <i class="fas fa-dollar-sign"></i>
                      </Button>
                      <Button
                        color="info"
                        id="Editar"
                        size="sm"
                        onClick={(e) => {
                          setSelectedContenedor(a._id);
                          setSelectedClienteGasto(a.idClientes);
                          setnumeroInterno(a.numeroInterno);
                          toggleCargos();
                        }}
                      >
                        <i class="fas fa-plus"></i>
                      </Button> */}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
          <div className='col-md-6'>
            <Pagination
              total={totalItems}
              itemsPerPage={ITEMS_PER_PAGE}
              currentPage={currentPage}
              onPageChange={(page) => setCurrentPage(page)}
            />
          </div>
        </div>
      ) : undefined}
      <br />

      <Modal size='xxl' isOpen={modalEdit} toggle={toggleEdit}>
        <ModalHeader toggle={toggleEdit}>
          <h4>
            {t('Editar')} {t('Contenedor')} {numeroContenedor}
          </h4>
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col md={3}>
              <Label>{t('Contenedor')}</Label>
              <Input
                type='text'
                placeholder='Contenedor'
                value={contenedor}
                required
                onChange={(e) => {
                  setContenedor(e.target.value);
                }}
              />
            </Col>
            <Col md={3}>
              <Label>{t('Numero Bl')}</Label>
              <Input
                type='text'
                placeholder='NumeroBl'
                value={numeroBl}
                required
                onChange={(e) => {
                  setNumeroBl(e.target.value);
                }}
              />
            </Col>
            <Col md={3}>
              <Label>{t('Fecha Cita')}</Label>
              <Input
                type='date'
                placeholder='fechaCita'
                value={fechaCita}
                onChange={(e) => {
                  setFechaCita(e.target.value);
                }}
              />
            </Col>
          </Row>
          <Row>
            <Col md={3}>
              <Label>{t('Fecha')}</Label>
              <Input
                type='date'
                placeholder='Fecha'
                value={fecha}
                required
                disabled
              />
            </Col>

            <Col md={3}>
              <Label>{t('Numero Interno')}</Label>
              <Input
                type='text'
                placeholder='numeroInterno'
                value={numeroInterno}
                required
                disabled
              />
            </Col>
{totalCargos > 0 || totalGastos > 0 ?(
  <>
  <Col md={3}>
              <Label className='mr-sm-2'>{t('Cliente')}</Label>
              <Input
                className='col-sm-12'
                type='select'
                value={selectedClienteEdit}
                required
                disabled
              >
                <option value='0'>{t('Selecciona')}</option>
                {clientes
                  .sort((a, b) =>
                    a.nombre_comercial > b.nombre_comercial ? 1 : -1
                  )
                  .map((a) => {
                    return <option value={a._id}>{a.nombre_comercial}</option>;
                  })}
              </Input>
            </Col>
  </>
) : (
  <>
<Col md={3}>
              <Label className='mr-sm-2'>{t('Cliente')}</Label>
              <Input
                className='col-sm-12'
                type='select'
                value={selectedClienteEdit}
                required
                onChange={(e) => {
                  setSelectedClienteEdit(e.target.value);
                }}
              >
                <option value='0'>{t('Selecciona')}</option>
                {clientes
                  .sort((a, b) =>
                    a.nombre_comercial > b.nombre_comercial ? 1 : -1
                  )
                  .map((a) => {
                    return <option value={a._id}>{a.nombre_comercial}</option>;
                  })}
              </Input>
            </Col>
            </>
)}
            
            <Col md={3}>
              <Label className='mr-sm-2'>{t('Naviera')}</Label>
             {rastreo == "No" ?(
               <Input
               className='col-sm-12'
               type='select'
               value={selectedNavieraEdit}
               required
               onChange={(e) => {
                 setSelectedNavieraEdit(e.target.value);
               }}
             >
               <option value='0'>{t('Selecciona')}</option>
               {proveedores
                 .sort((a, b) => (a.name > b.name ? 1 : -1))
                 .map((a) => {
                   if (a.tipo === 'Naviera') {
                     return <option value={a._id}>{a.name}</option>;
                   }
                 })}
             </Input>
             ):( 
             <Input
              className='col-sm-12'
              type='select'
              value={selectedNavieraEdit}
              required
              disabled
            >
              <option value='0'>{t('Selecciona')}</option>
              {proveedores
                .sort((a, b) => (a.name > b.name ? 1 : -1))
                .map((a) => {
                  if (a.tipo === 'Naviera') {
                    return <option value={a._id}>{a.name}</option>;
                  }
                })}
            </Input>)}
            </Col>
          </Row>
          <br />
          <Row>
            <Col md={3}>
              <Label className='mr-sm-2'>{t('Agente Aduanal')}</Label>
              <Input
                className='col-sm-12'
                type='select'
                value={selectedAgenteEdit}
                required
                onChange={(e) => {
                  setSelectedAgenteEdit(e.target.value);
                }}
              >
                <option value='0'>{t('Selecciona')}</option>
                {proveedores
                  .sort((a, b) => (a.name > b.name ? 1 : -1))
                  .map((a) => {
                    if (a.tipo === 'Agente') {
                      return <option value={a._id}>{a.name}</option>;
                    }
                  })}
              </Input>
            </Col>

            <Col md={3}>
              <Label className='mr-sm-2'>{t('Forwarder')}</Label>
              <Input
                className='col-sm-12'
                type='select'
                value={selectedForwarderEdit}
                required
                onChange={(e) => {
                  setSelectedForwarderEdit(e.target.value);
                }}
              >
                <option value='0'>{t('Selecciona')}</option>
                {proveedores
                  .sort((a, b) => (a.name > b.name ? 1 : -1))
                  .map((a) => {
                    if (a.tipo === 'Forwarder') {
                      return <option value={a._id}>{a.name}</option>;
                    }
                  })}
              </Input>
            </Col>
            <Col md={3}>
              <Label>{t('PuertoOrigen')}</Label>
              <Input
                type='text'
                placeholder='PuertoOrigen'
                value={puertoOrigen}
                required
                onChange={(e) => {
                  setPuertoOrigen(e.target.value);
                }}
              />
            </Col>

            <Col md={3}>
              <Label>{t('Puerto')}</Label>
              <Input
                type='select'
                placeholder='Puerto'
                value={puerto}
                required
                onChange={(e) => {
                  setPuerto(e.target.value);
                }}
              >
                <option value=''>Selecciona</option>
                <option value="Aeropuerto CDMX">Aeropuerto CDMX</option>
                  <option value="Houston">Houston</option>
                  <option value="Laredo">Laredo</option>
                  <option value="Lazaro Cardenas">Lazaro Cardenas</option>
                  <option value="Long Beach">Long Beach</option>
                  <option value="Manzanillo">Manzanillo</option>
                  <option value="Pantaco">Pantaco</option>
                  <option value="Progreso">Progreso</option>
                  <option value="Tijuana">Tijuana</option>
                  <option value="Veracruz">Veracruz</option>
              </Input>
            </Col>

            </Row>
          <br />
          <Row>
            <Col md={3}>
              <Label>{t('Terminal')}</Label>
              <Input
                type='select'
                placeholder='Terminal'
                value={selectedTerminal}
                required
                onChange={(e) => {
                  setSelectedTerminal(e.target.value);
                }}
              >
                {terminales
                  .sort((a, b) => (a.name > b.name ? 1 : -1))
                  .map((a) => {
                    return <option value={a._id}>{a.name}</option>;
                  })}
              </Input>
            </Col>
            <Col md={3}>
              <Label>{t('Pedimento')}</Label>
              <Input
                type='text'
                placeholder='Pedimento'
                value={pedimento}
                required
                onChange={(e) => {
                  setPedimento(e.target.value);
                }}
              />
            </Col>
            <Col md={3}>
              <Label>{t('Programa')}</Label>
              <Input
                type='select'
                placeholder='Programa'
                value={selectedPrograma}
                required
                onChange={(e) => {
                  setSelectedPrograma(e.target.value);
                }}
              >
                {programas
                  .sort((a, b) => (a.name > b.name ? 1 : -1))
                  .map((a) => {
                    return <option value={a._id}>{a.name}</option>;
                  })}
              </Input>
            </Col>
            <Col md={3}>
              <Label>{t('Patente')}</Label>
              <Input
                type='select'
                placeholder='Patente'
                value={selectedPatente}
                required
                onChange={(e) => {
                  setSelectedPatente(e.target.value);
                }}
              >
                {patentes
                  .sort((a, b) => (a.name > b.name ? 1 : -1))
                  .map((a) => {
                    return <option value={a._id}>{a.name}</option>;
                  })}
              </Input>
            </Col>
          </Row>
          <br />
          <Row>
            <Col md={3}>
              <Label>{t('Modalidad')}</Label>
              <Input
                type='select'
                placeholder='Modalidad'
                value={modalidad}
                required
                onChange={(e) => {
                  setModalidad(e.target.value);
                }}
              >
                <option value=''>Selecciona</option>
                <option value='Tren'>Tren</option>
                <option value='Camion'>Camion</option>
              </Input>
            </Col>
            {/* <Col md={3}>
              <Label>
                {t("Fecha")} ETA {t("Estimada")}
              </Label>
              <Input
                type="date"
                value={fechaETAEstimada}
                required
                onChange={(e) => {
                  setFechaETAEstimada(e.target.value);
                }}
              />
            </Col> */}
            <Col md={3}>
              <Label>{t('Asegurado')}</Label>
              <Input
                type='select'
                placeholder='Asegurado'
                value={asegurado}
                required
                onChange={(e) => {
                  setAsegurado(e.target.value);
                }}
              >
                <option value=''>Selecciona</option>
                <option value='No'>No</option>
                <option value='Si'>Si</option>
                <option value='No Aplica'>No Aplica</option>
              </Input>
            </Col>
            <Col md={3}>
              <Label>{t('Fecha')} ETA</Label>
              <Input
                type='date'
                value={fechaETAReal}
                required
                onChange={(e) => {
                  setFechaETAReal(e.target.value);
                }}
              />
            </Col>
            <Col md={3}>
              <Label>{t('Peso Total')}</Label>
              <Input
                type='number'
                value={pesoTotal}
                required
                onChange={(e) => {
                  setPesoTotal(e.target.value);
                }}
              />
            </Col>
          </Row>
          <br />
          <Row>
          <Col md={3}>
              <Label className='mr-sm-2'>{t('Agencia')}</Label>
              <Input
                className='col-sm-12'
                type='select'
                value={selectedAgenciaEdit}
                required
                onChange={(e) => {
                  setSelectedAgenciaEdit(e.target.value);
                }}
              >
                <option value='0'>{t('Selecciona')}</option>
                {proveedores
                  .sort((a, b) => (a.name > b.name ? 1 : -1))
                  .map((a) => {
                    if (a.tipo === 'Agencia') {
                      return <option value={a._id}>{a.name}</option>;
                    }
                  })}
              </Input>
            </Col>
            <Col md={3}>
              <Label className='mr-sm-2'>{t('Comisionista')}</Label>
              <Input
                className='col-sm-12'
                type='select'
                value={selectedComisionistaEdit}
                required
                onChange={(e) => {
                  setSelectedComisionistaEdit(e.target.value);
                }}
              >
                <option value='0'>{t('Selecciona')}</option>
                {proveedores
                  .sort((a, b) => (a.name > b.name ? 1 : -1))
                  .map((a) => {
                    if (a.tipo === 'Comisionista') {
                      return <option value={a._id}>{a.name}</option>;
                    }
                  })}
              </Input>
            </Col>
          <Col md={3}>
              <Label className='mr-sm-2'>{t('Transportista')}</Label>
              <Input
                className='col-sm-12'
                type='select'
                value={selectedTransportistaEdit}
                required
                onChange={(e) => {
                  setSelectedTransportistaEdit(e.target.value);
                }}
              >
                <option value='0'>{t('Selecciona')}</option>
                {proveedores
                  .sort((a, b) => (a.name > b.name ? 1 : -1))
                  .map((a) => {
                    if (a.tipo === 'Transportista') {
                      return <option value={a._id}>{a.name}</option>;
                    }
                  })}
              </Input>
            </Col>
          </Row>
          <br />
          <Row>
             <Col md={3}>
              <Label>{t('Dias Libres Demoras')}</Label>
              <Input
                type='number'
                placeholder='Dias Libres'
                value={diasLibresDemoras}
                required
                onChange={(e) => {
                  setDiasLibresDemoras(e.target.value);
                }}
              />
            </Col>
            <Col md={3}>
              <Label>{t('Custodia')}</Label>
              <Input
                type='text'
                placeholder='Custodia'
                value={custodia}
                required
                onChange={(e) => {
                  setCustodia(e.target.value);
                }}
              />
            </Col>
          </Row>
          <br />
          <Row>
            <Col md={6}>
              <Label>{t('Direccion de Entrega')}</Label>
              <Input
                type='text'
                placeholder='Direccion Entrega'
                value={direccionEntrega}
                required
                onChange={(e) => {
                  setDireccionEntrega(e.target.value);
                }}
              />
            </Col>
            <Col md={6}>
              <Label for='exampleEmail' className='mr-sm-2'>
                {t('Observaciones')}
              </Label>
              <Input
                type='textarea'
                placeholder='Observaciones'
                value={observaciones}
                required
                onChange={(e) => {
                  setObservaciones(e.target.value);
                }}
              />
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <Label for='exampleEmail' className='mr-sm-2'>
                {t('Observaciones Internas')}
              </Label>
              <Input
                type='textarea'
                placeholder='ObservacionesInternas'
                value={observacionesInternas}
                required
                onChange={(e) => {
                  setObservacionesInternas(e.target.value);
                }}
              />
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button color='success' onClick={editContenedores}>
            {t('Guardar')}
          </Button>
        </ModalFooter>
      </Modal>

      <Modal
        size='xxl'
        isOpen={modalEditArticulos}
        toggle={toggleEditArticulos}
      >
        <ModalHeader toggle={toggleEditArticulos}>
          <h4>
            {'Editar'} {t('Articulos')} {t('Contenedor')} {numeroContenedor}
          </h4>
          <h4>
            TOTAL {totalCantidad_edit} pzas. /{' '}
            {new Intl.NumberFormat('en-US', {
              style: 'currency',
              currency: 'USD',
              maximumFractionDigits: 2,
            }).format(totalGeneral_edit)}
          </h4>
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col md={2}>
              <Label className='mr-sm-2'>{t('Articulos')}</Label>
            </Col>
            <Col md={2}>
              <Label className='mr-sm-2'>{t('Descripcion')}</Label>
            </Col>
            <Col md={1}>
              <Label className='mr-sm-2'>{t('Cantidad')}</Label>
            </Col>
            <Col md={1}>
              <Label className='mr-sm-2'>{t('Precio')}</Label>
            </Col>
            <Col md={2}>
              <Label className='mr-sm-2'>Total</Label>
            </Col>
          </Row>

          {articulosContenedor.map((ao) => (
            <div key={ao.id}>
              <Row>
                <Col md={2}>
                  <Input
                    // bsSize="sm"
                    name='articulos'
                    type='select'
                    value={ao.articulos}
                    required
                    onChange={(event) => {
                      BuscaArticuloExistentes(ao.id, event);
                    }}
                  >
                    <option value='0'>{t('Selecciona')}</option>
                    {articulos
                      .sort((a, b) => (a.name > b.name ? 1 : -1))
                      .map((a) => {
                        return <option value={a._id}>{a.name}</option>;
                      })}
                  </Input>
                </Col>

                <Col md={2}>
                  <Input
                    // bsSize="sm"
                    name='descripcion'
                    type='text'
                    placeholder='descripcion'
                    value={ao.descripcion}
                    required
                    onChange={(event) =>
                      handleChangeInputExistentes(ao.id, event)
                    }
                  />
                </Col>

                <Col md={1}>
                  <Input
                    // bsSize="sm"
                    name='cantidad'
                    type='number'
                    min='0'
                    step='any'
                    placeholder='Cantidad'
                    value={ao.cantidad}
                    required
                    onChange={(event) =>
                      handleChangeInputExistentesCantidad(ao.id, event)
                    }
                  />
                </Col>

                <Col md={1}>
                  <Input
                    // bsSize="sm"
                    name='precio'
                    type='number'
                    min='0'
                    step='any'
                    placeholder='Precio'
                    value={ao.precio}
                    required
                    onChange={(event) =>
                      handleChangeInputExistentes(ao.id, event)
                    }
                  />
                </Col>
                <Col md={2}>
                  <Input
                    // bsSize="sm"
                    name='total'
                    type='number'
                    min='0'
                    step='any'
                    placeholder='Total'
                    value={ao.total}
                    disabled
                    onChange={(event) =>
                      handleChangeInputExistentes(ao.id, event)
                    }
                  />
                </Col>
              </Row>
            </div>
          ))}

          {/* Agregar mas articulos */}

          {inputFields.map((inputField) => (
            <div key={inputField.id}>
              <Row>
                <Col md={2}>
                  <Input
                    // bsSize="sm"
                    name='articulos'
                    type='select'
                    value={inputField.articulos}
                    required
                    onChange={(event) => {
                      BuscaArticulo(inputField.id, event);
                    }}
                  >
                    <option value='0'>{t('Selecciona')}</option>
                    {articulos
                      .sort((a, b) => (a.name > b.name ? 1 : -1))
                      .map((a) => {
                        return <option value={a._id}>{a.name}</option>;
                      })}
                  </Input>
                </Col>

                <Col md={2}>
                  <Input
                    // bsSize="sm"
                    name='descripcion'
                    type='text'
                    placeholder='descripcion'
                    value={inputField.descripcion}
                    required
                    onChange={(event) =>
                      handleChangeInput(inputField.id, event)
                    }
                  />
                </Col>

                <Col md={1}>
                  <Input
                    // bsSize="sm"
                    name='cantidad'
                    type='number'
                    min='0'
                    step='any'
                    placeholder='Cantidad'
                    value={inputField.cantidad}
                    required
                    onChange={(event) =>
                      handleChangeInput(inputField.id, event)
                    }
                  />
                </Col>

                <Col md={1}>
                  <Input
                    // bsSize="sm"
                    name='precio'
                    type='number'
                    min='0'
                    step='any'
                    placeholder='Precio'
                    value={inputField.precio}
                    required
                    onChange={(event) =>
                      handleChangeInput(inputField.id, event)
                    }
                  />
                </Col>

                <Col md={2}>
                  <Input
                    // bsSize="sm"
                    name='total'
                    type='number'
                    min='0'
                    step='any'
                    placeholder='Total'
                    value={inputField.total}
                    disabled
                    onChange={(event) =>
                      handleChangeInput(inputField.id, event)
                    }
                  />
                </Col>
                <Col>
                  <Button
                    size='sm'
                    className='btn'
                    color='danger'
                    disabled={inputFields.length === 1}
                    onClick={() => handleRemoveFields(inputField.id)}
                    tabindex='-1'
                  >
                    <i class='fas fa-minus'></i>
                  </Button>
                  <Button
                    size='sm'
                    className='btn'
                    color='info'
                    onClick={handleAddFields}
                    tabindex='-1'
                  >
                    <i class='fas fa-plus'></i>
                  </Button>
                </Col>
              </Row>
            </div>
          ))}
          <Row>
            <Col md={6}>
              <h4 id='logoutBoton'>
                TOTAL {totalCantidad_edit} pzas. /{' '}
                {new Intl.NumberFormat('en-US', {
                  style: 'currency',
                  currency: 'USD',
                  maximumFractionDigits: 2,
                }).format(totalGeneral_edit)}
              </h4>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button size='sm' color='success' onClick={saveContenedor}>
            {t('Guardar')}
          </Button>
        </ModalFooter>
      </Modal>

      <Modal size='sm' isOpen={modalProgreso} toggle={toggleProgreso}>
        <ModalHeader toggle={toggleProgreso}>
          <h4>{t('Progreso')}</h4>
        </ModalHeader>
        <ModalBody>
          <h4>
            {' '}
            {t('Este proceso puede tardar varios segundos.')}
            <br />
            {t('Por favor no cierre ni refresque su navegador.')}
          </h4>
          <br />
          <div className='progreso'>
            <Spinner
              style={{
                width: '50px',
                height: '50px',
                color: '#232B41',
              }}
            />
            <Spinner
              style={{
                width: '50px',
                height: '50px',
                color: '#232B41',
              }}
            />
            <Spinner
              style={{
                width: '50px',
                height: '50px',
                color: '#232B41',
              }}
            />
          </div>
        </ModalBody>
      </Modal>

      <Modal size='lg' isOpen={modalStatus} toggle={toggleStatus}>
        <ModalHeader toggle={toggleStatus}>
          <h4>
            {t('Status')} Contenedor {numeroInterno}
          </h4>
        </ModalHeader>
        <ModalBody>
          <Row>
            <Button size='sm' className='btn' color='primary' onClick={excelOC}>
              Excel <i class='far fa-file-excel'></i>
            </Button>
          </Row>
          <Row>
            <Col md={4}>
              <Label>Status</Label>
              <Input
                type='select'
                value={status}
                onChange={(e) => setstatus(e.target.value)}
              >
                  <option value=''>Selecciona</option>
                  <option value='Pendiente'>Pendiente</option>
                  <option value='Ficha Tecnica'>Ficha Tecnica</option>
                  <option value='En Agua'>En Agua</option>
                  <option value='Toque Piso'>Toque Piso</option>
                  <option value='Telex'> Telex</option>
                  <option value='Naviera Freno Demoras'>Naviera Freno Demoras</option>
                  <option value="Bloqueado">Bloqueado</option>
                  <option value='Cambio Patente'>Cambio Patente</option>
                  <option value='Proceso Pago MBL'>Proceso Pago MBL</option>
                  <option value='Proceso Revalidacion'>Proceso Revalidacion</option>
                  <option value='Revalidacion'>Revalidacion</option>
                  <option value='Pedimento Pagado'>Pedimento Pagado</option>
                  <option value='Bloqueado SEMAR'>Bloqueado SEMAR</option>
                  <option value='Cita'>Cita</option>
                  <option value='Por Modular'>Por Modular</option>
                  <option value='Modulado'>Modulado</option>
                  <option value='Por Documentar Tren'>Por Documentar Tren</option>
                  <option value='Por subir Tren'>Por subir Tren</option>
                  <option value='Maniobra Transportista'>Maniobra Transportista</option>
                  <option value='Patio Transportista'>Patio Transportista</option>
                  <option value='A1'>A1</option>
                  <option value='PAMA'>PAMA</option>
                  <option value='ROJO'>ROJO</option>
                  <option value='OVT'>OVT</option>
                  <option value='Abandono'>Abandono</option>
                  <option value='RETENIDO DESDE LLEGADA'>RETENIDO DESDE LLEGADA</option>
                  <option value='Bodega Tortons'>Bodega Tortons</option>
                  <option value='En Tren'>En Tren</option>
                  <option value='En Ruta'>En Ruta</option>
                  <option value='Entregado'>Entregado</option>
                  <option value='Retorno Vacio'>Retorno Vacio</option>
                  <option value='Cancelado'>Cancelado</option>
              </Input>
              {/* </Col>
                <Col md={3}>
                  <Label>.</Label> */}
              <Button onClick={() => updateOnlyStatus()} size='sm'>
                Actualizar
              </Button>
            </Col>
          </Row>
          <br />
          <Row>
            <Col md={3} className='negrita'>
              <Label className='mr-sm-2'>Concepto</Label>
            </Col>
            <Col md={3} className='negrita'>
              <Label className='mr-sm-2'>Fecha</Label>
            </Col>
            <Col md={3} className='negrita'>
              <Label className='mr-sm-2'>Realizado</Label>
            </Col>
          </Row>

          <Row>
            <Col md={3}>
              <Label className='mr-sm-2'>BL</Label>
            </Col>
            <Col md={3} className='negro'>
              <Input
                type='date'
                value={fechaBl}
                onChange={(e) => setfechaBl(e.target.value)}
              />
            </Col>

            <Col md={3}>
              <Label>{bl === 'Si' ? 'Listo' : 'Pendiente'}</Label>
            </Col>

            <Col md={3}>
              <Button
                color={bl === 'Si' ? 'primary' : 'danger'}
                onClick={() =>
                  updateStatus(
                    'bl',
                    bl === 'Si' ? 'No' : 'Si',
                    'fechaBl',
                    fechaBl
                  )
                }
                size='sm'
              >
                <i className='fas fa-check-circle'></i>
              </Button>
            </Col>
          </Row>
          <br />
          <Row>
            <Col md={3}>
              <Label className='mr-sm-2'>Packing List</Label>
            </Col>
            <Col md={3} className='negro'>
              <Input
                type='date'
                value={fechaPl}
                onChange={(e) => setfechaPl(e.target.value)}
              />
            </Col>

            <Col md={3}>
              <Label>{pl === 'Si' ? 'Listo' : 'Pendiente'}</Label>
            </Col>

            <Col md={3}>
              <Button
                color={pl === 'Si' ? 'primary' : 'danger'}
                onClick={() =>
                  updateStatus(
                    'pl',
                    pl === 'Si' ? 'No' : 'Si',
                    'fechaPl',
                    fechaPl
                  )
                }
                size='sm'
              >
                <i className='fas fa-check-circle'></i>
              </Button>
            </Col>
          </Row>
          <br />
          <Row>
            <Col md={3}>
              <Label className='mr-sm-2'>Factura</Label>
            </Col>
            <Col md={3} className='negro'>
              <Input
                type='date'
                value={fechaFactura}
                onChange={(e) => setfechaFactura(e.target.value)}
              />
            </Col>

            <Col md={3}>
              <Label>{factura === 'Si' ? 'Listo' : 'Pendiente'}</Label>
            </Col>

            <Col md={3}>
              <Button
                color={factura === 'Si' ? 'primary' : 'danger'}
                onClick={() =>
                  updateStatus(
                    'factura',
                    factura === 'Si' ? 'No' : 'Si',
                    'fechaFactura',
                    fechaFactura
                  )
                }
                size='sm'
              >
                <i className='fas fa-check-circle'></i>
              </Button>
            </Col>
          </Row>
          <br />
          <Row>
            <Col md={3}>
              <Label className='mr-sm-2'>FichaTecnica</Label>
            </Col>
            <Col md={3} className='negro'>
              <Input
                type='date'
                value={fechaFichaTecnica}
                onChange={(e) => setfechaFichaTecnica(e.target.value)}
              />
            </Col>

            <Col md={3}>
              <Label>{fichaTecnica === 'Si' ? 'Listo' : 'Pendiente'}</Label>
            </Col>

            <Col md={3}>
              <Button
                color={fichaTecnica === 'Si' ? 'primary' : 'danger'}
                onClick={() =>
                  updateStatus(
                    'fichaTecnica',
                    fichaTecnica === 'Si' ? 'No' : 'Si',
                    'fechaFichaTecnica',
                    fechaFichaTecnica
                  )
                }
                size='sm'
              >
                <i className='fas fa-check-circle'></i>
              </Button>
            </Col>
          </Row>
          <br />
          <Row>
            <Col md={3}>
              <Label className='mr-sm-2'>Telex</Label>
            </Col>
            <Col md={3} className='negro'>
              <Input
                type='date'
                value={fechaTelex}
                onChange={(e) => setfechaTelex(e.target.value)}
              />
            </Col>

            <Col md={3}>
              <Label>{telex === 'Si' ? 'Listo' : 'Pendiente'}</Label>
            </Col>

            <Col md={3}>
              <Button
                color={telex === 'Si' ? 'primary' : 'danger'}
                onClick={() =>
                  updateStatus(
                    'telex',
                    telex === 'Si' ? 'No' : 'Si',
                    'fechaTelex',
                    fechaTelex
                  )
                }
                size='sm'
              >
                <i className='fas fa-check-circle'></i>
              </Button>
            </Col>
          </Row>
          <br />
          <Row>
            <Col md={3}>
              <Label className='mr-sm-2'>Toque de Piso</Label>
            </Col>
            <Col md={3} className='negro'>
              <Input
                type='date'
                value={fechaToquePiso}
                onChange={(e) => setfechaToquePiso(e.target.value)}
              />
            </Col>

            <Col md={3}>
              <Label>{toquePiso === 'Si' ? 'Listo' : 'Pendiente'}</Label>
            </Col>

            <Col md={3}>
              <Button
                color={toquePiso === 'Si' ? 'primary' : 'danger'}
                onClick={() =>
                  updateStatus(
                    'toquePiso',
                    toquePiso === 'Si' ? 'No' : 'Si',
                    'fechaToquePiso',
                    fechaToquePiso
                  )
                }
                size='sm'
              >
                <i className='fas fa-check-circle'></i>
              </Button>
            </Col>
          </Row>
          <br />
          <Row>
            <Col md={3}>
              <Label className='mr-sm-2'>Revalidacion</Label>
            </Col>
            <Col md={3} className='negro'>
              <Input
                type='date'
                value={fechaRevalidacion}
                onChange={(e) => setfechaRevalidacion(e.target.value)}
              />
            </Col>

            <Col md={3}>
              <Label>{revalidacion === 'Si' ? 'Listo' : 'Pendiente'}</Label>
            </Col>

            <Col md={3}>
              <Button
                color={revalidacion === 'Si' ? 'primary' : 'danger'}
                onClick={() =>
                  updateStatus(
                    'revalidacion',
                    revalidacion === 'Si' ? 'No' : 'Si',
                    'fechaRevalidacion',
                    fechaRevalidacion
                  )
                }
                size='sm'
              >
                <i className='fas fa-check-circle'></i>
              </Button>
            </Col>
          </Row>
          <br />
          <Row>
            <Col md={3}>
              <Label className='mr-sm-2'>Pedimento Pagado</Label>
            </Col>
            <Col md={3} className='negro'>
              <Input
                type='date'
                value={fechaPagoPedimento}
                onChange={(e) => setfechaPagoPedimento(e.target.value)}
              />
            </Col>

            <Col md={3}>
              <Label>{pagoPedimento === 'Si' ? 'Listo' : 'Pendiente'}</Label>
            </Col>

            <Col md={3}>
              <Button
                color={pagoPedimento === 'Si' ? 'primary' : 'danger'}
                onClick={() =>
                  updateStatus(
                    'pagoPedimento',
                    pagoPedimento === 'Si' ? 'No' : 'Si',
                    'fechaPagoPedimento',
                    fechaPagoPedimento
                  )
                }
                size='sm'
              >
                <i className='fas fa-check-circle'></i>
              </Button>
            </Col>
          </Row>
          <br />
          {/* <Row>
            <Col md={3}>
              <Label className="mr-sm-2">Documentos</Label>
            </Col>
            <Col md={3} className="negro">
              <Input
                type="date"
                value={fechaDocumentos}
                onChange={(e) => setfechaDocumentos(e.target.value)}
              />
            </Col>

            <Col md={3}>
              <Label>{documentos === "Si" ? "Listo" : "Pendiente"}</Label>
            </Col>

            <Col md={3}>
              <Button
                color={documentos === "Si" ? "primary" : "danger"}
                onClick={() =>
                  updateStatus(
                    "documentos",
                    documentos === "Si" ? "No" : "Si",
                    "fechaDocumentos",
                    fechaDocumentos
                  )
                }
                size="sm"
              >
                <i className="fas fa-check-circle"></i>
              </Button>
            </Col>
          </Row>
          <br /> */}
          <Row>
            <Col md={3}>
              <Label className='mr-sm-2'>Modulacion</Label>
            </Col>
            <Col md={3} className='negro'>
              <Input
                type='date'
                value={fechaModulacion}
                onChange={(e) => setfechaModulacion(e.target.value)}
              />
            </Col>

            <Col md={3}>
              <Label>{modulacion === 'Si' ? 'Listo' : 'Pendiente'}</Label>
            </Col>

            <Col md={3}>
              <Button
                color={modulacion === 'Si' ? 'primary' : 'danger'}
                onClick={() =>
                  updateStatus(
                    'modulacion',
                    modulacion === 'Si' ? 'No' : 'Si',
                    'fechaModulacion',
                    fechaModulacion
                  )
                }
                size='sm'
              >
                <i className='fas fa-check-circle'></i>
              </Button>
            </Col>
          </Row>
          <br />

          <Row>
            <Col md={3}>
              <Label className='mr-sm-2'>Salida de Puerto</Label>
            </Col>
            <Col md={3} className='negro'>
              <Input
                type='date'
                value={fechaSalidaPuerto}
                onChange={(e) => setfechaSalidaPuerto(e.target.value)}
              />
            </Col>

            <Col md={3}>
              <Label>{salidaPuerto === 'Si' ? 'Listo' : 'Pendiente'}</Label>
            </Col>

            <Col md={3}>
              <Button
                color={salidaPuerto === 'Si' ? 'primary' : 'danger'}
                onClick={() =>
                  updateStatus(
                    'salidaPuerto',
                    salidaPuerto === 'Si' ? 'No' : 'Si',
                    'fechaSalidaPuerto',
                    fechaSalidaPuerto
                  )
                }
                size='sm'
              >
                <i className='fas fa-check-circle'></i>
              </Button>
            </Col>
          </Row>
          <br />
          <Row>
            <Col md={3}>
              <Label className='mr-sm-2'>Salida Ruta</Label>
            </Col>
            <Col md={3} className='negro'>
              <Input
                type='date'
                value={fechaSalidaRuta}
                onChange={(e) => setfechaSalidaRuta(e.target.value)}
              />
            </Col>

            <Col md={3}>
              <Label>{salidaRuta === 'Si' ? 'Listo' : 'Pendiente'}</Label>
            </Col>

            <Col md={3}>
              <Button
                color={salidaRuta === 'Si' ? 'primary' : 'danger'}
                onClick={() =>
                  updateStatus(
                    'salidaRuta',
                    salidaRuta === 'Si' ? 'No' : 'Si',
                    'fechaSalidaRuta',
                    fechaSalidaRuta
                  )
                }
                size='sm'
              >
                <i className='fas fa-check-circle'></i>
              </Button>
            </Col>
          </Row>
          <br />

          {/* <Row>
            <Col md={3}>
              <Label className='mr-sm-2'>Maniobras</Label>
            </Col>
            <Col md={3} className='negro'>
              <Input
                type='date'
                value={fechaManiobras}
                onChange={(e) => setfechaManiobras(e.target.value)}
              />
            </Col>

            <Col md={3}>
              <Label>{maniobras === 'Si' ? 'Listo' : 'Pendiente'}</Label>
            </Col>

            <Col md={3}>
              <Button
                color={maniobras === 'Si' ? 'primary' : 'danger'}
                onClick={() =>
                  updateStatus(
                    'maniobras',
                    maniobras === 'Si' ? 'No' : 'Si',
                    'fechaManiobras',
                    fechaManiobras
                  )
                }
                size='sm'
              >
                <i className='fas fa-check-circle'></i>
              </Button>
            </Col>
          </Row> 
          <br />*/}

          {user.contenedoresEntrega?(
            <>
          <Row>
            <Col md={3}>
              <Label className='mr-sm-2'>Entrega Cliente</Label>
            </Col>
            <Col md={3} className='negro'>
              <Input
                type='date'
                value={fechaEntregaCliente}
                onChange={(e) => setfechaEntregaCliente(e.target.value)}
              />
            </Col>

            <Col md={3}>
              <Label>{entregaCliente === 'Si' ? 'Listo' : 'Pendiente'}</Label>
            </Col>

            <Col md={3}>
              <Button
                color={entregaCliente === 'Si' ? 'primary' : 'danger'}
                onClick={() =>
                  updateStatus(
                    'entregaCliente',
                    entregaCliente === 'Si' ? 'No' : 'Si',
                    'fechaEntregaCliente',
                    fechaEntregaCliente
                  )
                }
                size='sm'
              >
                <i className='fas fa-check-circle'></i>
              </Button>
            </Col>
          </Row>
          <br />
          </>
        ):undefined}
          <Row>
            <Col md={3}>
              <Label className='mr-sm-2'>Retorno Vacio</Label>
            </Col>
            <Col md={3} className='negro'>
              <Input
                type='date'
                value={fechaRetornoVacio}
                onChange={(e) => setfechaRetornoVacio(e.target.value)}
              />
            </Col>

            <Col md={3}>
              <Label>{retornoVacio === 'Si' ? 'Listo' : 'Pendiente'}</Label>
            </Col>

            <Col md={3}>
              <Button
                color={retornoVacio === 'Si' ? 'primary' : 'danger'}
                onClick={() =>
                  updateStatus(
                    'retornoVacio',
                    retornoVacio === 'Si' ? 'No' : 'Si',
                    'fechaRetornoVacio',
                    fechaRetornoVacio
                  )
                }
                size='sm'
              >
                <i className='fas fa-check-circle'></i>
              </Button>
            </Col>
          </Row>
          <br />
        </ModalBody>
      </Modal>

      <Modal size='lg' isOpen={modalGastos} toggle={toggleGastos}>
        <ModalHeader toggle={toggleGastos}>
          <h4>
            {t('Gastos')} Contenedor {numeroInterno}
          </h4>
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col md={6}>
              <Label className='mr-sm-2'>{t('Fecha')}</Label>
              <Input
                type='date'
                placeholder='Fecha'
                value={fechaGasto}
                required
                onChange={(e) => {
                  setFechaGasto(e.target.value);
                }}
              />
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <Label className='mr-sm-2'>Proveedor</Label>
              <Input
                // bsSize="sm"
                type='select'
                required
                value={selectedProveedor}
                onChange={(e) => setSelectedProveedor(e.target.value)}
              >
                <option value='0'>{t('Selecciona')}</option>
                {proveedores
                  .sort((a, b) => (a.name > b.name ? 1 : -1))
                  .map((a) => {
                    return <option value={a._id}>{a.name}</option>;
                  })}
              </Input>
            </Col>

            <Col md={6}>
              <Label className='mr-sm-2'>{t('Cliente')}</Label>
              <Input
                // bsSize="sm"
                type='select'
                required
                value={selectedClienteGasto}
                disabled
              >
                <option value='0'>{t('Selecciona')}</option>
                {clientes
                  .sort((a, b) =>
                    a.nombre_comercial > b.nombre_comercial ? 1 : -1
                  )
                  .map((a) => {
                    return <option value={a._id}>{a.nombre_comercial}</option>;
                  })}
              </Input>
            </Col>
          </Row>

          <Row>
            <Col md={6}>
              <Label className='mr-sm-2'>{t('Concepto')}</Label>
              <Input
                // bsSize="sm"
                type='select'
                required
                value={selectedConcepto}
                onChange={(e) => setSelectedConcepto(e.target.value)}
              >
                <option value='0'>{t('Selecciona')}</option>
                {conceptosGastos
                  .sort((a, b) => (a.name > b.name ? 1 : -1))
                  .map((a) => {
                    return <option value={a._id}>{a.name}</option>;
                  })}
              </Input>
            </Col>

            <Col md={6}>
              <Label for='exampleEmail' className='mr-sm-2'>
                {t('Descripcion')}
              </Label>
              <Input
                type='text'
                placeholder='Descripcion'
                value={descripcion}
                required
                onChange={(e) => {
                  setDescripcion(e.target.value);
                }}
              />
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <Label className='mr-sm-2'>{t('Moneda')}</Label>
              <Input
                // bsSize="sm"
                type='select'
                required
                value={moneda}
                onChange={(e) => {
                  setMoneda(e.target.value);
                  setTotalUSD(0);
                  setTotal(0);
                  setTipoCambio(1);
                }}
              >
                <option value='MXN'>{t('MXN')}</option>
                <option value='USD'>{t('USD')}</option>
              </Input>
            </Col>
          </Row>
          {moneda === 'USD' ? (
            <Row>
              <Col sm={4}>
                <Label for='exampleEmail' className='mr-sm-2'>
                  {t('Total USD')}
                </Label>
                <Input
                  type='number'
                  min='0'
                  step='any'
                  placeholder='TotalUSD'
                  value={totalUSD}
                  required
                  onChange={(e) => calcula(e.target.value)}
                />
              </Col>
              <Col sm={4}>
                <Label for='exampleEmail' className='mr-sm-2'>
                  Tipo de Cambio
                </Label>
                <Input
                  type='number'
                  min='0'
                  step='any'
                  placeholder='TipoCambio'
                  value={tipoCambio}
                  required
                  onChange={(e) => calculaTipoCambio(e.target.value)}
                />
              </Col>
              <Col sm={4}>
                <Label for='exampleEmail' className='mr-sm-2'>
                  {t('Total MXN')}
                </Label>
                <Input
                  type='number'
                  min='0'
                  step='any'
                  value={total}
                  disabled
                  // onChange={(e) => calculaMXN(e.target.value)}
                />
              </Col>
            </Row>
          ) : (
            <Row>
              <Col sm={4}>
                <Label for='exampleEmail' className='mr-sm-2'>
                  {t('Total MXN')}
                </Label>
                <Input
                  type='number'
                  min='0'
                  step='any'
                  value={total}
                  onChange={(e) => {
                    setTotal(e.target.value);
                    setTotalUSD(e.target.value / tipoCambio);
                  }}
                />
              </Col>
            </Row>
          )}
          <br />
          {validaBoton ? (
            <Button color='success' onClick={() => saveGasto()}>
              Guardar
            </Button>
          ) : (
            <Button color='success' disabled>
              Guardar
            </Button>
          )}
        </ModalBody>
      </Modal>

      <Modal size='lg' isOpen={modalCargos} toggle={toggleCargos}>
        <ModalHeader toggle={toggleCargos}>
          <h4>
            {t('Cargos')} Contenedor {numeroInterno}
          </h4>
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col md={6}>
              <Label className='mr-sm-2'>{t('Fecha')}</Label>
              <Input
                type='date'
                placeholder='Fecha'
                value={fechaGasto}
                required
                onChange={(e) => {
                  setFechaGasto(e.target.value);
                }}
              />
            </Col>

            <Col md={6}>
              <Label className='mr-sm-2'>{t('Cliente')}</Label>
              <Input
                // bsSize="sm"
                type='select'
                required
                value={selectedClienteGasto}
                disabled
              >
                <option value='0'>{t('Selecciona')}</option>
                {clientes
                  .sort((a, b) =>
                    a.nombre_comercial > b.nombre_comercial ? 1 : -1
                  )
                  .map((a) => {
                    return <option value={a._id}>{a.nombre_comercial}</option>;
                  })}
              </Input>
            </Col>
          </Row>

          <Row>
            <Col md={6}>
              <Label className='mr-sm-2'>{t('Concepto')}</Label>
              <Input
                // bsSize="sm"
                type='select'
                required
                value={selectedConcepto}
                onChange={(e) => setSelectedConcepto(e.target.value)}
              >
                <option value='0'>{t('Selecciona')}</option>
                {conceptosGastos
                  .sort((a, b) => (a.name > b.name ? 1 : -1))
                  .map((a) => {
                    return <option value={a._id}>{a.name}</option>;
                  })}
              </Input>
            </Col>

            <Col md={6}>
              <Label for='exampleEmail' className='mr-sm-2'>
                {t('Descripcion')}
              </Label>
              <Input
                type='text'
                placeholder='Descripcion'
                value={descripcion}
                required
                onChange={(e) => {
                  setDescripcion(e.target.value);
                }}
              />
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <Label className='mr-sm-2'>{t('Moneda')}</Label>
              <Input
                // bsSize="sm"
                type='select'
                required
                value={moneda}
                onChange={(e) => {
                  setMoneda(e.target.value);
                  setTotalUSD(0);
                  setTotal(0);
                  setTipoCambio(1);
                }}
              >
                <option value='MXN'>{t('MXN')}</option>
                <option value='USD'>{t('USD')}</option>
              </Input>
            </Col>
          </Row>
          {moneda === 'USD' ? (
            <Row>
              <Col sm={4}>
                <Label for='exampleEmail' className='mr-sm-2'>
                  {t('Total USD')}
                </Label>
                <Input
                  type='number'
                  min='0'
                  step='any'
                  placeholder='TotalUSD'
                  value={totalUSD}
                  required
                  onChange={(e) => calcula(e.target.value)}
                />
              </Col>
              <Col sm={4}>
                <Label for='exampleEmail' className='mr-sm-2'>
                  Tipo de Cambio
                </Label>
                <Input
                  type='number'
                  min='0'
                  step='any'
                  placeholder='TipoCambio'
                  value={tipoCambio}
                  required
                  onChange={(e) => calculaTipoCambio(e.target.value)}
                />
              </Col>
              <Col sm={4}>
                <Label for='exampleEmail' className='mr-sm-2'>
                  {t('Total MXN')}
                </Label>
                <Input
                  type='number'
                  min='0'
                  step='any'
                  value={total}
                  disabled
                  // onChange={(e) => calculaMXN(e.target.value)}
                />
              </Col>
            </Row>
          ) : (
            <Row>
              <Col sm={4}>
                <Label for='exampleEmail' className='mr-sm-2'>
                  {t('Total MXN')}
                </Label>
                <Input
                  type='number'
                  min='0'
                  step='any'
                  value={total}
                  onChange={(e) => {
                    setTotal(e.target.value);
                    setTotalUSD(e.target.value / tipoCambio);
                  }}
                />
              </Col>
            </Row>
          )}
          <br />
          {validaBoton ? (
            <Button color='success' onClick={() => saveCargo()}>
              Guardar
            </Button>
          ) : (
            <Button color='success' disabled>
              Guardar
            </Button>
          )}
        </ModalBody>
      </Modal>

      <Modal size='sm' isOpen={modalETA} toggle={toggleETA}>
        <ModalHeader toggle={toggleETA}>
          <h4>{t('Actualizar ETAs')}</h4>
        </ModalHeader>
        <ModalBody>
          <EtaUpdate />
        </ModalBody>
      </Modal>

      <Modal size="sm" isOpen={modalSubirFotoPacking} toggle={toggleSubirFotoPacking}>
        <ModalHeader toggle={toggleSubirFotoPacking}>
          <h4>Subir Fotos</h4>
        </ModalHeader>
        <ModalBody>
        <Row>
                  <Col md={12}>
              <Label>
                Selecciona los Archivos
              </Label>
              <Input
                type="file"
                multiple
                onChange={(e) => {
                  setFile(Array.from(e.target.files));
                  // setFile(e.target.files[0]);
                }}
              />
            </Col>
                  </Row>
          <Button size="sm" color="success" onClick={guardaFotosPacking}>
            Guardar
          </Button>
        </ModalBody>
      </Modal>
      <Modal size="sm" isOpen={modalSubirFotoBL} toggle={toggleSubirFotoBL}>
        <ModalHeader toggle={toggleSubirFotoBL}>
          <h4>Subir Fotos</h4>
        </ModalHeader>
        <ModalBody>
        <Row>
                  <Col md={12}>
              <Label>
                Selecciona los Archivos
              </Label>
              <Input
                type="file"
                multiple
                onChange={(e) => {
                  setFile(Array.from(e.target.files));
                  // setFile(e.target.files[0]);
                }}
              />
            </Col>
                  </Row>
          <Button size="sm" color="success" onClick={guardaFotosBL}>
            Guardar
          </Button>
        </ModalBody>
      </Modal>

      <Modal size="sm" isOpen={modalSubirFotoInvoice} toggle={toggleSubirFotoInvoice}>
        <ModalHeader toggle={toggleSubirFotoInvoice}>
          <h4>Subir Fotos</h4>
        </ModalHeader>
        <ModalBody>
        <Row>
                  <Col md={12}>
              <Label>
                Selecciona los Archivos
              </Label>
              <Input
                type="file"
                multiple
                onChange={(e) => {
                  setFile(Array.from(e.target.files));
                  // setFile(e.target.files[0]);
                }}
              />
            </Col>
                  </Row>
          <Button size="sm" color="success" onClick={guardaFotosInvoice}>
            Guardar
          </Button>
        </ModalBody>
      </Modal>
      <Modal size="sm" isOpen={modalSubirFotoFichaTecnica} toggle={toggleSubirFotoFichaTecnica}>
        <ModalHeader toggle={toggleSubirFotoFichaTecnica}>
          <h4>Subir Fotos</h4>
        </ModalHeader>
        <ModalBody>
        <Row>
                  <Col md={12}>
              <Label>
                Selecciona los Archivos
              </Label>
              <Input
                type="file"
                multiple
                onChange={(e) => {
                  setFile(Array.from(e.target.files));
                  // setFile(e.target.files[0]);
                }}
              />
            </Col>
                  </Row>
          <Button size="sm" color="success" onClick={guardaFotosFichaTecnica}>
            Guardar
          </Button>
        </ModalBody>
      </Modal>

      <Modal size="sm" isOpen={modalSubirFotoCargosLocales} toggle={toggleSubirFotoCargosLocales}>
        <ModalHeader toggle={toggleSubirFotoCargosLocales}>
          <h4>Subir Fotos</h4>
        </ModalHeader>
        <ModalBody>
        <Row>
                  <Col md={12}>
              <Label>
                Selecciona los Archivos
              </Label>
              <Input
                type="file"
                multiple
                onChange={(e) => {
                  setFile(Array.from(e.target.files));
                  // setFile(e.target.files[0]);
                }}
              />
            </Col>
                  </Row>
          <Button size="sm" color="success" onClick={guardaFotosCargosLocales}>
            Guardar
          </Button>
        </ModalBody>
      </Modal>

      <Modal size="sm" isOpen={modalSubirFotoDODA} toggle={toggleSubirFotoDODA}>
        <ModalHeader toggle={toggleSubirFotoDODA}>
          <h4>Subir Fotos</h4>
        </ModalHeader>
        <ModalBody>
        <Row>
                  <Col md={12}>
              <Label>
                Selecciona los Archivos
              </Label>
              <Input
                type="file"
                multiple
                onChange={(e) => {
                  setFile(Array.from(e.target.files));
                  // setFile(e.target.files[0]);
                }}
              />
            </Col>
                  </Row>
          <Button size="sm" color="success" onClick={guardaFotosDODA}>
            Guardar
          </Button>
        </ModalBody>
      </Modal>

      <Modal size="sm" isOpen={modalSubirFotoBoleta} toggle={toggleSubirFotoBoleta}>
        <ModalHeader toggle={toggleSubirFotoBoleta}>
          <h4>Subir Fotos</h4>
        </ModalHeader>
        <ModalBody>
        <Row>
                  <Col md={12}>
              <Label>
                Selecciona los Archivos
              </Label>
              <Input
                type="file"
                multiple
                onChange={(e) => {
                  setFile(Array.from(e.target.files));
                  // setFile(e.target.files[0]);
                }}
              />
            </Col>
                  </Row>
          <Button size="sm" color="success" onClick={guardaFotosBoleta}>
            Guardar
          </Button>
        </ModalBody>
      </Modal>

      <Modal size="sm" isOpen={modalSubirFotoPrealta} toggle={toggleSubirFotoPrealta}>
        <ModalHeader toggle={toggleSubirFotoPrealta}>
          <h4>Subir Fotos</h4>
        </ModalHeader>
        <ModalBody>
        <Row>
                  <Col md={12}>
              <Label>
                Selecciona los Archivos
              </Label>
              <Input
                type="file"
                multiple
                onChange={(e) => {
                  setFile(Array.from(e.target.files));
                  // setFile(e.target.files[0]);
                }}
              />
            </Col>
                  </Row>
          <Button size="sm" color="success" onClick={guardaFotosPrealta}>
            Guardar
          </Button>
        </ModalBody>
      </Modal>

      <Modal size="sm" isOpen={modalSubirFotoEIR} toggle={toggleSubirFotoEIR}>
        <ModalHeader toggle={toggleSubirFotoEIR}>
          <h4>Subir Fotos</h4>
        </ModalHeader>
        <ModalBody>
        <Row>
                  <Col md={12}>
              <Label>
                Selecciona los Archivos
              </Label>
              <Input
                type="file"
                multiple
                onChange={(e) => {
                  setFile(Array.from(e.target.files));
                  // setFile(e.target.files[0]);
                }}
              />
            </Col>
                  </Row>
          <Button size="sm" color="success" onClick={guardaFotosEIR}>
            Guardar
          </Button>
        </ModalBody>
      </Modal>

      <Modal size="sm" isOpen={modalSubirFotoValidacion} toggle={toggleSubirFotoValidacion}>
        <ModalHeader toggle={toggleSubirFotoValidacion}>
          <h4>Subir Fotos</h4>
        </ModalHeader>
        <ModalBody>
        <Row>
                  <Col md={12}>
              <Label>
                Selecciona los Archivos
              </Label>
              <Input
                type="file"
                multiple
                onChange={(e) => {
                  setFile(Array.from(e.target.files));
                  // setFile(e.target.files[0]);
                }}
              />
            </Col>
                  </Row>
          <Button size="sm" color="success" onClick={guardaFotosValidacion}>
            Guardar
          </Button>
        </ModalBody>
      </Modal>

      <Modal size="sm" isOpen={modalSubirFotoGarantia} toggle={toggleSubirFotoGarantia}>
        <ModalHeader toggle={toggleSubirFotoGarantia}>
          <h4>Subir Fotos</h4>
        </ModalHeader>
        <ModalBody>
        <Row>
                  <Col md={12}>
              <Label>
                Selecciona los Archivos
              </Label>
              <Input
                type="file"
                multiple
                onChange={(e) => {
                  setFile(Array.from(e.target.files));
                  // setFile(e.target.files[0]);
                }}
              />
            </Col>
                  </Row>
          <Button size="sm" color="success" onClick={guardaFotosGarantia}>
            Guardar
          </Button>
        </ModalBody>
      </Modal>
      <Modal size="sm" isOpen={modalSubirFotoTransporte} toggle={toggleSubirFotoTransporte}>
        <ModalHeader toggle={toggleSubirFotoTransporte}>
          <h4>Subir Fotos</h4>
        </ModalHeader>
        <ModalBody>
        <Row>
                  <Col md={12}>
              <Label>
                Selecciona los Archivos
              </Label>
              <Input
                type="file"
                multiple
                onChange={(e) => {
                  setFile(Array.from(e.target.files));
                  // setFile(e.target.files[0]);
                }}
              />
            </Col>
                  </Row>
          <Button size="sm" color="success" onClick={guardaFotosTransporte}>
            Guardar
          </Button>
        </ModalBody>
      </Modal>

          
    <Modal size="xxl" isOpen={modalFotoPacking} toggle={toggleFotoPacking}>
      <ModalHeader toggle={toggleFotoPacking}>
        <h4>Packing List</h4>
      </ModalHeader>
      <ModalBody>
      <Row>
      {photo.length > 0 ? (
        photo.map((item) => (
          <div key={item.id} style={{ textAlign: "center", marginBottom: "20px" }}>
            {item.format === "pdf" ? (
              <embed
                src={item.secure_url}
                type="application/pdf"
                width="500"
                height="600"
              />
            ) : item.format === "xls" || item.format === "xlsx" || item.format === "xlsm" ? (
              <a href={item.secure_url} download>
                <Button color="primary">
                  Descargar {item.original_filename}. {item.format}
                </Button>
              </a>
              ) : item.format === "doc" || item.format === "docx" ? (
                <a href={item.secure_url} download>
                  <Button color="primary">
                    Descargar {item.original_filename}.{item.format}
                  </Button>
                </a>
            ) : (
              <img
                src={item.secure_url}
                alt="Uploaded Image"
                width="250"
                height="auto"
              />
            )}
            <div>
              <Button
                color="danger"
                onClick={() => borrarFoto(item.asset_id)}
                style={{ marginTop: "10px" }}
              >
                Eliminar
              </Button>
            </div>
          </div>
        ))
      ) : (
        <h4>No se ha subido una Foto, PDF o archivo Excel....</h4>
      )}
    </Row>
      </ModalBody>
    </Modal>

    <Modal size="xxl" isOpen={modalFotoBL} toggle={toggleFotoBL}>
      <ModalHeader toggle={toggleFotoBL}>
        <h4>BL</h4>
      </ModalHeader>
      <ModalBody>
      <Row>
      {photo.length > 0 ? (
        photo.map((item) => (
          <div key={item.id} style={{ textAlign: "center", marginBottom: "20px" }}>
            {item.format === "pdf" ? (
              <embed
                src={item.secure_url}
                type="application/pdf"
                width="500"
                height="600"
              />
            ) : item.format === "xls" || item.format === "xlsx" || item.format === "xlsm" ? (
              <a href={item.secure_url} download>
                <Button color="primary">
                  Descargar {item.original_filename}. {item.format}
                </Button>
              </a>
              ) : item.format === "doc" || item.format === "docx" ? (
                <a href={item.secure_url} download>
                  <Button color="primary">
                    Descargar {item.original_filename}.{item.format}
                  </Button>
                </a>
            ) : (
              <img
                src={item.secure_url}
                alt="Uploaded Image"
                width="250"
                height="auto"
              />
            )}
            <div>
              <Button
                color="danger"
                onClick={() => borrarFoto(item.asset_id)}
                style={{ marginTop: "10px" }}
              >
                Eliminar
              </Button>
            </div>
          </div>
        ))
      ) : (
        <h4>No se ha subido una Foto, PDF o archivo Excel....</h4>
      )}
    </Row>
      </ModalBody>
    </Modal>
        
    <Modal size="xxl" isOpen={modalFotoInvoice} toggle={toggleFotoInvoice}>
      <ModalHeader toggle={toggleFotoInvoice}>
        <h4>Invoice</h4>
      </ModalHeader>
      <ModalBody>
      <Row>
      {photo.length > 0 ? (
        photo.map((item) => (
          <div key={item.id} style={{ textAlign: "center", marginBottom: "20px" }}>
            {item.format === "pdf" ? (
              <embed
                src={item.secure_url}
                type="application/pdf"
                width="500"
                height="600"
              />
            ) : item.format === "xls" || item.format === "xlsx" || item.format === "xlsm" ? (
              <a href={item.secure_url} download>
                <Button color="primary">
                  Descargar {item.original_filename}. {item.format}
                </Button>
              </a>
              ) : item.format === "doc" || item.format === "docx" ? (
                <a href={item.secure_url} download>
                  <Button color="primary">
                    Descargar {item.original_filename}.{item.format}
                  </Button>
                </a>
            ) : (
              <img
                src={item.secure_url}
                alt="Uploaded Image"
                width="250"
                height="auto"
              />
            )}
            <div>
              <Button
                color="danger"
                onClick={() => borrarFoto(item.asset_id)}
                style={{ marginTop: "10px" }}
              >
                Eliminar
              </Button>
            </div>
          </div>
        ))
      ) : (
        <h4>No se ha subido una Foto, PDF o archivo Excel....</h4>
      )}
    </Row>
      </ModalBody>
    </Modal>

    <Modal size="xxl" isOpen={modalFotoFichaTecnica} toggle={toggleFotoFichaTecnica}>
      <ModalHeader toggle={toggleFotoFichaTecnica}>
        <h4>Ficha Tecnica</h4>
      </ModalHeader>
      <ModalBody>
      <Row>
      {photo.length > 0 ? (
        photo.map((item) => (
          <div key={item.id} style={{ textAlign: "center", marginBottom: "20px" }}>
            {item.format === "pdf" ? (
              <embed
                src={item.secure_url}
                type="application/pdf"
                width="500"
                height="600"
              />
            ) : item.format === "xls" || item.format === "xlsx" || item.format === "xlsm" ? (
              <a href={item.secure_url} download>
                <Button color="primary">
                  Descargar {item.original_filename}. {item.format}
                </Button>
              </a>
              ) : item.format === "doc" || item.format === "docx" ? (
                <a href={item.secure_url} download>
                  <Button color="primary">
                    Descargar {item.original_filename}.{item.format}
                  </Button>
                </a>
            ) : (
              <img
                src={item.secure_url}
                alt="Uploaded Image"
                width="250"
                height="auto"
              />
            )}
            <div>
              <Button
                color="danger"
                onClick={() => borrarFoto(item.asset_id)}
                style={{ marginTop: "10px" }}
              >
                Eliminar
              </Button>
            </div>
          </div>
        ))
      ) : (
        <h4>No se ha subido una Foto, PDF o archivo Excel....</h4>
      )}
    </Row>
      </ModalBody>
    </Modal>

    <Modal size="xxl" isOpen={modalFotoCargosLocales} toggle={toggleFotoCargosLocales}>
      <ModalHeader toggle={toggleFotoCargosLocales}>
        <h4>Cargos Locales</h4>
      </ModalHeader>
      <ModalBody>
      <Row>
      {photo.length > 0 ? (
        photo.map((item) => (
          <div key={item.id} style={{ textAlign: "center", marginBottom: "20px" }}>
            {item.format === "pdf" ? (
              <embed
                src={item.secure_url}
                type="application/pdf"
                width="500"
                height="600"
              />
            ) : item.format === "xls" || item.format === "xlsx" || item.format === "xlsm" ? (
              <a href={item.secure_url} download>
                <Button color="primary">
                  Descargar {item.original_filename}. {item.format}
                </Button>
              </a>
               ) : item.format === "doc" || item.format === "docx" ? (
                <a href={item.secure_url} download>
                  <Button color="primary">
                    Descargar {item.original_filename}.{item.format}
                  </Button>
                </a>
            ) : (
              <img
                src={item.secure_url}
                alt="Uploaded Image"
                width="250"
                height="auto"
              />
            )}
            <div>
              <Button
                color="danger"
                onClick={() => borrarFoto(item.asset_id)}
                style={{ marginTop: "10px" }}
              >
                Eliminar
              </Button>
            </div>
          </div>
        ))
      ) : (
        <h4>No se ha subido una Foto, PDF o archivo Excel....</h4>
      )}
    </Row>
      </ModalBody>
    </Modal>

    <Modal size="xxl" isOpen={modalFotoDODA} toggle={toggleFotoDODA}>
      <ModalHeader toggle={toggleFotoDODA}>
        <h4>DODA</h4>
      </ModalHeader>
      <ModalBody>
      <Row>
      {photo.length > 0 ? (
        photo.map((item) => (
          <div key={item.id} style={{ textAlign: "center", marginBottom: "20px" }}>
            {item.format === "pdf" ? (
              <embed
                src={item.secure_url}
                type="application/pdf"
                width="500"
                height="600"
              />
            ) : item.format === "xls" || item.format === "xlsx" || item.format === "xlsm" ? (
              <a href={item.secure_url} download>
                <Button color="primary">
                  Descargar {item.original_filename}. {item.format}
                </Button>
              </a>
              ) : item.format === "doc" || item.format === "docx" ? (
                <a href={item.secure_url} download>
                  <Button color="primary">
                    Descargar {item.original_filename}.{item.format}
                  </Button>
                </a>
            ) : (
              <img
                src={item.secure_url}
                alt="Uploaded Image"
                width="250"
                height="auto"
              />
            )}
            <div>
              <Button
                color="danger"
                onClick={() => borrarFoto(item.asset_id)}
                style={{ marginTop: "10px" }}
              >
                Eliminar
              </Button>
            </div>
          </div>
        ))
      ) : (
        <h4>No se ha subido una Foto, PDF o archivo Excel....</h4>
      )}
    </Row>
      </ModalBody>
    </Modal>

    <Modal size="xxl" isOpen={modalFotoBoleta} toggle={toggleFotoBoleta}>
      <ModalHeader toggle={toggleFotoBoleta}>
        <h4>Boleta</h4>
      </ModalHeader>
      <ModalBody>
      <Row>
      {photo.length > 0 ? (
        photo.map((item) => (
          <div key={item.id} style={{ textAlign: "center", marginBottom: "20px" }}>
            {item.format === "pdf" ? (
              <embed
                src={item.secure_url}
                type="application/pdf"
                width="500"
                height="600"
              />
            ) : item.format === "xls" || item.format === "xlsx" || item.format === "xlsm" ? (
              <a href={item.secure_url} download>
                <Button color="primary">
                  Descargar {item.original_filename}. {item.format}
                </Button>
              </a>
              ) : item.format === "doc" || item.format === "docx" ? (
                <a href={item.secure_url} download>
                  <Button color="primary">
                    Descargar {item.original_filename}.{item.format}
                  </Button>
                </a>
            ) : (
              <img
                src={item.secure_url}
                alt="Uploaded Image"
                width="250"
                height="auto"
              />
            )}
            <div>
              <Button
                color="danger"
                onClick={() => borrarFoto(item.asset_id)}
                style={{ marginTop: "10px" }}
              >
                Eliminar
              </Button>
            </div>
          </div>
        ))
      ) : (
        <h4>No se ha subido una Foto, PDF o archivo Excel....</h4>
      )}
    </Row>
      </ModalBody>
    </Modal>

    <Modal size="xxl" isOpen={modalFotoPrealta} toggle={toggleFotoPrealta}>
      <ModalHeader toggle={toggleFotoPrealta}>
        <h4>Prealta</h4>
      </ModalHeader>
      <ModalBody>
      <Row>
      {photo.length > 0 ? (
        photo.map((item) => (
          <div key={item.id} style={{ textAlign: "center", marginBottom: "20px" }}>
            {item.format === "pdf" ? (
              <embed
                src={item.secure_url}
                type="application/pdf"
                width="500"
                height="600"
              />
            ) : item.format === "xls" || item.format === "xlsx" || item.format === "xlsm" ? (
              <a href={item.secure_url} download>
                <Button color="primary">
                  Descargar {item.original_filename}. {item.format}
                </Button>
              </a>
              ) : item.format === "doc" || item.format === "docx" ? (
                <a href={item.secure_url} download>
                  <Button color="primary">
                    Descargar {item.original_filename}.{item.format}
                  </Button>
                </a>
            ) : (
              <img
                src={item.secure_url}
                alt="Uploaded Image"
                width="250"
                height="auto"
              />
            )}
            <div>
              <Button
                color="danger"
                onClick={() => borrarFoto(item.asset_id)}
                style={{ marginTop: "10px" }}
              >
                Eliminar
              </Button>
            </div>
          </div>
        ))
      ) : (
        <h4>No se ha subido una Foto, PDF o archivo Excel....</h4>
      )}
    </Row>
      </ModalBody>
    </Modal>

    <Modal size="xxl" isOpen={modalFotoEIR} toggle={toggleFotoEIR}>
      <ModalHeader toggle={toggleFotoEIR}>
        <h4>EIR</h4>
      </ModalHeader>
      <ModalBody>
      <Row>
      {photo.length > 0 ? (
        photo.map((item) => (
          <div key={item.id} style={{ textAlign: "center", marginBottom: "20px" }}>
            {item.format === "pdf" ? (
              <embed
                src={item.secure_url}
                type="application/pdf"
                width="500"
                height="600"
              />
            ) : item.format === "xls" || item.format === "xlsx" || item.format === "xlsm" ? (
              <a href={item.secure_url} download>
                <Button color="primary">
                  Descargar {item.original_filename}. {item.format}
                </Button>
              </a>
              ) : item.format === "doc" || item.format === "docx" ? (
                <a href={item.secure_url} download>
                  <Button color="primary">
                    Descargar {item.original_filename}.{item.format}
                  </Button>
                </a>
            ) : (
              <img
                src={item.secure_url}
                alt="Uploaded Image"
                width="250"
                height="auto"
              />
            )}
            <div>
              <Button
                color="danger"
                onClick={() => borrarFoto(item.asset_id)}
                style={{ marginTop: "10px" }}
              >
                Eliminar
              </Button>
            </div>
          </div>
        ))
      ) : (
        <h4>No se ha subido una Foto, PDF o archivo Excel....</h4>
      )}
    </Row>
      </ModalBody>
    </Modal>

    <Modal size="xxl" isOpen={modalFotoValidacion} toggle={toggleFotoValidacion}>
      <ModalHeader toggle={toggleFotoValidacion}>
        <h4>Validacion</h4>
      </ModalHeader>
      <ModalBody>
      <Row>
      {photo.length > 0 ? (
        photo.map((item) => (
          <div key={item.id} style={{ textAlign: "center", marginBottom: "20px" }}>
            {item.format === "pdf" ? (
              <embed
                src={item.secure_url}
                type="application/pdf"
                width="500"
                height="600"
              />
            ) : item.format === "xls" || item.format === "xlsx" || item.format === "xlsm" ? (
              <a href={item.secure_url} download>
                <Button color="primary">
                  Descargar {item.original_filename}. {item.format}
                </Button>
              </a>
              ) : item.format === "doc" || item.format === "docx" ? (
                <a href={item.secure_url} download>
                  <Button color="primary">
                    Descargar {item.original_filename}.{item.format}
                  </Button>
                </a>
            ) : (
              <img
                src={item.secure_url}
                alt="Uploaded Image"
                width="250"
                height="auto"
              />
            )}
            <div>
              <Button
                color="danger"
                onClick={() => borrarFoto(item.asset_id)}
                style={{ marginTop: "10px" }}
              >
                Eliminar
              </Button>
            </div>
          </div>
        ))
      ) : (
        <h4>No se ha subido una Foto, PDF o archivo Excel....</h4>
      )}
    </Row>
      </ModalBody>
    </Modal>

    <Modal size="xxl" isOpen={modalFotoGarantia} toggle={toggleFotoGarantia}>
      <ModalHeader toggle={toggleFotoGarantia}>
        <h4>Garantia</h4>
      </ModalHeader>
      <ModalBody>
      <Row>
      {photo.length > 0 ? (
        photo.map((item) => (
          <div key={item.id} style={{ textAlign: "center", marginBottom: "20px" }}>
            {item.format === "pdf" ? (
              <embed
                src={item.secure_url}
                type="application/pdf"
                width="500"
                height="600"
              />
            ) : item.format === "xls" || item.format === "xlsx" || item.format === "xlsm" ? (
              <a href={item.secure_url} download>
                <Button color="primary">
                  Descargar {item.original_filename}. {item.format}
                </Button>
              </a>
              ) : item.format === "doc" || item.format === "docx" ? (
                <a href={item.secure_url} download>
                  <Button color="primary">
                    Descargar {item.original_filename}.{item.format}
                  </Button>
                </a>
            ) : (
              <img
                src={item.secure_url}
                alt="Uploaded Image"
                width="250"
                height="auto"
              />
            )}
            <div>
              <Button
                color="danger"
                onClick={() => borrarFoto(item.asset_id)}
                style={{ marginTop: "10px" }}
              >
                Eliminar
              </Button>
            </div>
          </div>
        ))
      ) : (
        <h4>No se ha subido una Foto, PDF o archivo Excel....</h4>
      )}
    </Row>
      </ModalBody>
    </Modal>

    <Modal size="xxl" isOpen={modalFotoTransporte} toggle={toggleFotoTransporte}>
      <ModalHeader toggle={toggleFotoTransporte}>
        <h4>Transporte</h4>
      </ModalHeader>
      <ModalBody>
      <Row>
      {photo.length > 0 ? (
        photo.map((item) => (
          <div key={item.id} style={{ textAlign: "center", marginBottom: "20px" }}>
            {item.format === "pdf" ? (
              <embed
                src={item.secure_url}
                type="application/pdf"
                width="500"
                height="600"
              />
            ) : item.format === "xls" || item.format === "xlsx" || item.format === "xlsm" ? (
              <a href={item.secure_url} download>
                <Button color="primary">
                  Descargar {item.original_filename}. {item.format}
                </Button>
              </a>
              ) : item.format === "doc" || item.format === "docx" ? (
                <a href={item.secure_url} download>
                  <Button color="primary">
                    Descargar {item.original_filename}.{item.format}
                  </Button>
                </a>
            ) : (
              <img
                src={item.secure_url}
                alt="Uploaded Image"
                width="250"
                height="auto"
              />
            )}
            <div>
              <Button
                color="danger"
                onClick={() => borrarFoto(item.asset_id)}
                style={{ marginTop: "10px" }}
              >
                Eliminar
              </Button>
            </div>
          </div>
        ))
      ) : (
        <h4>No se ha subido una Foto, PDF o archivo Excel....</h4>
      )}
    </Row>
      </ModalBody>
    </Modal>



    <Modal size="sm" isOpen={modalFotos} toggle={toggleFotos}>
      <ModalHeader toggle={toggleFotos}>
        <h4>Archivos</h4>
      </ModalHeader>
      <ModalBody>
        <Table>
          <thead>
            <tr>
              <th>Titulo</th>
              <th>Archivos</th>
            </tr>
            </thead>
            <tbody>
                <tr>
                  <td>Packing</td>
                  <td>
                            <>
                              {packing == "Si" ? (
                                <>
                                {/* {packing} */}
                                <Button
                                  color="info"
                                  id="Editar"
                                  size="sm"
                                  onClick={(e) => jalaFotoPacking(idContenedor)}
                                >
                                  <i class="fas fa-camera"></i>
                                </Button>
                                </>
                              ) : (
                                <>
                                {/* {a.packing} */}
                                <Button
                                  color="info"
                                  id="Editar"
                                  size="sm"
                                  disabled
                                >
                                  <i class="fas fa-camera"></i>
                                </Button>
                                </>
                              )}
                              {user.contenedoresCreate ? (
                                <Button
                                  color="success"
                                  id="Editar"
                                  size="sm"
                                  onClick={(e) => {
                                    setIdContenedor(idContenedor);
                                    // setIdControlCalidad(idControlCalidad)
                                    toggleSubirFotoPacking();
                                  }}
                                >
                                  <i class="fas fa-upload"></i>
                                </Button>
                              ) : (
                                <Button
                                  color="success"
                                  id="Editar"
                                  size="sm"
                                  disabled
                                >
                                  <i class="fas fa-upload"></i>
                                </Button>
                              )}
                            </>
                          </td>
                </tr>
                <tr>
                  <td>Ficha Tecnica</td>
                  <td>
                            <>
                              {fichaTecnicaArchivo == "Si" ? (
                                <>
                                {/* {fichaTencnica} */}
                                <Button
                                  color="info"
                                  id="Editar"
                                  size="sm"
                                  onClick={(e) => jalaFotoFichaTecnica(idContenedor)}
                                >
                                  <i class="fas fa-camera"></i>
                                </Button>
                                </>
                              ) : (
                                <>
                                {/* {fichaTencnica} */}
                                <Button
                                  color="info"
                                  id="Editar"
                                  size="sm"
                                  disabled
                                >
                                  <i class="fas fa-camera"></i>
                                </Button>
                                </>
                              )}
                              {user.contenedoresCreate ? (
                                <Button
                                  color="success"
                                  id="Editar"
                                  size="sm"
                                  onClick={(e) => {
                                    setIdContenedor(idContenedor);
                                    // setIdControlCalidad(a.idControlCalidad)
                                    toggleSubirFotoFichaTecnica();
                                  }}
                                >
                                  <i class="fas fa-upload"></i>
                                </Button>
                              ) : (
                                <Button
                                  color="success"
                                  id="Editar"
                                  size="sm"
                                  disabled
                                >
                                  <i class="fas fa-upload"></i>
                                </Button>
                              )}
                            </>
                          </td>
                </tr>
                <tr>
                  <td>BL</td>
                  <td>
                            <>
                              {blArchivo == "Si" ? (
                                <>
                                {/* {bl} */}
                                <Button
                                  color="info"
                                  id="Editar"
                                  size="sm"
                                  onClick={(e) => jalaFotoBL(idContenedor)}
                                >
                                  <i class="fas fa-camera"></i>
                                </Button>
                                </>
                              ) : (
                                <>
                                {/* {bl} */}
                                <Button
                                  color="info"
                                  id="Editar"
                                  size="sm"
                                  disabled
                                >
                                  <i class="fas fa-camera"></i>
                                </Button>
                                </>
                              )}
                              {user.contenedoresCreate ? (
                                <Button
                                  color="success"
                                  id="Editar"
                                  size="sm"
                                  onClick={(e) => {
                                    setIdContenedor(idContenedor);
                                    // setIdControlCalidad(idControlCalidad)
                                    toggleSubirFotoBL();
                                  }}
                                >
                                  <i class="fas fa-upload"></i>
                                </Button>
                              ) : (
                                <Button
                                  color="success"
                                  id="Editar"
                                  size="sm"
                                  disabled
                                >
                                  <i class="fas fa-upload"></i>
                                </Button>
                              )}
                            </>
                          </td>
                </tr>
                <tr>
                  <td>Invoice</td>
                  <td>
                            <>
                              {invoice == "Si" ? (
                                <>
                                {/* {invoice} */}
                                <Button
                                  color="info"
                                  id="Editar"
                                  size="sm"
                                  onClick={(e) => jalaFotoInvoice(idContenedor)}
                                >
                                  <i class="fas fa-camera"></i>
                                </Button>
                                </>
                              ) : (
                                <>
                                {/* {invoice} */}
                                <Button
                                  color="info"
                                  id="Editar"
                                  size="sm"
                                  disabled
                                >
                                  <i class="fas fa-camera"></i>
                                </Button>
                                </>
                              )}
                              {user.contenedoresCreate ? (
                                <Button
                                  color="success"
                                  id="Editar"
                                  size="sm"
                                  onClick={(e) => {
                                    setIdContenedor(idContenedor);
                                    // setIdControlCalidad(a.idControlCalidad)
                                    toggleSubirFotoInvoice();
                                  }}
                                >
                                  <i class="fas fa-upload"></i>
                                </Button>
                              ) : (
                                <Button
                                  color="success"
                                  id="Editar"
                                  size="sm"
                                  disabled
                                >
                                  <i class="fas fa-upload"></i>
                                </Button>
                              )}
                            </>
                          </td>
                </tr>

                <tr>
                  <td>Cargos Locales</td>
                  <td>
                            <>
                              {cargosLocales == "Si" ? (
                                <>
                                {/* {cargosLocales} */}
                                <Button
                                  color="info"
                                  id="Editar"
                                  size="sm"
                                  onClick={(e) => jalaFotoCargosLocales(idContenedor)}
                                >
                                  <i class="fas fa-camera"></i>
                                </Button>
                                </>
                              ) : (
                                <>
                                {/* {cargosLocales} */}
                                <Button
                                  color="info"
                                  id="Editar"
                                  size="sm"
                                  disabled
                                >
                                  <i class="fas fa-camera"></i>
                                </Button>
                                </>
                              )}
                              {user.contenedoresCreate ? (
                                <Button
                                  color="success"
                                  id="Editar"
                                  size="sm"
                                  onClick={(e) => {
                                    setIdContenedor(idContenedor);
                                    // setIdControlCalidad(a.idControlCalidad)
                                    toggleSubirFotoCargosLocales();
                                  }}
                                >
                                  <i class="fas fa-upload"></i>
                                </Button>
                              ) : (
                                <Button
                                  color="success"
                                  id="Editar"
                                  size="sm"
                                  disabled
                                >
                                  <i class="fas fa-upload"></i>
                                </Button>
                              )}
                            </>
                          </td>
                </tr>
                <tr>
                  <td>Garantia</td>
                  <td>
                            <>
                              {garantia == "Si" ? (
                                <>
                                {/* {garantia} */}
                                <Button
                                  color="info"
                                  id="Editar"
                                  size="sm"
                                  onClick={(e) => jalaFotoGarantia(idContenedor)}
                                >
                                  <i class="fas fa-camera"></i>
                                </Button>
                                </>
                              ) : (
                                <>
                                {/* {garantia} */}
                                <Button
                                  color="info"
                                  id="Editar"
                                  size="sm"
                                  disabled
                                >
                                  <i class="fas fa-camera"></i>
                                </Button>
                                </>
                              )}
                              {user.contenedoresCreate ? (
                                <Button
                                  color="success"
                                  id="Editar"
                                  size="sm"
                                  onClick={(e) => {
                                    setIdContenedor(idContenedor);
                                    // setIdControlCalidad(a.idControlCalidad)
                                    toggleSubirFotoGarantia();
                                  }}
                                >
                                  <i class="fas fa-upload"></i>
                                </Button>
                              ) : (
                                <Button
                                  color="success"
                                  id="Editar"
                                  size="sm"
                                  disabled
                                >
                                  <i class="fas fa-upload"></i>
                                </Button>
                              )}
                            </>
                          </td>
                </tr>
                <tr>
                  <td>DODA</td>
                  <td>
                            <>
                              {DODA == "Si" ? (
                                <>
                                {/* {DODA} */}
                                <Button
                                  color="info"
                                  id="Editar"
                                  size="sm"
                                  onClick={(e) => jalaFotoDODA(idContenedor)}
                                >
                                  <i class="fas fa-camera"></i>
                                </Button>
                                </>
                              ) : (
                                <>
                                {/* {DODA} */}
                                <Button
                                  color="info"
                                  id="Editar"
                                  size="sm"
                                  disabled
                                >
                                  <i class="fas fa-camera"></i>
                                </Button>
                                </>
                              )}
                              {user.contenedoresCreate ? (
                                <Button
                                  color="success"
                                  id="Editar"
                                  size="sm"
                                  onClick={(e) => {
                                    setIdContenedor(idContenedor);
                                    // setIdControlCalidad(a.idControlCalidad)
                                    toggleSubirFotoDODA();
                                  }}
                                >
                                  <i class="fas fa-upload"></i>
                                </Button>
                              ) : (
                                <Button
                                  color="success"
                                  id="Editar"
                                  size="sm"
                                  disabled
                                >
                                  <i class="fas fa-upload"></i>
                                </Button>
                              )}
                            </>
                          </td>
                </tr>
                <tr>
                  <td>Boleta</td>
                  <td>
                            <>
                              {boleta == "Si" ? (
                                <>
                                {/* {boleta} */}
                                <Button
                                  color="info"
                                  id="Editar"
                                  size="sm"
                                  onClick={(e) => jalaFotoBoleta(idContenedor)}
                                >
                                  <i class="fas fa-camera"></i>
                                </Button>
                                </>
                              ) : (
                                <>
                                {/* {boleta} */}
                                <Button
                                  color="info"
                                  id="Editar"
                                  size="sm"
                                  disabled
                                >
                                  <i class="fas fa-camera"></i>
                                </Button>
                                </>
                              )}
                              {user.contenedoresCreate ? (
                                <Button
                                  color="success"
                                  id="Editar"
                                  size="sm"
                                  onClick={(e) => {
                                    setIdContenedor(idContenedor);
                                    // setIdControlCalidad(a.idControlCalidad)
                                    toggleSubirFotoBoleta();
                                  }}
                                >
                                  <i class="fas fa-upload"></i>
                                </Button>
                              ) : (
                                <Button
                                  color="success"
                                  id="Editar"
                                  size="sm"
                                  disabled
                                >
                                  <i class="fas fa-upload"></i>
                                </Button>
                              )}
                            </>
                          </td>
                </tr>
                <tr>
                  <td>Prealta</td>
                  <td>
                            <>
                              {prealta == "Si" ? (
                                <>
                                {/* {prealta} */}
                                <Button
                                  color="info"
                                  id="Editar"
                                  size="sm"
                                  onClick={(e) => jalaFotoPrealta(idContenedor)}
                                >
                                  <i class="fas fa-camera"></i>
                                </Button>
                                </>
                              ) : (
                                <>
                                {/* {prealta} */}
                                <Button
                                  color="info"
                                  id="Editar"
                                  size="sm"
                                  disabled
                                >
                                  <i class="fas fa-camera"></i>
                                </Button>
                                </>
                              )}
                              {user.contenedoresCreate ? (
                                <Button
                                  color="success"
                                  id="Editar"
                                  size="sm"
                                  onClick={(e) => {
                                    setIdContenedor(idContenedor);
                                    // setIdControlCalidad(a.idControlCalidad)
                                    toggleSubirFotoPrealta();
                                  }}
                                >
                                  <i class="fas fa-upload"></i>
                                </Button>
                              ) : (
                                <Button
                                  color="success"
                                  id="Editar"
                                  size="sm"
                                  disabled
                                >
                                  <i class="fas fa-upload"></i>
                                </Button>
                              )}
                            </>
                          </td>
                </tr>
                <tr>
                  <td>EIR</td>
                  <td>
                            <>
                              {EIR == "Si" ? (
                                <>
                                {/* {EIR} */}
                                <Button
                                  color="info"
                                  id="Editar"
                                  size="sm"
                                  onClick={(e) => jalaFotoEIR(idContenedor)}
                                >
                                  <i class="fas fa-camera"></i>
                                </Button>
                                </>
                              ) : (
                                <>
                                {/* {EIR} */}
                                <Button
                                  color="info"
                                  id="Editar"
                                  size="sm"
                                  disabled
                                >
                                  <i class="fas fa-camera"></i>
                                </Button>
                                </>
                              )}
                              {user.contenedoresCreate ? (
                                <Button
                                  color="success"
                                  id="Editar"
                                  size="sm"
                                  onClick={(e) => {
                                    setIdContenedor(idContenedor);
                                    // setIdControlCalidad(a.idControlCalidad)
                                    toggleSubirFotoEIR();
                                  }}
                                >
                                  <i class="fas fa-upload"></i>
                                </Button>
                              ) : (
                                <Button
                                  color="success"
                                  id="Editar"
                                  size="sm"
                                  disabled
                                >
                                  <i class="fas fa-upload"></i>
                                </Button>
                              )}
                            </>
                          </td>
                </tr>
            </tbody>
        </Table>
      </ModalBody>
    </Modal>

   <Modal size="xxl" isOpen={modalArchivo} toggle={toggleArchivo}>
        <ModalHeader toggle={toggleArchivo}>
          <h4>{t("Subir Archivo")}</h4>
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col md={10}>
              <Input
                required
                type="file"
                name="file"
                id="file"
                onChange={(event) => importarArchivo(event)}
              />
            </Col>

            <Col md={2}>
              <Badge
                color="info"
                className="w-100 text-center"
                style={{
                  fontSize: "1rem", // más grande el texto
                  padding: "1rem", // más espacio vertical y horizontal
                  minHeight: "3rem", // fuerza un alto mínimo
                  display: "flex", // centra vertical y horizontal
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                {totalContenedores} Contenedores
              </Badge>
            </Col>
          </Row>
          <br />

          <Table bordered striped>
            <thead>
              <tr>
                <th>Cliente</th>
                {/* <th>Referencia</th> */}
                {/* <th>Referencia Cliente</th> */}
                <th>Contenedor</th>
                <th>ETA</th>
                <th>Articulo</th>
                <th>Valor Factura</th>
                <th>Pedimento</th>
                <th>Modalidad</th>
                <th>Puerto</th>
                {/*<th>Direccion Entrega</th> */}
              </tr>
            </thead>
            <tbody>
              {inputFieldsContenedores
                // .filter((e) => e.referencia != "")
                .map((a) => (
                  <tr key={a.id}>
                    <td>{a.cliente}</td>
                    {/* <td>{a.referencia}</td> */}
                    {/* <td>{a.referenciaCliente}</td> */}
                    <td>{a.contenedor}</td>
                    <td>{a.fechaETA}</td>
                    <td>{a.articulo}</td>
                    <td>
                      {new Intl.NumberFormat("en-US", {
                        style: "currency",
                        currency: "USD",
                        maximumFractionDigits: 2,
                      }).format(a.valorFactura)}
                    </td>
                    <td>{a.pedimento}</td>
                    <td>{a.modalidad}</td>
                    <td>{a.puerto}</td>
                    {/* <td>{a.direccionEntrega}</td> */}
                  </tr>
                ))}
            </tbody>
          </Table>
          <br />
          <Row>
            <Col md={2}>
          {validaBoton ? (
            <Button color="success" onClick={() => saveContenedoresArchivo()}>
              Guardar
            </Button>
          ) : (
            <Button color="success" disabled>
              Guardar
            </Button>
          )}
          </Col>
          <Col md={2}>
              <Badge
                color="info"
                className="w-100 text-center"
                style={{
                  fontSize: "1rem", // más grande el texto
                  padding: "1rem", // más espacio vertical y horizontal
                  minHeight: "3rem", // fuerza un alto mínimo
                  display: "flex", // centra vertical y horizontal
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                {totalContenedores} Contenedores
              </Badge>
            </Col>
            </Row>
        </ModalBody>
      </Modal>
      {loader}
    </>
  );
}

export default ListadoContenedores;

